import { ProposalDecision, ToolName, ToolPolicy } from '../../agents/types.js';
import { BlameLogType } from '../../blamelog/index.js';
import { CaseState, CaseStatus, CaseType, SystemEndReason, } from '../../cases/index.js';
import { CaseTag } from '../../cases/index.js';
import { CollectorType, PaymentOptionType } from '../../collectors/index.js';
import { ConnectConnectionStatus } from '../../connect/connections/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '../../connect/mappings/index.js';
import { ProductService } from '../../connect/products/index.js';
import { InterestType, LienType, ValuationSource, } from '../../cosmoV2/assets.js';
import { ProviderName } from '../../cosmoV2/providers/index.js';
import { SubmitToCourtError } from '../../court/auto-submit.js';
import { UdbetalingsRekvisitioner } from '../../court/index.js';
import { CreditorState } from '../../creditor/index.js';
import { AlternativeContactType, CompanyStarCycle, DissolvedStatus, FoundationCode, PrivateStarCycle, RelationType, } from '../../customers/index.js';
import { DebtRegistrationState, RegistryType, } from '../../debt-register/index.js';
import { DebtRegistrationError } from '../../debt-register/rki.js';
import { DocumentTypes } from '../../documents/index.js';
import { AutoBillingTiming, Timing, } from '../../economy/billing-appendix-setups/index.js';
import { DepositShareType } from '../../economy/billing/organize.js';
import { CaseVoucherEventType } from '../../economy/case-voucher-events/event-type.js';
import { State as CaseVoucherState } from '../../economy/case-vouchers/index.js';
import { CaseVoucherSource, PaymentType, State, } from '../../economy/case-vouchers/index.js';
import { CaseVoucherTags } from '../../economy/index.js';
import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { PayoutState, PayoutType } from '../../economy/payouts/index.js';
import { CompoundingPeriod, ImposeInterestFrequency, VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '../../economy/vouchers/index.js';
import { EmbedPlacement } from '../../embeds/index.js';
import { EndReasonCategory } from '../../end-reasons/index.js';
import { ImportState } from '../../imports/types.js';
import { Entity, Gender, PermissionLevels, TimespanUnit } from '../../index.js';
import { AggregationType } from '../../insights/aggregations.js';
import { BulkActionType } from '../../insights/bulk-actions.js';
import { FilterType } from '../../insights/index.js';
import { DiscountType, IntentType } from '../../intents/index.js';
import { InteractionEventType } from '../../interactions/events/index.js';
import { InteractionType, PhoneIncomingTag, PhoneOutgoingTag, ReturnReason, } from '../../interactions/index.js';
import { PerformedByType } from '../../performed-by/index.js';
import { SystemProcedure, SystemProcedureId } from '../../procedures/index.js';
import { PropertyDataType } from '../../properties/index.js';
import { TemplateMention, TemplateTag, TemplateType, } from '../../templates/index.js';
import { SKU } from '../../tenants/billing.js';
import { TenantStatus } from '../../tenants/index.js';
import { TribunalCaseStatus, TribunalCaseType, } from '../../tribunal/cases/types.js';
import { CourtMeetingState, DistraintType, TribunalJobType, } from '../../tribunal/jobs/types.js';
import { UpdateType } from '../../updates/index.js';
import { InterestFrom, VoucherApplicationTarget, VoucherApplicationType, } from '../../voucher-applications/index.js';
import { PathWarning, RequirementType, TimingType, TodoType, } from '../../workflows/index.js';
export default {
    is: {
        currently: 'en',
    },
    langs: {
        en: 'English',
        da: 'Danish',
        sv: 'Swedish',
        no: 'Norwegian',
        fi: 'Finnish',
        nl: 'Dutch',
        de: 'German',
        fr: 'French',
        es: 'Spanish',
        cs: 'Czech',
        el: 'Greek',
    },
    tribunalCaseTypes: {
        [TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Bailiff claim form (Betalingspåkrav)',
        [TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Bailiff court request (fogedrekvisition)',
        [TribunalCaseType.DKAndreFogedsager]: '🇩🇰 Other bailiff cases',
        [TribunalCaseType.GLStaevning]: '🇬🇱 Stævning',
        [TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
        [TribunalCaseType.GLBetalingspaakrav]: '🇬🇱 Bailiff claim form (Betalingspåkrav)',
    },
    tribunalCaseStatuses: {
        [TribunalCaseStatus.Created]: 'Created',
        [TribunalCaseStatus.Awaiting1Paategning]: 'Awaiting "1.-påtegning"',
        [TribunalCaseStatus.ClosedBecauseOfObjection]: 'Closed - dispute',
        [TribunalCaseStatus.Closed]: 'Ended',
        [TribunalCaseStatus.Awaiting2Paategning]: 'Awaiting "2.-påtegning"',
        [TribunalCaseStatus.AwaitingBailiffMeeting]: 'Awaiting meeting',
        [TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Awaiting meeting notice',
        [TribunalCaseStatus.AwaitingVerdict]: 'Awaiting verdict',
        [TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Awaiting invitation',
        [TribunalCaseStatus.AwaitingFogedmoede]: 'Awaiting meeting',
    },
    tribunalJobTypes: {
        [TribunalJobType.GLCreateBetalingspaakrav]: 'Create bailiffs court case',
        [TribunalJobType.GLResendBetalingspaakrav]: 'Resending of bailiffs court case',
        [TribunalJobType.CreateBetalingspaakrav]: 'Create bailiffs court case',
        [TribunalJobType.ResendBetalingspaakrav]: 'Resending of bailiffs court case',
        [TribunalJobType.Register1Paategning]: 'Registering "1.-påtegning"',
        [TribunalJobType.ClosedObjection]: 'Closed after 1.-påtegning due to dispute',
        [TribunalJobType.Register2Paategning]: 'Registering "2.-påtegning"',
        [TribunalJobType.CreateFogedrekvisition]: 'Create "fogedrekvisition"',
        [TribunalJobType.RegisterInsolvency]: 'Register insolvency',
        [TribunalJobType.RegisterPolicePresentation]: 'Register police presentation',
        [TribunalJobType.CreateStaevning]: 'Create stævning',
        [TribunalJobType.RegisterVerdict]: 'Verdict registered',
        [TribunalJobType.ResendStaevning]: 'Resending of stævning',
        [TribunalJobType.CreateFogedbegaering]: 'Create fogedbegæring',
        [TribunalJobType.ResendFogedbegaering]: 'Resending of fogedbegæring',
        [TribunalJobType.RegisterInsolvens]: 'Register insolvency',
        [TribunalJobType.CourtMeeting]: 'Court meeting',
        [TribunalJobType.Distraint]: 'Distraint',
        [TribunalJobType.CreateOtherFogedsager]: 'Create other bailiff case',
        [TribunalJobType.Note]: 'Add note',
        [TribunalJobType.CloseCase]: 'Mark case as ended',
    },
    distraintType: {
        [DistraintType.Property]: 'Real estate',
        [DistraintType.Vehicle]: 'Vehicle',
        [DistraintType.RentalDeposit]: 'Rental deposit',
        [DistraintType.CooperativeHousing]: 'Cooperative housing',
        [DistraintType.Other]: 'Other',
        [DistraintType.MortgageDeed]: 'Mortgage deed',
        [DistraintType.ExcessTax]: 'Tax refund',
    },
    tenantStatus: {
        [TenantStatus.Active]: 'Active',
        [TenantStatus.Demo]: 'Demo',
        [TenantStatus.Disabled]: 'Disabled',
        [TenantStatus.GettingStarted]: 'Awaiting go live',
        [TenantStatus.Sandbox]: 'Sandbox',
    },
    tenantStatusPlural: {
        [TenantStatus.Active]: 'Active',
        [TenantStatus.Demo]: 'Demos',
        [TenantStatus.Disabled]: 'Disabled',
        [TenantStatus.GettingStarted]: 'Awaiting go live',
        [TenantStatus.Sandbox]: 'Sandboxes',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": "Concatenated SMS'",
        'Min.': 'Min.',
        'Pcs.': 'Pcs.',
        Months: 'Months',
    },
    tenantBilling: {
        invoices: 'Invoices',
        invoice: 'Invoice',
        creditNote: 'Credit note',
        noInvoicesYet: 'No invoices to show',
        backToTenantBilling: 'Back to billing',
    },
    tenantSKU: {
        [SKU.DomesticSMS]: 'SMS domestic',
        [SKU.InternationalSMS]: 'SMS international',
        [SKU.DomesticAutoCall]: 'Automatic call domestic',
        [SKU.InternationalAutoCall]: 'Automatic call international',
        [SKU.DomesticLetter]: 'Letter domestic',
        [SKU.InternationalLetter]: 'Letter international',
        [SKU.ReturnLetter]: 'Return letter',
        [SKU.DigitalSignature]: 'Digital signature',
        [SKU.PhoneLookup]: 'Phone number lookup',
        [SKU.EmailLookup]: 'Email lookup',
        [SKU.CaseCreation]: 'Case creation',
        [SKU.MigratedCaseCreation]: 'Migrated case creation',
        [SKU.MonthlyBaseFee]: 'Monthly license fee',
        [SKU.SupportAgreement]: 'Support agreement',
        [SKU.EBoks0_60KB]: 'e-Boks message (0-60kb)',
        [SKU.EBoks61_120KB]: 'e-Boks message (61-120kb)',
        [SKU.EBoks121_300KB]: 'e-Boks message (121-300kb)',
        [SKU.EBoks301_480KB]: 'e-Boks message (301-480kb)',
        [SKU.EBoks481_960KB]: 'e-Boks message (481-960kb)',
        [SKU.EBoks961_1440KB]: 'e-Boks message (961-1440kb)',
        [SKU.EBoks1441_1920KB]: 'e-Boks message (1441-1920kb)',
        [SKU.EBoks1921_10080KB]: 'e-Boks message (1921-10080kb)',
        [SKU.Onboarding]: 'Onboarding',
        [SKU.LetterExtraSheet]: 'Extra pages, physical letter',
        [SKU.NemId]: 'NemId validation',
        [SKU.MitID]: 'MitID validation',
        [SKU.FreezingSystemSignOn]: 'Freezing system sign on',
        [SKU.FreezingSystemSignOff]: 'Freezing system sign off',
        [SKU.Consultancy]: 'Consultancy',
        [SKU.CosmoPersonLookup]: 'Lookup person',
        [SKU.CosmoCompanyLookup]: 'Lookup company',
    },
    caseVoucherTableLabels: {
        overview: 'Case economy',
        detailed: 'Case economy detailed',
        principalWithReferenceCaseVouchers: 'Principal with reference vouchers',
    },
    documentSettings: {
        newDocumentSigningLink: 'New document signing link',
        name: 'Merge field name',
        description: 'Description',
        signedProcedure: 'Trigger if the document is signed',
        declinedSigningProcedure: 'Trigger if signing of the document is declined',
    },
    caseVoucherTables: {
        caseVoucherTable: 'Case voucher table',
        previewDescription: 'Search for a case to preview how the table will look with the case vouchers from that case.',
        createNewTable: 'Add table',
        name: 'Merge field name',
        description: 'Description',
        includeHeader: 'Show header in table',
        includeSumRow: 'Show sum row in table',
        includeSubTotalRow: 'Show subtotal row in table',
        excludeVoucherTypesFromSubTotal: 'Case voucher types excluded from the subtotal',
        showSubTotalPerCaseVoucher: 'Show subtotal under each case voucher (incl. its reference vouchers)',
        showDepositDistribution: 'Show deposit distribution based on interest deposit order',
        showInterestCalculationDetails: 'Show interest calculation details',
        showInterestStatus: 'Show interest reason (paid and acknowledged)',
        includeDeleted: 'Show deleted case vouchers',
        includeFIKPaymentDetails: 'Include FIK payment-ID based on the case voucher reference id',
        includeDate: 'Show date',
        includeDueDate: 'Show due date',
        excludeNotDueCaseVouchers: 'Hide not due invoices',
        onlyShowSelectedVoucherCategories: 'Only show selected case voucher categories',
        includeReferenceCaseVouchers: 'Hide reference vouchers',
        filterOnCaseVoucherProperties: 'Filter on case voucher attributes',
        groupBy: 'Group case vouchers',
        groupByText: 'Text',
        groupIncludesPayments: 'Include all payment types',
        excludePaymentsFromSubTotal: 'Exclude all payment types',
        matchPropertiesShouldBeTrue: 'Should be true',
        matchPropertiesShouldBeFalse: 'Should be false',
        selectCaseForPreview: 'Select a case to preview the table',
        display: 'Display',
        filtering: 'Filtering',
        grouping: 'Grouping',
        type: 'Table type',
        typeStandard: 'Standard',
        typeLedger: 'Statement with running balances',
        typeLedgerDescription: 'Every case voucher and each month of interest in chronological order, showing what each payment covered and the remaining principal, interest and costs.',
    },
    economyCategories: {
        [VoucherCategory.DISBURSEMENT]: 'Disbursement',
        [VoucherCategory.FEE]: 'Fee',
        [VoucherCategory.COLLECTIONCOMMISSION]: 'Collection commission',
        [VoucherCategory.OVERPAYMENT]: 'Overpayment',
        [VoucherCategory.PAYOUT]: 'Payout',
        [VoucherCategory.VAT]: 'Vat',
        [VoucherCategory.TRANSACTION]: 'Transaction',
        [VoucherCategory.COST]: 'Cost',
        [VoucherCategory.COURTCOST]: 'Court cost',
        [VoucherCategory.INTEREST]: 'Interest',
        [VoucherCategory.PRINCIPAL]: 'Principal',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Principals',
        [VoucherTypeIds.INVOICE]: 'Invoices',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'On account invoices',
        [VoucherTypeIds.FINALINVOICE]: 'Final settlements',
        [VoucherTypeIds.CONTROLFEE]: 'Control fees',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administration costs',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Credit initiation fees',
        [VoucherTypeIds.CREDITNOTE]: 'Credit notes',
        [VoucherTypeIds.YEARLYINTEREST]: 'Yearly interests',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Monthly interests',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Interest per started month',
        [VoucherTypeIds.PROCESSINTEREST]: 'Interests',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Interests (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Compound interests (daily capitalization)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Compound interests (monthly capitalization)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Compound interests (quarterly capitalization)',
        [VoucherTypeIds.REMINDERFEE]: 'Reminder fees',
        [VoucherTypeIds.COLLECTIONCOST]: 'Collection costs',
        [VoucherTypeIds.COLLECTIONFEE]: 'Collection fees',
        [VoucherTypeIds.BAILIFFSFEE]: 'Bailiffs Fees',
        [VoucherTypeIds.WRITFEE]: 'Writ fees',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Court claim costs without civil court',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Court claim salaries',
        [VoucherTypeIds.BAILIFSSALARY]: 'Bailiffs salaries',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Bailiff requisition fees',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Police presentation fees',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Court claim costs with bailiffs court',
        [VoucherTypeIds.WRITSALARY]: 'Writ salaries',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Compensation costs',
        [VoucherTypeIds.Folkeregisteropslag]: 'Population register lookup',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectual property cases',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Civil court costs',
        [VoucherTypeIds.DEPOSIT]: 'Deposits',
        [VoucherTypeIds.WITHDRAWAL]: 'Withdrawals',
        [VoucherTypeIds.OVERPAYMENT]: 'Overpayments',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Collection commissions',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Collection commissions (surveillance)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Collection commissions (creditor deposit)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Legal counsels',
        [VoucherTypeIds.ENDCASEFEE]: 'End of case fees',
        [VoucherTypeIds.STARTCASEFEE]: 'Start of case fees',
        [VoucherTypeIds.BPKFEE]: 'BPK fees',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions fees',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Debt register registration fees',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Writ disbursements',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Police presentation disbursements',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Bailiff requisition disbursements',
        [VoucherTypeIds.VAT]: 'VAT',
        [VoucherTypeIds.GAELDSBREV]: 'Loan',
        [VoucherTypeIds.SETTLEMENT]: 'Settlements',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Payouts of deposit',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Meeting fees',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Writ fee',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Appointment fee',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Locksmith fee',
        [VoucherTypeIds.DRIVINGFEE]: 'Driving costs',
        [VoucherTypeIds.OTHERFEE]: 'Other costs',
        [VoucherTypeIds.REFUND]: 'Refunds',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Joint deposits',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Default interest (Sweden)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Enforcement application fees (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Representation fees (payment order)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Default interest (Norway)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Court fees (Conciliation Board)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Legal collection fees (Norway)',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Principal',
        [VoucherTypeIds.INVOICE]: 'Invoice',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'On account invoice',
        [VoucherTypeIds.FINALINVOICE]: 'Final settlement',
        [VoucherTypeIds.CONTROLFEE]: 'Control fee',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administration cost',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Credit initiation fee',
        [VoucherTypeIds.CREDITNOTE]: 'Credit note',
        [VoucherTypeIds.YEARLYINTEREST]: 'Yearly interest',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Monthly interest',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Interest per started month',
        [VoucherTypeIds.PROCESSINTEREST]: 'Interest',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Interest (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Compound interest (daily compounding)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Compound interest (monthly compounding)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Compound interest (quarterly compounding)',
        [VoucherTypeIds.REMINDERFEE]: 'Reminder fee',
        [VoucherTypeIds.COLLECTIONCOST]: 'Collection cost',
        [VoucherTypeIds.COLLECTIONFEE]: 'Collection fee',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Compensation cost',
        [VoucherTypeIds.Folkeregisteropslag]: 'Population register lookup',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectual property cases',
        [VoucherTypeIds.DEPOSIT]: 'Deposit',
        [VoucherTypeIds.WITHDRAWAL]: 'Withdrawal',
        [VoucherTypeIds.OVERPAYMENT]: 'Overpayment',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Collection commission',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Collection commission (surveillance)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Collection commission (creditor deposit)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Legal counsel',
        [VoucherTypeIds.ENDCASEFEE]: 'End of case fee',
        [VoucherTypeIds.STARTCASEFEE]: 'Start of case fee',
        [VoucherTypeIds.BPKFEE]: 'BPK fee',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions fee',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Debt register registration fee',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Writ disbursement',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Police presentation disbursement',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Bailiff requisition disbursement',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Court claim cost without civil court',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Court claim salary',
        [VoucherTypeIds.VAT]: 'VAT',
        [VoucherTypeIds.BAILIFFSFEE]: 'Bailiffs fee',
        [VoucherTypeIds.BAILIFSSALARY]: 'Bailiffs salary',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Police presentation fee',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyr med fogedretten',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostning til civilretten',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Bailiff requisition fee',
        [VoucherTypeIds.WRITFEE]: 'Writ fee',
        [VoucherTypeIds.WRITSALARY]: 'Writ salary',
        [VoucherTypeIds.GAELDSBREV]: 'Loan',
        [VoucherTypeIds.SETTLEMENT]: 'Settlement',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Payout of deposit',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Meeting fee',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Writ fee',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Appointment fee',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Lock smith fee',
        [VoucherTypeIds.DRIVINGFEE]: 'Driving costs',
        [VoucherTypeIds.OTHERFEE]: 'Other fee',
        [VoucherTypeIds.REFUND]: 'Refunds',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Joint deposit',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Default interest (Sweden)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Enforcement application fee (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Representation fee (payment order)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Default interest (Norway)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Court fee (Conciliation Board)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Legal collection fee (Norway)',
    },
    transactionAccounts: {
        transactionAccount: 'bank account',
        name: 'Account name',
        referenceId: 'Reference no.',
        edit: 'Edit account',
        bankAccountsPlaceholder: 'Name of the bank account',
        add: 'Add bank account',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'added the following voucher(s)',
        addedTheFollowingVouchers: 'The following voucher(s) was added',
        someoneDeletedTheFollowingVouchers: 'deleted the following voucher(s)',
        deletedTheFollowingVouchers: 'The following voucher(s) was deleted',
        thatResultedIn: 'That resulted in this billing',
    },
    economyDownloadPostings: {
        postingReference: 'Appendix id',
        creditorReference: 'Creditor reference',
        transactionId: 'Transaction ID',
        type: 'Type',
        ofVoucher: 'Of voucher',
        date: 'Date',
        currency: 'Currency',
        amount: 'Amount',
        accountType: 'Account type',
        account: 'Account',
    },
    systemTankHandles: {
        DEPOSITS: 'Deposits',
    },
    billingModels: {
        name: 'Name',
        preventNegativeCreditorBalance: 'Prevent negative creditor balance',
        moreSettings: 'More settings',
        forceCollectionCommissionBilling: 'Force automatic billing of collection commission - even before deposits.',
        forceCollectionCommissionBillingVoucherTypeId: 'Select billing voucher type',
        selectSeparateFeeVoucherType: 'Bill collection commission separetely',
        selectVouchersGroup: 'Select vouchers',
        systemConnector: 'System billing model',
        tenantConnector: 'Created billing model',
        voucherCategory: 'Voucher category',
        voucherType: 'Voucher type',
        allVouchers: 'All vouchers',
        categoriesOrTypesFilter: 'Select vouchers to be billed',
        caseTagFilter: 'Filter cases',
        caseTagSurveillanceFilter: 'Surveillance only',
        caseTagCompanyFilter: 'Company cases only',
        caseTagPrivateFilter: 'Private cases only',
        voucherTagFilter: 'Bill by imposed by',
        imposedByCollector: 'Imposed by collector',
        imposedByCreditor: 'Imposed by creditor',
        feeFraction: 'Bill a fraction of the voucher',
        feeFractionPlaceholder: 'Fraction of the voucher',
        addShare: 'Add another billing filter',
        byVoucherCategory: 'By voucher category',
        byVoucherType: 'By voucher type',
        createBillingModel: 'Create billing model',
        simulateBilling: 'Simulate billing',
        simulateCompany: 'Simulate a company',
        simulateSurveillance: 'Simulate surveillance',
        simulateAmount: 'Amount of deposit',
        previewBillingModel: 'Preview billing model',
        selectBillingModel: 'Select billing model',
        searchBillingModels: 'Search billing models',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'Created setup',
        systemBillingAppendixSetup: 'System setup',
        name: 'Name',
        billingAppendixSetups: 'Billing appendix setups',
        noBillingAppendixSetupsToShow: 'No setups to show',
        newBillingAppendixSetup: 'New billing appendix setup',
        addBillingAppendixSetup: 'Create billing appendix setup',
        billing: 'Bill',
        createNew: 'Create setup',
        addNewSetup: 'Add setup',
        appendixHandle: 'Appendix name',
        hideFromCreditor: 'Hide settlements of this appendix type on the creditor portal',
        includeVatInDepositShare: 'Include VAT in the collection commission in payment tables',
        selectBillingAppendixSetup: 'Select billing appendix setup',
        searchBillingAppendixSetups: 'Search billing appendix setups',
        previewBillingAppendixSetup: 'Preview billing appendix setup',
        autoBilling: 'Auto billing',
        autoBillingDescription: 'Automatically generate the bill on a fixed schedule. When off, billing is created manually.',
        autoBillingOff: 'Off',
        selectAllVoucherTypes: 'Select all voucher types',
    },
    billingAppendixSetupTimings: {
        [Timing.Manual]: 'Manual billing',
        [Timing.ASAP]: 'Daily',
        [Timing.OnCaseEnd]: 'After case end',
        [Timing.Weekly]: 'Weekly',
        [Timing.Monthly]: 'Monthly',
        [Timing.Quarterly]: 'Quarterly',
    },
    autoBillingTimings: {
        [AutoBillingTiming.Weekdays0700]: 'Weekdays at 07:00',
    },
    caseVoucherStates: {
        [State.Unmapped]: 'Unmapped',
        [State.Unknown]: 'Unknown',
        [State.Archived]: 'Archived',
        [State.Overpayment]: 'Overpayment',
        [State.FullPayment]: 'Full payment',
        [State.PartialPayment]: 'Partial payment',
        [State.PaymentPlanEntryPayment]: 'Installment payment',
        [State.UnkownPaymentPlanPayment]: 'Unknown payment plan',
        [State.AccordPayment]: 'Accord payment',
        [State.PrincipalPayment]: 'Principal payment',
        [State.Pending]: 'Pending',
    },
    caseVoucherSources: {
        [CaseVoucherSource.Collector]: 'Collector',
        [CaseVoucherSource.Creditor]: 'Creditor',
    },
    depositShareType: {
        [DepositShareType.AdjustmentCredit]: 'Adjustment - credit',
        [DepositShareType.AdjustmentDebit]: 'Adjustment - debit',
        [DepositShareType.Deposit]: 'Deposit',
        [DepositShareType.Fee]: 'Collection commission',
    },
    voucherTypeSettings: {
        voucherType: 'Voucher type',
        category: 'Category',
        vat: 'Vat',
        setting: 'Setting',
        createNewVoucherType: 'Create new voucher type',
        create: 'Create',
        interruptsLimitationPeriod: 'Interrupts the limitation period',
        interruptsLimitationPeriodDesc: 'Payments of this type restart the limitation period of the debt.',
        customCaseVoucherType: 'Created case voucher types',
        standardCaseVoucherType: 'Standard case voucher types',
        customBillingVoucherType: 'Created billing voucher types',
        standardBillingVoucherType: 'Standard billing voucher types',
        caseVoucherType: 'Case voucher type',
        caseVoucherTypeDesc: 'Name of case voucher type, category and setting.',
        label: 'Name',
        noSetting: 'None',
        interstDays: 'Interest days',
        interstDaysDesc: 'Days per year',
        interestRounding: 'Rounding',
        interestRoundingDesc: 'When to rent to be rounded off.',
        interestRoundingContent: 'Rounded to the nearest penny daily.',
        interestCompoundingPeriod: 'Interest attribution',
        interestCompoundingPeriodDesc: 'How often must the interest be attributed to the principal. Also called the capitalization period.',
        interestCompoundVouchers: 'Capitalized Interest Vouchers',
        interestCompoundVouchersDesc: 'Voucher types to be classified as capitalized interest if they serve as references to the same principal voucher.',
        interestFrequency: 'Calculation frequency',
        interestFrequencyDesc: 'How often the interest is calculated.',
        interestTable: 'Rentesatstabel',
        interestTableDesc: 'Interest rate table',
        interestTableFromDate: 'From date',
        interestTableRate: 'Interest rate',
        interestTableAddRate: 'Add rate',
        interestTableEditRate: 'Edit rate',
        interestTableSaveRate: 'Save',
        interestTableCancelEdit: 'Cancel',
        interestTableDeleteRate: 'Delete rate',
        interestTableNoRates: 'No interest rates yet. Add one to get started.',
        interestTableWarning: 'Changes can affect existing cases',
        interestTableWarningDesc: 'Editing historical rates or adding rates dated before today can change interest on existing cases, payment plan instalments and already settled cases. Proceed with care.',
        editor: 'Voucher editor',
        editorDesc: 'Configure which fields are available when creating vouchers of this type, and how they behave.',
        editorGroupInputs: 'Available inputs',
        editorGroupInputsDesc: 'Choose which fields the user can fill in when creating a voucher.',
        editorGroupBehavior: 'Behavior',
        editorGroupBehaviorDesc: 'How vouchers of this type behave once created.',
        editorGroupVisibility: 'Visibility',
        editorGroupVisibilityDesc: 'Control where this voucher type and its vouchers are shown.',
        editorRequired: 'Required',
        editorDueDate: 'Due date',
        editorDueDateDesc: 'Show a due date field.',
        editorDefaultAmount: 'Default amount',
        editorDefaultAmountDesc: 'Pre-fill the amount field with this value. Leave empty to disable.',
        editorText: 'Free text',
        editorTextDesc: 'Show a text field for additional notes.',
        editorReferenceId: 'Reference ID',
        editorReferenceIdDesc: 'Show a field for an external reference identifier.',
        editorReferenceVoucher: 'Reference voucher',
        editorReferenceVoucherDesc: 'Allow linking the voucher to another voucher on the same case.',
        editorAppendix: 'Appendix',
        editorAppendixDesc: 'Allow attaching an appendix file.',
        editorSource: 'Source selector',
        editorSourceDesc: 'Let the caseworker pick whether the voucher is imposed by the creditor or the collector.',
        editorSourceDefaultCreditor: 'Default to creditor',
        editorAmountNegative: 'Allow negative amount',
        editorAmountNegativeDesc: 'Used for credit notes and deposits where the amount reduces the case balance.',
        editorAddInterest: 'Automatically add procesrente',
        editorAddInterestDesc: 'Adds a process interest voucher referencing this voucher.',
        editorShowOnCreditorWeb: 'Show on creditor portal',
        editorShowOnCreditorWebDesc: 'Visible to creditors in the self-service portal.',
        editorHideProperties: 'Hide properties',
        editorHidePropertiesDesc: 'Hide the voucher properties panel in the editor.',
        editorHideFromAllUsers: 'Hide from all users',
        editorHideFromAllUsersDesc: 'The voucher type will not be selectable when creating a new voucher.',
        billingVoucherType: 'Billing voucher type',
        billingVoucherTypeDesc: 'Name of billing voucher type and category.',
        editorPayoutToContact: 'Pay out to contact',
        editorPayoutToContactDesc: 'The caseworker picks a contact with bank details and a payout to the contact is created along with the voucher. Used for suppliers hired on behalf of the creditor, e.g. a locksmith.',
        editorCreditorDisbursement: 'Bill the disbursement to the creditor',
        editorCreditorDisbursementDesc: 'The caseworker can add the amount to the creditor billing with the chosen billing voucher type. When required, it happens every time.',
    },
    voucherTypeSetting: {
        [VoucherTypeSetting.AmountFromTable]: 'Amount from table',
        [VoucherTypeSetting.InterestFromTable]: 'Interest from table',
        [VoucherTypeSetting.CompoundInterest]: 'Compound interest',
        [VoucherTypeSetting.FixedInterest]: 'Fixed interest',
        [VoucherTypeSetting.InterestPercentage]: 'Yearly interest',
        [VoucherTypeSetting.TextAsLabel]: 'Text as label',
        [VoucherTypeSetting.Payment]: 'Payment',
    },
    compoundingPeriod: {
        [CompoundingPeriod.Daily]: 'Daily',
        [CompoundingPeriod.Monthly]: 'Monthly',
        [CompoundingPeriod.Quarterly]: 'Quarterly',
    },
    imposeInterestFrequency: {
        [ImposeInterestFrequency.Daily]: 'Daily',
        [ImposeInterestFrequency.Monthly]: 'Per started month',
    },
    economy: {
        groupPostings: 'Group vouchers in export',
        generalBillingSettings: 'Billing settings',
        sendingBillingByEmail: 'Sending billing appendices by email',
        doNotAttachBillingAppendicesInEmails: 'Do not attach billing appendices in emails',
        billingModels: 'Billing models',
        tenantBillingModels: 'Your billing models',
        defaultBillingModels: 'Standard billing models',
        noBillingModelsToShow: 'No billing models to show',
        newBillingModel: 'Billing model',
        addBillingModel: 'Add billing model',
        billingAppendixSetup: 'Billing appendix setup',
        standardPrice: 'standard price:',
        regNumber: 'Reg. nr.',
        accountNumber: 'Account number',
        pipeFilterSelectVoucherTypes: 'Select voucher types',
        depositFile: 'Deposit file',
        caseEconomy: 'Case Economy',
        costCeilingReached: 'Cost ceiling reached',
        costCeilingReachedDescription: 'Interest and fees on this case are capped at the principal amount.',
        costCeilingExceeded: 'Cost ceiling exceeded',
        costCeilingExceededDescription: 'Fees and costs on this case already exceed the cost ceiling on their own.',
        voucherAlreadyExists: 'already exist on case',
        histItemHeader: 'Economy',
        sum: 'Sum',
        voucherType: 'Voucher type',
        account: 'Account',
        referenceId: 'Reference ID',
        text: 'Description',
        amount: 'Amount',
        originalAmount: 'Original amount',
        amountAfterWriteOffs: 'Amount after write-offs',
        date: 'Date',
        addAppendix: 'Add appendix',
        referenceVoucher: 'Reference voucher to base interest on',
        selectReferenceVoucher: 'Select reference voucher',
        interestRate: 'Interest rate',
        interestAmount: 'Interest amount',
        interest: 'Interest',
        dueDate: 'Due date',
        expirationDate: 'Expiration date',
        expirationFromDate: 'Special start date for expiration',
        expirationManualSet: 'Expiration date manually set',
        expirationLength: 'Limitation period (years)',
        expirationLengthStandard: 'Standard',
        expirationResetToCalculated: 'Calculate automatically again',
        expiredAmount: 'Expired amount',
        irrecoverableAmount: 'Irrecoverable amount',
        cannotMoveWrittenOffVoucher: 'The voucher has partly expired or become irrecoverable and cannot be moved to this case',
        interestStartDate: 'Interest start date',
        interestStartDays: 'Days before interest starts',
        interestEndDate: 'Interst end date',
        imposedByCreditor: 'Imposed by creditor',
        debtIrrecoverable: 'Irrecoverable',
        debtExpied: 'Expired',
        markExpired: 'Expire and end case',
        markSomeExpired: 'Expire',
        markSomeExpiredPostings: 'vouchers',
        sureYouWantToMarkExpired: 'Are you sure that you want to mark vouchers expired?',
        voucherCreationCreate: 'Create',
        voucherCreationIncludeInterest: 'Add interest',
        voucherCreationCreditorDeposit: 'Deposit to creditor',
        addDisbursementToBilling: 'Add disbursement to creditor billing',
        disbursementAddedToBilling: 'The disbursement is billed to the creditor',
        caseVoucherInfoType: 'Type',
        caseVoucherInfoTypeSeeDetails: 'See details about case voucher type',
        caseVoucherInfoCreatedAt: 'Created at',
        voucherInfoId: 'Voucher id',
        voucherInfoCreatedBy: 'Created by',
        caseVoucherInfoCategory: 'Category',
        caseVoucherInfoState: 'State',
        caseVoucherInfoHeaderTheVoucher: 'Case voucher',
        caseVoucherInfoHeaderMeta: 'Information',
        caseVoucherInfoHeaderInterest: 'Interest',
        voucherInfoText: 'Text',
        voucherInfoAmount: 'Amount',
        voucherInfoCasePreview: 'Case',
        voucherInfoMoveToCase: 'Case voucher moved to case',
        voucherInfoCreditorName: 'Creditor',
        voucherInfoAppendix: 'Appendix',
        voucherInfoRefVoucher: 'Reference Voucher',
        voucherInfoInterestHis: 'Interest history',
        voucherInfoIfrom: 'From',
        voucherInfoITo: 'To',
        voucherInfoIInterval: 'Interval',
        voucherInfoIRVA: 'Ref. Voucher Amount',
        voucherInfoICompoundedAmount: 'Compounded amount',
        voucherInfoIDays: 'days',
        voucherInfoIReapplied: 'Reapplied',
        voucherInfoIReason: 'Reason',
        voucherInfoIPaid: 'Paid',
        voucherInfoIAcknowledged: 'Acknowledged',
        voucherInfoInterestPeriods: 'Interest periods',
        voucherInfoInterestPeriodFrozen: 'Interest free',
        voucherInfoInterestPeriodVoided: 'Reapplied at',
        voucherInfoInterestPeriodOpenEnded: 'Open-ended',
        voucherInfoDistributedOnto: 'Distributed onto',
        voucherInfoDistributionsReceived: 'Covered by',
        voucherInfoDistributionVoucher: 'Voucher',
        voucherInfoDistributionAmount: 'Amount',
        voucherInfoDistributionType: 'Type',
        voucherInfoDistributionFixed: 'Fixed',
        voucherInfoDistributionAutomatic: 'Automatic',
        voucherInfoDistributionBilling: 'Fixed (billing)',
        voucherInfoDistributionRemaining: 'Remaining',
        voucherInfoDeleteFixedDistribution: 'Remove fixed distribution',
        voucherInfoEditFixedDistribution: 'Edit fixed distribution',
        voucherInfoConfirmDeleteFixedDistribution: 'Are you sure you want to remove this fixed distribution?',
        voucherInfoFixedDistributionSave: 'Save',
        voucherInfoFixedDistributionJointInfo: 'This change will also affect associated payments on other cases',
        voucherInfoAllocatePayment: 'Allocate payment',
        voucherInfoAllocatePaymentTarget: 'Allocate to voucher',
        voucherInfoDistributionDynamic: 'Calculated',
        voucherInfoDistributionUnallocated: 'Unallocated',
        voucherInfoEditDistributions: 'Edit distributions',
        voucherInfoDistributionDateFromOriginal: 'Date from original',
        voucherInfoDistributionDateFromApplied: 'Date from applied',
        voucherInfoCreateCounterEntry: 'Create counter entry',
        voucherInfoConfirmCounterEntry: 'Are you sure you want to create a counter entry for this voucher?',
        voucherInfoCounterEntryAmount: 'Counter entry amount',
        voucherInfoDeleteVoucher: 'Delete voucher',
        voucherDeleteHasFixedDistributions: 'This voucher has fixed distributions. Do you want to remove them and delete the voucher?',
        voucherDeleteHasFixedDistributionsWithJoint: 'This voucher has fixed distributions. Deleting will also remove associated payments on other cases. Continue?',
        voucherInfoMarkVoucherExpired: 'Mark expired',
        voucherInfoUnmarkVoucherExpired: 'Unmark expired',
        voucherInfoMarkVoucherIrrecoverable: 'Irrecoverable',
        voucherInfoRestoreVoucher: 'Restore voucher',
        currency: 'Currency',
        billingModel: 'Billing model',
        aggregation: 'Aggregation',
        postings: 'Postings',
        bookkeepingMapping: 'Map bookkeeping accounts',
        bookkeepingMappingBase: 'General',
        bookkeepingMappingFees: 'Fees',
        bookkeepingMappingDisbursements: 'Disbursements',
        bookkeepingMappingAccount: 'Account',
        bookkeepingMappingAccountType: 'Account type',
        bookkeepingMappingReverse: 'Reverse amounts',
        bookkeepingMappingExclude: 'Exclude',
        bookkeepingMappingIncludeVat: 'Include vat',
        bookkeepingMappingContraAccountOn: 'Contra voucher',
        bookkeepingMappingContraAccount: 'Contra account',
        bookkeepingMappingContraAccountType: 'Contra account type',
        bookkeepingMappingCreditorReferenceId: 'Creditor reference id',
        bookkeepingMappingBankOrPSP: 'Bank or acquirer',
    },
    economyAppendixHeaders: {
        type: 'Type',
        date: 'Date',
        voucherId: 'Voucher Id',
        voucherType: 'Voucher Type',
        text: 'Text',
        amount: 'Amount',
        currency: 'Currency',
    },
    caseVoucherTags: {
        [CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Imposed by collector',
        [CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Imposed by creditor',
        [CaseVoucherTags.CREDITORTRANSACTION]: 'Creditor transaction',
        [CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic import',
        [CaseVoucherTags.EXPIRED]: 'Expired',
        [CaseVoucherTags.IRRECOVERABLE]: 'Irrecoverable',
    },
    caseTags: {
        [CaseTag.SURVEILLANCE]: 'Surveillance',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaction imports',
        selectType: 'Select payment type',
    },
    caseVouchers: {
        source: 'Source',
        irrecoverableDate: 'Irrecoverable date',
        expirationDate: 'Expiration date',
        expired: 'Expired',
        case: 'Case',
        map: 'Map',
        mapHeader: 'Map case voucher to case',
        deleteWarning: 'Are you sure that you want to delete this voucher? This action cannot be reversed.',
        exportFileName: 'case-vouchers',
        voucherId: 'Voucher-id',
        voucherReferenceId: 'Voucher reference',
        caseId: 'Casenumber',
        creditor: 'Creditor',
        creditorReference: 'Creditor reference',
        customerReference: 'Customer reference',
        account: 'Account',
        accountId: 'Account-id',
        bookingDate: 'Booking date',
        bookingDateDescription: 'The date the deposit is booked in the accounts. The payment date decides how interest is calculated; the booking date decides which accounting period the deposit belongs to.',
        bookingDateFollowsDate: 'Follows the payment date',
        setBookingDate: 'Set booking date',
        setBookingDateDescription: 'Set the date the selected deposits are booked in the accounts. Use this when an acquirer settlement reaches the bank later than the payments themselves.',
        clearBookingDate: 'Clear, follow the payment date',
    },
    payouts: {
        caseSeqId: 'Case id',
        caseReferenceId: 'Case reference',
        billingId: 'Billing id',
        court: 'Court',
        type: 'Type',
        account: 'Account',
        creditorReference: 'Creditor reference',
        text: 'Text',
        state: 'State',
        amount: 'Amount',
        currency: 'Currency',
        createdAt: 'Created',
        updatedAt: 'Updated',
        complete: 'Completed',
        completeOnExport: 'Mark completed on export',
        exportFileName: 'payouts',
    },
    payoutState: {
        [PayoutState.Completed]: 'Completed',
        [PayoutState.Created]: 'Created',
        [PayoutState.DataUpdated]: 'Data updated',
        [PayoutState.Failed]: 'Failed',
        [PayoutState.Initiated]: 'Initiated',
    },
    payoutType: {
        [PayoutType.CourtFee]: 'Court fee',
        [PayoutType.CreditorReceivables]: 'Creditor receivables',
        [PayoutType.Other]: 'Other',
        [PayoutType.Overpayment]: 'Overpayment',
    },
    clientBilling: {
        clientBilling: 'Creditor billing',
        isAdjustment: 'Adjustment',
        billings: 'Billings',
        seeDetails: 'See creditor billing details',
        seeDetailsCreditor: 'See billing details',
        fetchingUpdatedEconomy: 'Fetching updated information',
        deposits: 'Deposits',
        fees: 'Fees',
        disbursements: 'Disbursements',
        showPerDeposit: 'Show per deposit',
        voucherType: 'Voucher type',
        original: 'Original',
        paid: 'Paid',
        residue: 'Residue',
        collector: 'Collector',
        creditor: 'Creditor',
        overpayment: 'Overpayment',
        text: 'Text',
        addVoucher: 'Add voucher',
        otherPayments: 'of other deposits.',
        noVouchers: 'No vouchers',
        hoursOf: 'hours at',
        hourOf: 'hour at',
        hourlyRateOn: 'Charge hourly rate',
        hourlyRate: 'Hourly rate',
        hourlyRateHours: 'Hours',
        hourlyRateMinutes: 'Minutes',
    },
    search: {
        migratedId: 'Migrated j.no.',
        noResults: 'No results',
        voucherReferenceId: 'Voucher id',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Phone',
    },
    deposits: {
        customizeExport: 'Customize export',
        selectedExportHint: 'Only the selected postings',
        filteredExportHint: 'All table filter results · max. 10,000',
        exportEditorDescription: 'Choose fields on the left and customize your file’s columns on the right.',
        exportFormat: 'File format',
        standardExportColumns: 'Standard fields',
        availableExportColumns: 'Available fields',
        searchExportColumns: 'Search fields or properties…',
        exportColumnHint: 'Drag to reorder. Click a name to rename.',
        exportColumnName: 'Column name',
        chooseExportColumns: 'Choose fields on the left to build your export.',
        resetExportColumns: 'Restore defaults',
        saveExportSettings: 'Save settings',
        exportStoredLocally: 'Personal settings · saved on this device',
        exportSettings: 'Export payments',
        exportFiltered: 'Filtered postings',
        exportSelected: 'Selected postings',
        exportLimit: 'Export up to 10,000 payments using the table filters. Narrow the filters if there are more matches.',
        markAsExported: 'Mark postings as exported',
        exportColumns: 'Export columns',
        addExportColumn: 'Add column',
        moveColumnUp: 'Move column up',
        moveColumnDown: 'Move column down',
        removeExportColumn: 'Remove column',
        pickPaymentType: 'Pick payment type',
        unknownDeposit: 'Unknown deposits',
        unknownDepositSubHeader: 'Could not identify deposit',
        archive: 'Archive',
        exportDesc: 'Export of deposits from bank or PSP (credit/debit cards etc.)',
        unknownDesc: 'Here is a list of unknown deposits.',
        transactionLookUpDesc: 'Here you can lookup deposits by transaction id.',
        transactionLookUpPlaceholder: 'Type transaction id (for example: 12341234)',
        transactionLookUpNotFound: 'Transaction not found.',
        transactionLookUpNotDeposit: 'Transaction is not a deposit.',
        transactionLookUpButton: 'Lookup',
        transactionLookUpDeposit: 'Deposit',
        downloadSample: 'Download sample',
        downloadSampleQuantity: 'Quantity deposits in sample',
        linkBank: 'Link bank account',
        selectBankAccount: 'Select bank account',
        dropHere: 'Drop here',
        upload: 'Register deposits',
        deposits: 'Deposits',
        map: 'Register deposits',
        handleTransaction: 'Handle deposit',
        addSingleDepositHeader: 'Add single deposit',
        addSingleDepositPaymentType: 'Payment type',
        addSingleDepositDate: 'Date',
        addSingleDepositText: 'Text',
        addSingleDepositAmount: 'Amount',
        addSingleDepositAddAndClose: 'Add and close',
        addSingleDepositAddAndClear: 'Add and clear',
    },
    depositsPaymentTypes: {
        [PaymentType.Mastercard]: 'MasterCard',
        [PaymentType.Swish]: 'Swish',
        [PaymentType.Vipps]: 'Vipps',
        [PaymentType.Visa]: 'Visa',
        [PaymentType.Dankort]: 'Dankort',
        [PaymentType.MobilePay]: 'MobilePay',
        [PaymentType.Betalingsservice]: 'Betalingsservice',
        [PaymentType.Leverandørservice]: 'Leverandørservice',
        [PaymentType.BankTransfer]: 'Bank transaction',
        [PaymentType.FIK]: 'FIK',
        [PaymentType.IBAN]: 'IBAN',
        [PaymentType.Creditor]: 'Creditor',
        [PaymentType.PayPal]: 'PayPal',
        [PaymentType.ApplePay]: 'Apple Pay',
        [PaymentType.GooglePay]: 'Google Pay',
    },
    caseVoucherEvents: {
        header: 'Deposit changes',
        desc: 'Everything that has happened to the deposits received on our accounts. Export the changes to book them, and they are marked as exported so the same change is never booked twice.',
        eventId: 'Change id',
        eventType: 'Change',
        eventDate: 'Time of change',
        performedByType: 'Performed by type',
        performedById: 'Performed by id',
        fromCase: 'From case',
        toCase: 'To case',
        fromCreditor: 'From creditor',
        fromCreditorReference: 'From creditor reference',
        exported: 'Exported',
    },
    caseVoucherEventTypes: {
        [CaseVoucherEventType.Created]: 'Created',
        [CaseVoucherEventType.Booked]: 'Booked on case',
        [CaseVoucherEventType.Moved]: 'Moved to another case',
        [CaseVoucherEventType.Unbooked]: 'Unbooked from case',
        [CaseVoucherEventType.Deleted]: 'Deleted',
        [CaseVoucherEventType.Restored]: 'Restored',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Voucher (later deleted)',
        caseVoucherPatchedCaseId: 'was mapped to the case',
        caseVoucherPatched: 'was edited',
        caseVoucherCreated: 'added to the case',
        caseVoucherDeleted: 'deleted from the case',
        billingModelChanged: 'Billing model changed',
        billingStartDateChanged: 'Start date for billing changed',
    },
    billing: {
        ongoingWork: 'Ongoing work',
        bills: 'Bills',
        billingSequentialId: 'Id',
        case: 'Case',
        date: 'Date',
        type: 'Type',
        text: 'Text',
        customerReferenceId: 'Customer ref.',
        revenue: 'Fees',
        vat: 'Vat',
        payout: 'Payout',
        disbursements: 'Disbursements',
        overpayments: 'Overpayments',
        balance: 'Balance',
        amount: 'Amount',
        deposits: 'Deposits',
        deposit: 'Deposit',
        depositShareTooLongForPDF: 'The itemization of deposits is not included in the PDF because this billing has more than 100 deposits. The total of the deposits is still included.',
        bill: 'Bill',
        delete: 'Remove',
        deleteApproval: 'Are you sure you want to delete the vouchers from the billing? The action cannot be undone.',
        adjustments: 'Adjustments',
        billingPrevented: 'Postponed billings',
        billingStartDate: 'Start billing from',
        appendix: 'Appendix',
        readyForBilling: 'Ready for billing',
        awaitingCaseEnd: 'Awaiting case end',
        appendixMissing: 'Appendix missing',
        billSelected: 'Bill selected',
        addBillingVoucher: 'Add voucher',
        recipient: 'Recipient',
        billingSent: 'Sent',
        sendBilling: 'Send',
        information: 'Information',
        addedToPayouts: 'Added to payouts',
        addToPayouts: 'Add to payouts',
        invoiceNo: 'Invoice no.',
        specifiedByBankTransfer: 'should be stated on the bank transfer',
        paymentTerms: 'Payment terms: Netto',
        daysAndBillingDate: 'days - Payment date',
        billingAlreadySentAlert: 'The appendix has already been sent. Are you sure you want to send it again?',
        amountWillBeWithdrawnToAccount: 'is withdrawn to account',
        amountShouldBePaidToAccount: 'is paid to account',
        preview: 'Preview',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'For payout',
        collectionCommission: 'Collection commission',
        fees: 'Fees',
        otherVat: 'Other vat',
        subtotal: 'Subtotal',
        total: 'Total',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Date',
        billingCollectionBillingAddedToPayouts: 'Added to payouts',
        billingCollectionBillingSent: 'Sent',
        billingCollectionBillingBalance: 'Balance',
        billingsAppendix: 'Appendix',
        billingsType: 'Type',
        billingsCreditor: 'Creditor',
        billingsCases: 'Cases',
        billingsCurrency: 'Currency',
        generateAppendix: 'Generate appendix',
        awaitingGeneration: 'Appendices ready to be generated',
        warnThisWillAffectBilling: 'This action will affect already billed deposits. Are you sure you want to continue?',
        deletionWarning: "Are you sure you want to delete this billing? This action cannot be undone. Please note that deleting does not account for adjustments – these must be handled manually. Furthermore, it doesn't take into account whether the billing has already been sent or booked.",
    },
    creditorBilling: {
        newBillingFrom: 'New billing from',
        dear: 'Dear',
        herebyForwarded: 'Hereby forwarded:',
        seeAttached: 'Please see the attached.',
    },
    bookkeeping: {
        settleAll: 'Settle all creditors',
        preview: 'Preview',
        type: 'Type',
        date: 'Date',
        text: 'Text',
        amount: 'Amount',
        account: 'Acccount',
        contraAccount: 'Contra account',
        debtorVoucher: 'Debtor voucher',
        showMoreVouchers: 'Show more vouchers',
        showing: 'Showing',
        of: 'of',
        vouchers: 'vouchers',
        exportNdownload: 'Export and download',
        history: 'History',
        noHistorical: 'No historical entries yet',
        erpIntegrationHeader: 'Accounting system integration',
        accounts: 'Accounts',
        revenuePlaceholder: 'Revenue',
        outlayPlaceholder: 'Outlay',
        erpVendor: 'ERP vendor:',
        makeSureThat: 'Make sure that:',
        creditorReferenceIdsMatch: "Creditor reference ids matches the customers' in e-conomic",
        bankAccountReferenceIdsMatch: 'Bank and PSP accounts reference ids matches the accounts in e-conomic',
        activeAccountingYear: 'There is an active accounting year',
        connectEconomic: 'Connect e-conomic',
    },
    sites: {
        caseworkerWeb: 'Caseworker Web',
        clientWeb: 'Creditor Web',
        detiorWeb: 'Debtor Web',
    },
    blameLogs: {
        overview: 'Overview',
        userVisits: 'User visits',
        debtorUpdates: 'Debtor changes',
        economy: 'Economy',
        interactions: 'Interactions',
        noEntries: 'No entries',
        blameLog: 'Action log',
        logged: 'Action',
        ago: 'ago',
        type: 'Type',
        content: 'Content',
        subject: 'Subject',
        stepTitle: 'Step title',
        chainTitle: 'Workflow title',
        viewLetter: 'View letter',
        phoneNumber: 'Phone number',
        label: 'Label',
        workflow: 'Workflow',
        fromWorkflow: 'Switched from workflow',
        toWorkflow: 'To workflow',
        noLogs: 'No logs yet',
        settings: 'Settings',
        toggled: 'Toggled to',
        trueActivated: 'activated',
        falseActivated: 'deactivated',
        key: 'Key',
        code: 'Code',
        username: 'Username',
        password: 'Password',
        trueChanged: 'Changed',
        falseChanged: 'Unchanged',
        experianClientId: 'Experian client ID',
        to: 'to',
        when: 'When',
        procedure: 'Shortcut',
        removed: 'Removed',
        other: 'Other actions',
        description: 'Description',
        note: 'Note',
        createdAt: 'Created',
        trueYes: 'Yes',
        falseNo: 'No',
        dunning: 'Dunning',
        connectorBillingModel: 'Billing model',
        cleared: 'Removed',
        newValue: 'New value',
        caseSeqId: 'Case number',
        previousStatus: 'Previous status',
        reason: 'Reason',
        direction: 'Direction',
        mergedTo: 'Merged to',
        mergedFrom: 'Merged from',
        fromCase: 'From case',
        toCase: 'To case',
        fromVoucher: 'From voucher',
        toVoucher: 'To voucher',
        fromStatus: 'From status',
        toStatus: 'To status',
        entriesCount: 'Number of entries',
        activationTrigger: 'Activation triggered',
        tribunalType: 'Case type',
        jobType: 'Action',
        documentType: 'Document type',
        fileName: 'File name',
        signedAt: 'Signed at',
        signedBy: 'Signed by',
        source: 'Source',
        successCount: 'Successful',
        updatedCount: 'Updated',
        failedCount: 'Failed',
        dateUpdated: 'Date',
        fileUploaded: 'File uploaded',
        costsRegistered: 'Costs',
        meetingStateChanged: 'Status',
        noteUpdated: 'Note updated',
        caseLifecycle: 'Case lifecycle',
        paymentPlans: 'Payment plans',
        tribunal: 'Court',
    },
    blameLogSimplfiedType: {
        [BlameLogType.CaseVisit]: 'Case visit',
        [BlameLogType.CaseVoucherCreate]: 'Voucher created',
        [BlameLogType.CaseVoucherDelete]: 'Voucher deleted',
        [BlameLogType.CaseVoucherRestore]: 'Voucher restored',
        [BlameLogType.UnknownCaseVoucherMapped]: 'Unknown deposit mapped to case',
        [BlameLogType.CaseVoucherPatch]: 'Voucher updated',
        [BlameLogType.UserOnCustomerVisit]: 'Customer visit',
        [BlameLogType.CreditorVisit]: 'Creditor visit',
        [BlameLogType.VisitedBy]: 'Visit',
        [BlameLogType.CaseVoucherIrrecoverable]: 'Voucher irrecoverable',
        [BlameLogType.CaseVoucherExpired]: 'Voucher expired',
        [BlameLogType.InteractionCreate]: 'Interaction created',
        [BlameLogType.InteractionDelete]: 'Interaction deleted',
        [BlameLogType.WorkflowRollback]: 'Workflow rollback',
        [BlameLogType.InteractionHideFromClient]: 'Interaction hide from creditor',
        [BlameLogType.InteractionMappedToCase]: 'Interaction mapped to case',
        [BlameLogType.InteractionUnmappedFromCase]: 'Interaction unmapped from case',
        [BlameLogType.InteractionRollback]: 'Interaction rollback',
        [BlameLogType.DebtorWebLoginEId]: 'Debitorweb login with e-ID',
        [BlameLogType.DebtorUpdateName]: 'Name changed',
        [BlameLogType.DebtorUpdatePhone]: 'Phone changed',
        [BlameLogType.DebtorUpdateAddress]: 'Address changed',
        [BlameLogType.DebtorUpdateEmail]: 'Email changed',
        [BlameLogType.DebtorUpdateCourt]: 'Jurisdiction changed',
        [BlameLogType.DebtorUpdateBirthdate]: 'Birthdate changed',
        [BlameLogType.DebtorUpdateCVR]: 'CVR changed',
        [BlameLogType.DebtorUpdateCPR]: 'CPR changed',
        [BlameLogType.AKSConfiguration]: 'AKS configuration',
        [BlameLogType.AutoDebtRegister]: 'Automatic debt registration',
        [BlameLogType.AutoIgnoreUnresolvedOppositions]: 'Ignore unresolved disputes',
        [BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd]: 'Delete debt registration automatically on case end',
        [BlameLogType.AutoRegisterInOpenRegistry]: 'Open registry',
        [BlameLogType.AKSClientID]: 'Experian client id',
        [BlameLogType.RKIOveride]: 'Override auto RKI',
        [BlameLogType.AKSActivated]: 'AKS activated',
        [BlameLogType.PriceList]: 'Price list',
        [BlameLogType.UserPasswordUpdate]: 'User password changed',
        [BlameLogType.TriggerShortcut]: 'Trigger change',
        [BlameLogType.WorkflowChange]: 'Workflow change',
        [BlameLogType.WorkflowChangeOnCase]: 'Workflow changed on case',
        [BlameLogType.CaseCreate]: 'Case created',
        [BlameLogType.CaseDelete]: 'Case deleted',
        [BlameLogType.CaseMerge]: 'Case merged',
        [BlameLogType.CaseStatusChange]: 'Case status changed',
        [BlameLogType.CaseJournalNumberChange]: 'Journal number changed',
        [BlameLogType.CaseCostCeilingAmountChange]: 'Cost ceiling amount changed',
        [BlameLogType.CaseCostCeilingEnabledChange]: 'Cost ceiling toggled',
        [BlameLogType.PaymentPlanCreate]: 'Payment plan created',
        [BlameLogType.PaymentPlanPatched]: 'Payment plan updated',
        [BlameLogType.PaymentPlanDelete]: 'Payment plan deleted',
        [BlameLogType.CaseVoucherMoved]: 'Voucher moved',
        [BlameLogType.TribunalCaseCreate]: 'Tribunal case created',
        [BlameLogType.TribunalJobCreate]: 'Tribunal job created',
        [BlameLogType.TribunalJobPatch]: 'Tribunal job updated',
        [BlameLogType.TribunalJobDelete]: 'Tribunal job deleted',
        [BlameLogType.DocumentUpload]: 'Document uploaded',
        [BlameLogType.DocumentDelete]: 'Document deleted',
        [BlameLogType.DocumentSigned]: 'Document signed',
        [BlameLogType.ImportCreated]: 'Import created',
        [BlameLogType.ImportRun]: 'Import run',
        [BlameLogType.DeleteUpdate]: 'Task deleted',
        [BlameLogType.ConnectorBillingUpdate]: 'Billing model changed',
        [BlameLogType.CreditorSettingsUpdate]: 'Creditor settings changed',
        [BlameLogType.BulkAction]: 'Bulk action',
        [BlameLogType.FixedDistributionCreate]: 'Distribution created',
        [BlameLogType.FixedDistributionUpdate]: 'Distribution updated',
        [BlameLogType.FixedDistributionDelete]: 'Distribution deleted',
    },
    caseTypes: {
        [CaseType.CLIENT]: 'Creditor case',
        [CaseType.TENANT]: 'Tenant case',
    },
    cases: {
        case: 'Case',
        customerReferenceId: 'Referenceno.',
        creditor: 'Creditor',
        debt: 'Original',
        deposits: 'Deposits',
        balance: 'Debt',
        status: 'Case status',
        caseVoucher: 'Case voucher',
        amount: 'Amount',
        workflow: 'Workflow',
        responsible: 'Responsible',
        showAll: 'Show all',
        caseInfo: 'Case Info',
        cases: 'Cases',
        createNewCase: 'Create new case',
        caseOverview: 'All cases',
        casesLeft: 'Cases left',
        casePaused: 'Case paused',
        dueDateIsIn: 'Due date is in',
        days: 'days',
        pressCommandOrCtrlToContinue: 'Press command or control to also continue the case.',
        source: 'Source',
        sourceClient: 'The case originates from this case',
        referenceId: 'Creditor reference id',
        createdAt: 'Creation date',
        caseState: {
            [CaseState.ALL]: 'All cases',
            [CaseState.ACTIVE]: 'Active cases',
            [CaseState.CLOSED]: 'Closed cases',
        },
        caseStatus: {
            [CaseStatus.VERIFIED]: 'Verified',
            [CaseStatus.PENDING]: 'Pending',
            [CaseStatus.ENDED]: 'Ended',
        },
        settings: 'Case settings',
        caseSettings: {
            disableDebtorPaymentPlan: 'Disable debtor payment plan',
        },
        VERIFIED: 'Verified',
        PENDING: 'Pending',
        ENDED: 'Ended',
        dunning: 'Dunning',
        debtCollection: 'Debt collection',
        verify: 'Verify',
        end: 'End',
        reVerify: 'Re-Verify',
        endCase: 'End case',
        choosEndReason: 'Choose end reason',
        caseGroup: 'Case Group',
        pause: 'Pause',
        pauseCase: 'Pause case',
        pauseReason: 'Pause reason',
        pauseComment: 'Comment',
        blameLog: 'Action log',
        logged: 'Action',
        ago: 'ago',
        newCase: 'Create new case',
        caseReferenceId: 'Creditors reference id',
        invoiceId: 'Invoice ID',
        file: 'Invoice pdf',
        debtorName: 'Name',
        address: 'Address',
        phone: 'Phone number',
        email: 'Email',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Debtor has opposed',
        isCompany: 'Debtor is a company',
        theDetails: 'Info',
        theDebt: 'The debt',
        theDebtor: 'Debtor',
        manual: 'Manually',
        fromFile: 'From file',
        dropFile: 'Drop invoice here',
        clickHereToUpload: 'Or upload',
        addDebt: 'New invoice',
        issueDate: 'Invoice issue date',
        dueDate: 'Invoice due date',
        sendNoteToCollector: 'Send message to collector',
        sendNoteToCollectorButton: 'Send',
        note: 'Note',
        caseHasBeenDeleted: 'Case has been deleted',
        missingCreateAccess: 'The agreement has been ceased and therefore no new cases can be created. Contact us for more information',
        newCaseCreate: 'Case info',
        newCaseEconomy: 'Economy',
        newCaseDone: 'Done',
        noDebts: 'No debts',
        noDebtsExplainer: "Add debt using the '+' button",
        newCaseCreateExplainer: 'You are currently creating a new case. You can insert the custumer number from your system here. If the case is in another currency than Danish, you can also choose this here.',
        newCaseEconomyExplainer: 'Your case is now created, and below the economy of the case should be added. If you have created the case but need to undo it, we recommend that you contact us for deletion of the case.',
        newCaseCreationWarning: 'When you click further, the case will be created in the system. If you do not have all the information to create the case, it is recommended that you do not continue until you have all the information about the debt and debtor',
        deleteCase: 'Delete case',
        sureYouWantToDeleteCase: 'Are you sure you want to delete this case?',
    },
    mergeCases: {
        header: 'Merge this case with another',
        explanation: 'Merge this case with another case selected below. Vouchers will automatically be transferred to the target case and this case will be ended with end reason "Case is merged"',
        searchPlaceholder: 'Search for target case on same creditor',
        mergeBtn: 'Merge cases',
        undoCaseMerge: 'Undo case merge',
    },
    customers: {
        party: 'party',
        addParty: 'Add party',
        contact: 'Contact person',
        selectType: 'Select type',
        errorEmailValidation: 'Invalid email',
        errorCPRValidation: 'Invalid CPR',
        errorCVRValidation: 'Invalid CVR',
        noContactSelected: 'No contact person selected',
        noContact: 'No contact',
        noRelatedCases: 'No related cases',
        customer: 'Customer',
        createdAt: 'Created',
        casesOnCreditor: 'Cases on customer',
        thatIsRelatedTo: 'that is related to customer reference',
        casesRelatedToCustomerDescription: 'Cases matched on email, CPR, CVR or via external sources.',
        information: 'Information',
        casesOnCustomer: 'Cases on customer',
        relatedCases: 'Related cases',
        caseStatus: 'Status',
        relationType: 'Relation',
        creditor: 'Creditor',
        case: 'Case',
        customerHasBeenDeleted: 'Customer has been deleted',
        parties: 'Parties',
        customerReferenceId: 'Customer reference id',
        private: 'Private person',
        company: 'Company',
        existingCustomer: 'Existing customer',
        backToCase: 'Back to case',
        referenceId: 'Reference id',
        alternativeContactReferenceId: 'Alternative contact reference id',
        secondaryEntityDisabled: 'Inactive',
        addSecondaryEmails: 'Add one or more secondary emails',
        note: 'Optional note',
        addSecondaryEmail: 'Add secondary email',
        addSecondaryPhones: 'Add one or more secondary phone numbers',
        addSecondaryPhone: 'Add secondary phone number',
        enabled: 'Active',
        save: 'Save',
        createNewCaseOnCustomer: 'Add case on customer',
        copyCaseIds: 'Copy case numbers',
        notes: {
            title: 'Notes',
            addNote: 'Add a note',
            noNotes: 'No notes',
            edit: 'Edit',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            deleteConfirm: 'Delete this note?',
            editPlaceholder: 'Note text',
            noDebtor: 'No debtor on this customer',
        },
    },
    assets: {
        note: 'Note',
        assets: 'Assets',
        realEstate: 'Real estate',
        vehicles: 'Vehicles',
        other: 'Other assets',
        noAssets: 'No assets registered',
        addAsset: 'Add asset',
        editAsset: 'Edit asset',
        deleteAsset: 'Delete asset',
        confirmDelete: 'Are you sure you want to delete this asset?',
        description: 'Description',
        estimatedValue: 'Estimated value',
        bfeNumber: 'BFE number',
        address: 'Address',
        zipcode: 'Zip code',
        city: 'City',
        registrationNumber: 'Registration number',
        brand: 'Brand',
        model: 'Model',
        variant: 'Variant',
        year: 'Year',
        lienType: 'Lien type',
        source: 'Source',
        notSubscribed: 'Customer is not subscribed to Cosmo',
        type: 'Type',
        realEstateType: 'Real estate',
        vehicleType: 'Vehicle',
        taxType: 'Tax',
        otherType: 'Other',
        owners: 'Owners',
        liens: 'Liens',
        transactions: 'Transactions',
        currency: 'Currency',
        save: 'Save',
        cancel: 'Cancel',
        administrator: 'Administrator',
        creditor: 'Creditor',
        date: 'Date',
        amount: 'Amount',
        totalLiens: 'Total liens',
        noLiens: 'No liens registered',
        noTransactions: 'No transactions registered',
        lienCountSuffix: 'liens',
        assetCountSuffix: 'assets',
        thisCreditor: 'This creditor',
        linkedCase: 'Case',
        otherDistraints: 'Other attachments',
        transferDate: 'Transfer date',
        transferMethod: 'Transfer method',
        purchaseSum: 'Purchase price',
        conditional: 'Conditional',
        summary: 'Summary',
        netWorth: 'Estimated net worth',
        totalEstimatedValue: 'Total estimated value',
        loanToValue: 'Loan-to-value',
        liensToThisCreditor: 'Liens to this creditor',
        addLien: 'Add lien',
        editLien: 'Edit lien',
        registrationDate: 'Registration date',
        priority: 'Priority',
        missingCreditorRegisterId: 'This creditor has no central register ID — set one before adding liens.',
        interestRate: 'Interest rate (%)',
        interestType: 'Interest type',
        contributionRate: 'Contribution rate (%)',
        totalTermYears: 'Total term (years)',
        interestOnlyYears: 'Interest-only period (years)',
        termShort: 'Term',
        interestOnlyShort: 'IO period',
        yearsShort: 'yr',
        outstandingBalances: 'Outstanding balances',
        outstandingBalance: 'Outstanding balance',
        outstandingBalanceDate: 'Balance checked date',
        expectedOutstanding: 'Expected outstanding',
        assumedTooltip: 'Estimated value',
        addOutstandingBalance: 'Add outstanding balance',
        noOutstandingBalances: 'No outstanding balances recorded',
        remove: 'Remove',
        assetRegistrationNumber: 'Reg. no.',
        assetModelYear: 'Model year',
        ownershipShare: 'Ownership share',
        ownershipNotConfirmed: 'Ownership not confirmed',
        bfeAmbiguousOwner: 'Property data unavailable',
        notSubscribedDescription: 'The customer is no longer monitored, so these assets are a snapshot from when monitoring stopped and cannot be edited.',
        bfeAmbiguousOwnerDescription: 'Multiple persons with this name found in the property registry. Add a birthdate to the debtor to resolve.',
        proportionalValue: "Debtor's share value",
        debtors: 'Debtors',
        totalLabel: 'total',
        showHiddenLiens: 'Show hidden liens',
        hideHiddenLiens: 'Hide hidden liens',
        lienTypes: {
            [LienType.Attachment]: 'Attachment',
            [LienType.Mortgage]: 'Mortgage',
            [LienType.OwnerNote]: "Owner's mortgage deed",
            [LienType.PrivateNote]: 'Private mortgage deed',
            [LienType.PrivateIndexLinkedMortgage]: 'Private index-linked mortgage deed',
            [LienType.Other]: 'Other',
            [LienType.Unknown]: 'Unknown',
        },
        interestTypes: {
            [InterestType.Variable]: 'Variable',
            [InterestType.Fixed]: 'Fixed',
        },
        transferMethods: {
            FREE_SALE: 'Free sale',
            FORCED_AUCTION: 'Forced auction',
            INHERITANCE: 'Inheritance',
            GIFT: 'Gift',
            FAMILY_TRANSFER: 'Family transfer',
            EXCHANGE: 'Exchange',
            OTHER: 'Other',
        },
        valuations: 'Valuations',
        assetOverview: 'Asset overview',
        equity: 'Equity',
        viewAllAssets: 'View all assets',
        valuationSources: {
            [ValuationSource.PublicAssessment]: 'Public assessment',
            [ValuationSource.LastSale]: 'Last sale',
            [ValuationSource.Manual]: 'Manual',
        },
    },
    customerCaseRelationType: {
        [RelationType.CPR]: 'CPR',
        [RelationType.CVR]: 'CVR',
        [RelationType.Cosmo]: 'External',
        [RelationType.CustomerReferenceId]: 'Customer ref.',
        [RelationType.Email]: 'Email',
        [RelationType.NameAddress]: 'Name/addr.',
    },
    debtors: {
        private: 'Private',
        company: 'Company',
        addAlternativeContact: 'Add alternative contact',
        debtor: 'Debtor',
        alternativeContact: 'Alternative contact person',
        ownsCompany: 'Owns company',
        movedAbroad: 'Moved abroad',
        ownsCompanies: 'Owns companies',
        rkiRegistrations: 'RKI registrations',
        confirmDeleteUserFromCustomer: 'Are you sure you want to delete this user from the customer?',
        companyStatus: 'Company status',
        otherCasesOnDebtorTooltip: 'Debtor is associated with multiple cases',
        otherCasesOnDebtor: 'Other case',
        otherCasesOnDebtorPlural: 'other cases',
        movedTo: 'Moved to',
        debtors: 'Debtors',
        aksFailed: 'AKS Failed',
        cprStatus: 'CPR-status',
        status: {
            [PrivateStarCycle.Active]: 'Active',
            [PrivateStarCycle.Dead]: 'Dead',
            [PrivateStarCycle.Disappeared]: 'Disappeared',
            [PrivateStarCycle.Homeless]: 'Homeless',
            [PrivateStarCycle.GoneAway]: 'Moved abroad',
            [PrivateStarCycle.ForTaxReason]: 'Personal tax number',
            [PrivateStarCycle.NotVerified]: 'Unverified',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inactive',
            [CompanyStarCycle.OperationsCeased]: 'Operations ceased',
            [CompanyStarCycle.ShelfCompany]: 'Shelf company',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under liquidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Dissolved after liquidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Involuntary dissolution',
            [DissolvedStatus.Dissolved]: 'Dissolved',
            [DissolvedStatus.Unknown]: 'Unknown dissolution status',
            [DissolvedStatus.Voluntary]: 'Under voluntary liquidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under voluntary liquidation (declaration)',
            [DissolvedStatus.Forced]: 'Under forced dissolution',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Dissolved after declaration',
            [DissolvedStatus.DissolvedAfterMerger]: 'Dissolved after merger',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Dissolved after demerger',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Dissolved after bankruptcy',
            [DissolvedStatus.Ceased]: 'Ceased',
        },
        dissolutionStatus: 'Dissolution status',
        addressProtection: 'Address and name protection',
        addressProtectionShort: 'Protected',
        addDebtor: 'Add debtor',
        guardian: 'Guardian',
        relatedCases: 'related cases',
        relatedCasesDescription: 'Number of related cases that are verified / total number of related cases',
        otherCases: 'other cases',
        otherCasesDescription: 'Number of verified cases for the customer / total number of cases',
    },
    emailValidations: {
        risk: 'Risk',
        emailRisk: 'Email risk',
        didYouMean: 'Did you mean',
        isDisposableAddress: 'Is disposable email',
        isRoleAddress: 'Is role email',
        high: 'High',
        medium: 'Medium',
        low: 'low',
        unknown: 'Unknown',
        no_mx: 'No MX records',
        unknown_provider: 'Unknown email provider',
        high_risk_domain: 'High risk domain',
        subdomain_mailer: 'Subdomain mailer',
        immature_domain: 'Immature domain',
        tld_risk: 'The domain is registered high risk',
        mailbox_does_not_exist: 'Email does not exist',
        mailbox_is_disposable_address: 'Email is disposable',
        mailbox_is_role_address: 'Mailbox is role email',
        catch_all: 'Catch all',
        long_term_disposable: 'Long term disposable email',
    },
    phoneValidation: {
        mobile: 'Mobile',
        landline: 'Landline',
        landline_premium: 'Landline',
        landline_tollfree: 'Landline',
        virtual: 'Virtual',
        unknown: 'Unknown',
        pager: 'Pager',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Debtor info',
        debtorCreatedAt: 'Debtor Created At',
        company: 'Company',
        male: 'Male',
        female: 'Female',
        private: 'Private',
        activated: 'activated',
        subscribed: 'subscribed',
        failed: 'failed',
        movedTo: 'Moved to',
        description: 'Description',
        addDescription: 'Add description',
        name: 'Name',
        email: 'Email',
        noEmailAddr: 'No email address',
        phone: 'Phone',
        noAddr: 'No address',
        address: 'Address',
        letterReturned: 'Letter returned',
        cannotReceive: 'Cannot receive',
        deliverabilityFailedAt: 'Last delivery failed',
        deliverabilityChannels: {
            eboks: 'e-Boks',
            letter: 'Letter',
            eInvoice: 'E-invoice',
        },
        deliverabilityVia: {
            eboksName: 'Could not be delivered by name and address',
            eboksRegisterId: 'Could not be delivered by CPR/CVR',
            letter: 'Could not be delivered to the address',
            eInvoice: 'Could not be delivered to',
        },
        cpr: 'CPR',
        cvr: 'CVR',
        registryIdentifier: 'Central register ID',
        addressProtection: 'Address and name protection',
        addressProtectionShort: 'Protected',
        jurisdiction: 'Jurisdiction',
        noJurisdiction: 'No jurisdiction',
        chooseJurisdiction: 'Choose jurisdiction',
        status: {
            [PrivateStarCycle.Active]: 'Active',
            [PrivateStarCycle.Dead]: 'Dead',
            [PrivateStarCycle.Disappeared]: 'Disappeared',
            [PrivateStarCycle.Homeless]: 'Homeless',
            [PrivateStarCycle.GoneAway]: 'Moved abroad',
            [PrivateStarCycle.ForTaxReason]: 'Personal tax number',
            [PrivateStarCycle.NotVerified]: 'Unverified',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inactive',
            [CompanyStarCycle.OperationsCeased]: 'Operations ceased',
            [CompanyStarCycle.ShelfCompany]: 'Shelf company',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under liquidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Dissolved after liquidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Involuntary dissolution',
            [DissolvedStatus.Dissolved]: 'Dissolved',
            [DissolvedStatus.Unknown]: 'Unknown dissolution status',
            [DissolvedStatus.Voluntary]: 'Under voluntary liquidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under voluntary liquidation (declaration)',
            [DissolvedStatus.Forced]: 'Under forced dissolution',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Dissolved after declaration',
            [DissolvedStatus.DissolvedAfterMerger]: 'Dissolved after merger',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Dissolved after demerger',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Dissolved after bankruptcy',
            [DissolvedStatus.Ceased]: 'Ceased',
        },
        dissolutionStatus: 'Dissolution status',
        save: 'Save',
        remove: 'Remove',
        birthdate: 'Birthdate',
        noBirthdate: 'No birthdate',
        yearsOld: 'years old',
        companyForm: 'Company form',
        industry: 'Industry',
        employees: 'Employees',
        companyStatus: 'Company status',
        website: 'Website',
        dateOfFoundation: 'Date of foundation',
        quantifyOfPUnits: 'Quantity of P-Units',
        powerToBind: 'Power to bind',
        adProtected: 'Advertisement protected',
        cars: 'Cars',
        from: 'From',
        liabilities: 'Liabilities',
        priority: 'Priority',
        interest: 'Interest',
        properties: 'Properties',
        toilet: 'Toilet',
        roof: 'Roof',
        bath: 'Bath',
        built: 'Built',
        rkiRegis: 'RKI registrations',
        administrator: 'Administrator',
        disclosureDate: 'Disclosure date',
        deleted: 'deleted',
        toBedeleted: 'deleted',
        companyRelations: 'Company Relations',
        roles: 'Roles',
        accountableParticipant: 'Accountable participant',
        director: 'Director',
        executiveBoard: 'Executive board',
        beneficialOwner: 'Beneficial owner',
        founder: 'Founder',
        owner: 'owner',
        stakeholder: 'Stakeholder',
        chairperson: 'Chairperson',
        managingDirector: 'Managing director',
        boardMember: 'Board member',
        equityTier: 'Equity tier',
        viceChairperson: 'Vice chairperson',
        rightToVote: 'Right to vote',
        audit: 'Audit',
        specialOwnership: 'Special ownership',
        previous: 'Previous',
        noPreviousToShow: 'No previous to show',
        backTo: 'Back to',
        casesOnThisDebtor: 'Cases on this debtor',
        guardianName: 'Guardian name',
        guardianAddress: 'Guardian address',
        guardianStartDate: 'Guardian start date',
    },
    debtorWebHome: {
        dear: 'Dear',
        representative: 'We have registered that you have entered as a representative of debtor.',
        you: 'You',
        debtor: 'Debtor',
        owe: 'owe',
        to: 'to',
        youCanDoThisHere: 'You can pay on this page, signup for a payment plan or update your contact information. You are also welcome to send us a message if you have any questions.',
        yourInfo: 'Your information',
        name: 'Name',
        informName: 'Inform name',
        email: 'Email',
        informEmail: 'Inform email',
        phone: 'Phone',
        informPhone: 'Inform phone',
        address: 'Address',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Inform address',
        confirmation: 'I confirm that my information is correct.',
        updateButton: 'Update information',
        confirm: 'Confirm',
        faq: 'Frequently asked questions',
        contactUs: 'Contact us',
        contactUsText: 'Feel free to send us an email, call us or send a message through the textarea below.',
        yourMessage: 'Your message',
        enterEmail: 'Enter email to send a message',
        send: 'Send',
        logout: 'Log out',
        privacyPolicy: 'Privacy policy',
        businessTerms: 'Business terms',
        paymentMethods: 'Payment methods',
        payWithFI: 'Pay with FI number',
        paySafeWithFI: 'Pay safely with the following FI number:',
        payWithIBAN: 'Pay with IBAN',
        paySafeWithIBAN: 'Pay safely with IBAN from your bank:',
        payWithSWIFT: 'Pay with SWIFT',
        paySafeWithSWIFT: 'Pay safely with SWIFT from your bank:',
        payWithBankTransfer: 'Pay with bank transfer',
        registrationNumber: 'Registration no.',
        accountNumber: 'Account no.',
        payWithBankTransferText: 'Make a deposit to our account:',
        payWithBankTransferInfo: 'Remember to refer to j.no.',
        or: 'Or',
        iApprove: 'I accept the',
        theBusinessTerms: 'business terms',
        pleaseAcceptBusinessTerms: 'You must accept the business terms before you can proceed to the payment page.',
        payWithCardButton: 'Pay with card',
        createAPaymentPlan: 'Create a payment plan',
        fullPayment: 'Full payment',
        partialPayment: 'Partial payment',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Back to case',
        paymentPlanOn: 'Payment plan on case',
        selectPlan: 'Select payment plan',
        chooseDifferentPlan: 'Choose a different payment plan',
        sign: 'Sign agreement',
        gatherInfo: 'Enter information',
        paymentMethod: 'Select payment method',
        approval: 'Confirmation',
        info: 'Info',
        paymentPlan: 'Payment plan',
        firstPayment: 'First payment',
        entry: 'entry',
        lastPayment: 'Last payment',
        signedDoc: 'Signed document',
        needHelp: 'Need help?',
        orPay: 'Or pay the entire debt',
        pay: 'Pay the entire debt',
        months: 'Months',
        month: 'month',
        total: 'Total payment',
        select: 'Select',
        noOptions: 'Unfortunately, it is not possible to set up a payment plan.',
        signTextOne: 'In order to sign up for a payment plan with',
        signTextTwoAlternativeContact: 'debtor have to sign the following agreement.',
        signTextTwoDebtor: 'you have to sign the following agreement.',
        signTextThree: 'Before you can sign the agreement, you must enter your information.',
        agreement: 'Sign agreement',
        agreementTitle: 'Agreement',
        approvalText: 'Congratulations. You have entered into a payment plan.',
        paymentMethodText: 'We will take care of your card information and make it easy for you to sign up for automatic payment.',
        connectCard: 'Connect payment method',
        automaticPaymentMethod: 'Automatic payment method',
        manualBankTransferTitle: 'Prefer a manual bank transfer?',
        manualBankTransferHint: 'You can instead make a manual bank transfer. Bank details are available on the case overview.',
        securePaymentHint: 'Secure payment',
        deleteCardToChange: 'You can change/delete the selected card by clicking the delete card button.',
        deleteCard: 'Delete card',
        paymentPlanEntries: 'Payment plan installments',
        progressTitle: 'Your payment plan',
        progressPaid: 'Paid',
        progressRemaining: 'Remaining',
        progressNext: 'Next installment',
        progressComplete: 'Payment plan complete',
        progressOf: 'of',
        amount: 'Amount',
        date: 'Date',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Paid',
            [PaymentPlanEntryStatus.CANCELED]: 'Defaulted',
            [PaymentPlanEntryStatus.PENDING]: 'Future',
            [PaymentPlanEntryStatus.REMINDED]: 'Reminded',
            [PaymentPlanEntryStatus.AWAITING]: 'Awaiting',
            [PaymentPlanEntryStatus.OVERDUE]: 'Overdue',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Error settle',
        },
    },
    paymentPlanEntryStatuses: {
        [PaymentPlanEntryStatus.SETTLED]: 'Paid',
        [PaymentPlanEntryStatus.CANCELED]: 'Defaulted',
        [PaymentPlanEntryStatus.PENDING]: 'Future',
        [PaymentPlanEntryStatus.REMINDED]: 'Reminded',
        [PaymentPlanEntryStatus.AWAITING]: 'Awaiting',
        [PaymentPlanEntryStatus.OVERDUE]: 'Overdue',
        [PaymentPlanEntryStatus.ERRORSETTLED]: 'Error settle',
    },
    chains: {
        nextStep: 'Next step',
    },
    chainGroups: {
        dunningChain: 'Dunning workflow',
        chain: 'Workflow',
        add: 'Add',
        delete: 'Delete',
        configure: 'Configure workflows for case groups',
        caseGroup: 'Case group',
    },
    migration: {
        migrateData: 'Migrate data',
        modalHeader: 'Migrate data',
        uploadErrorMessage: 'An error occured, check the file is correct and try again',
    },
    creditorStateDescriptions: {
        [CreditorState.Lead]: 'Creditors which is being set up, but have not yet got access to the creditor web.',
        [CreditorState.SignedOn]: 'Creditors which is not yet active customers, but wants a demo of the creditor web.',
        [CreditorState.Active]: 'Active creditors that uploads new cases and have full access to the creditor web.',
        [CreditorState.Ceased]: 'Creditors which is cancelled, but still have active cases to follow.',
        [CreditorState.Cancelled]: 'Creditors which is cancelled and should not anymore have access to the creditor web.',
    },
    creditors: {
        creditor: 'Creditor',
        creditors: 'Creditors',
        creditorInfo: 'Creditor Information',
        allCreditors: 'All creditors',
        searchCreditors: 'Search creditors',
        newCreditorInfo: 'Creditor Info',
        newCreditorEconomy: 'Economy',
        newCreditorChains: 'Workflows',
        newCreditorUsers: 'Users',
        newCreditorDone: 'Done',
        states: {
            [CreditorState.Active]: 'Active',
            [CreditorState.Lead]: 'Lead',
            [CreditorState.SignedOn]: 'Signed on',
            [CreditorState.Cancelled]: 'Cancelled',
            [CreditorState.Ceased]: 'Ceased',
        },
        downloadOverview: 'Download overview',
        newCreditor: 'New creditor',
        defaultBillingModelDescription: 'Select billing model that new cases should be initialized with. All cases can have its own billing model. When creating a new case it will be created with the creditors standard billing model.',
        tenantInheritedBillingModelDescription: "If you do not select a default billing model cases will be created with the tenants' default billing model",
        tenantInheritedDunningConnectorDescription: "If you do not select a default billing model cases will be created with the tenants' default dunning billing model",
        chainsHeader: 'Select default workflows',
        chainsDescription: 'Select which workflow new cases should be created with. All cases can have its own workflow. When creating a new case it will be created with the creditors standard workflow.',
        usersNewHeader: 'Create login for creditors',
        usersCreditorHeader: 'Choose responsible users',
        next: 'Next',
        previous: 'Previous',
        setCreditorState: 'Set creditor state',
        cvr: 'CVR',
        company: 'Company',
        person: 'Person',
        vatRegistered: 'VAT registered',
        notVatRegistered: 'Not VAT registered',
        acquisitionResponsible: 'Acquisition Responsible',
        selectAcquiRespon: 'Select Acquisition Responsible',
        contact: 'Contact',
        selectContact: 'Select Contact',
        caseworkerContact: 'Caseworker Contact',
        selectCaseworkerContact: 'Select Caseworker Contact',
        none: 'None',
        createCreditor: 'Create Creditor',
        reference: 'Reference',
        name: 'Name',
        selectDefaultCollector: 'Select Default Collector',
        status: 'Status',
        active: 'Active',
        lead: 'Lead',
        selectClientContact: 'Select creditor contact',
        isCompany: 'Is company',
        create: 'Create',
        createdAt: 'Creation date',
        quantityCases: 'Cases count',
        referenceId: 'No.',
        wincentAvgPrediction: 'Wincent avg. score',
        selectDefaultChain: 'Select default workflow',
        defaultChain: 'Workflow',
        selectDefaultClientChain: 'Select default workflow',
        defaultClientChain: 'Dunning workflow',
        mandates: 'Mandates',
        mandatesPlaceholder: 'Empty',
        experianClientId: 'Experian client id',
        updateExperianClientId: 'Update client id',
        requestClientIdExperian: 'Request Experian a client id',
        requestClientIdExperianSuccess: 'Experian has been requested and will automatically type in the client id.',
        erpLink: "Link to creditors' ERP system",
        updateErpLink: 'Update link',
        aksEnabled: 'AKS activated',
        advokatindestaaelse: 'Advokatindestaaelse for open RKI',
        debitorRegistretCreditorNumber: 'Creditor number in Debitor Registret',
        debitorRegistretCreateCreditor: 'Create creditor in Debitor Registret',
        debitorRegistretCreateCreditorDescription: 'Creates the creditor in Debitor Registret and saves the creditor number.',
        debitorRegistretCreateCreditorSuccess: 'The creditor was created in Debitor Registret.',
        debitorRegistretCreateCreditorSkipped: 'The creditor is already created in Debitor Registret.',
        bankAccountDetails: 'Bank account details',
        updateBankAccountDetails: 'Update account',
        autoRKI: 'Auto debt registration',
        automaticDebtRegister: 'Override automatic register',
        useAutomaticDebtRegister: 'Set automatic registration on creditor',
        useAutoRegisterInOpenRegistry: 'Set open registry on creditor',
        useAutoIgnoreUnresolvedOppositions: 'Set ignore unresolved interactions (disputes) on creditor',
        selfCollection: 'Self collection',
        useSelfCollectionOption: 'Set self collection on creditor',
        outboundCall: 'Outbound call',
        useOutboundCallOption: 'Set outbound call on creditor',
        autoVerify: 'Auto verify cases',
        useAutoVerifyOption: 'Set auto verify on creditor',
        paymentTerms: 'Payment terms',
        paymentDays: 'Payment days',
        billingRecipients: 'Billing recipients',
        billingRecipientsDescription: 'Set multiple emails like this',
        automaticExpireVouchers: 'Override automatic expiration of vouchers',
        useAutomaticExpireVouchers: 'Set automatic expiration of vouchers on creditor',
        configurationOptions: 'Configurations',
        debtRegisterConfig: 'Debt registration',
        courtSubmitConfig: 'Configuration for automatical court submission',
        foundationExpiration: 'Expiration with foundation',
        normalExpiration: 'Expiration without foundation',
        interestExpiration: 'Interest expiration',
        debtorFAQ: 'Frequently asked questions (shown in debtor web)',
        faqHeader: 'Need help creating a new creditor?',
        faqText: 'We have made an article about how to do so. Click the botton below to read more.',
        newUserDisabled: 'New users cannot be created with current creditor state',
        cancelledError: 'Access has been cancelled',
        cancelledErrorMessage: 'Your access is cancelled. Contact us for more information.',
        eInvoice: {
            eInvoice: 'E-invoice',
            companyId: 'Company id',
            identification: 'Identification number',
            addChildCompany: 'Add as child company',
        },
        creditorCreationDisabled: 'Creditor creation is disabled',
        creditorCreationDisabledDescription: 'Creditors cannot be created from the user interface',
        moveCasesToNewCreditor: 'Move cases to new creditor',
        moveCases: 'Move cases',
        noCreditors: 'No creditors',
    },
    collectorTypes: {
        [CollectorType.CREDITOR]: 'Creditor',
        [CollectorType.TENANT]: 'Collector',
    },
    collectors: {
        collector: 'Collector',
        updateEntity: 'Save',
        masterData: 'Information',
        layout: 'Layout',
        websites: 'Websites',
        legal: 'Legal',
        paymentOptions: 'Payment option',
        communicationChannels: 'Communication channels',
        namePlaceholder: 'Name',
        centralRegisterIdPlaceholder: 'Local company registration number',
        nicknamePlaceholder: 'Nickname',
        addressPlaceholder: 'Address',
        logoFileIdPlaceholder: 'Logo',
        letterFrontLogoFileIdPlaceholder: 'Logo used on first page of letters',
        websitePlaceholder: 'Website',
        clientWebBasePlaceholder: 'Creditor web base',
        debtorWebBasePlaceholder: 'Debtor web base',
        titlePlaceholder: 'Company title',
        privacyPolicyPlaceholder: 'Privacy policy',
        businessTermsPlaceholder: 'Business Terms',
        emailPlaceholder: 'Email',
        replyToPlaceholder: 'Reply-to email',
        phonePlaceholder: 'Phone',
        paymentOptionsPlaceholder: 'Payment options',
        themePlaceholder: 'Theme',
        hideEmail: 'Hide email',
        secondaryCollector: 'Secondary collector',
        addSecondaryCollector: 'Add secondary collector',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Unfortunately, we cannot offer you any payment plans online. Please contact the debt collector.',
        paymentPlansDisabled: 'Payment plans disabled',
        paymentPlanDisabledForDebtor: 'Debtor can not create payment plans. See case settings',
        paymentPlan: 'Payment plan',
        signing: 'Entering into payment plans',
        signedFoundation: 'The debtor signs a foundation of debt',
        signedFoundationDescription: 'The payment plan becomes active once the debtor has signed in the debtor web.',
        noSignature: 'No signature',
        noSignatureDescription: 'The payment plan is active as soon as it is created.',
        foundationTemplate: 'Foundation template',
        defaultFoundation: 'Default foundation',
        skipTo: 'Skip to',
        editPaymentPlan: 'Edit payment plan',
        editPaymentPlanDescription: 'Adjust the entry amount, duration or interval. Already paid entries are kept.',
        editPaymentPlanHint: 'The {count} entries that have already been paid are kept. Only future entries are replaced with the new plan.',
        collapsedEntries: 'collapsed entries',
        deletePaymentPlan: 'Delete payment plan',
        progress: 'Progress',
        selectPaymentPlan: 'Select payment plan',
        signPaymentPlan: 'Sign payment plan',
        selectPaymentMethod: 'Select payment method',
        confirmation: 'Confirmation',
        createNewPaymentPlan: 'Create new payment plan',
        months: 'months',
        month: 'month',
        totalPayment: 'Total repayment',
        createCustomPlan: 'Create Custom Payment Plan',
        createStandardPlan: 'Create Standard Payment Plan',
        byAmount: 'By amount',
        byDuration: 'By duration',
        monthly: 'Monthly',
        everyOtherMonth: 'Two months',
        quarterly: 'Quarterly',
        yearly: 'Yearly',
        everyOtherWeek: 'Two weeks',
        weekly: 'Weekly',
        lastBankDayOfMonth: 'Last bank day of month',
        rest: 'Rest',
        generate: 'Generate',
        entries: 'Entries',
        entry: 'Entry',
        date: 'Date',
        reminder: 'Reminder',
        lastChanceOfPayment: 'Last chance',
        addedInterests: 'Added interests',
        cancelled: 'Defaulted',
        amount: 'Amount',
        confirmationCheckbox: 'Send confirmation when payment plan is activated',
        activate: 'Activate',
        cancel: 'Cancel',
        agreement: 'Agreement',
        inputAmount: 'Type in the amount.',
        details: 'Details',
        createPaymentPlan: 'Create payment plan',
        activatePaymentPlanWithoutFoundation: 'Activate payment plan without foundation.',
        errorCaseEnded: "Can't create payment plan: case has ended",
        paymentEntryText: 'Payment of',
        yearlyAPR: 'year APR',
        before: 'before',
        CREATED: 'Created',
        ACTIVE: 'Active',
        FINISHED: 'Finished',
        CANCELED: 'Canceled',
        DELETED: 'Deleted',
        errorInInput: 'Error in input',
        save: 'Save',
        calculationFoundation: 'Amount or duration',
        calculationFoundationDescription: "Select the payment plan's calculation basis. Either an amount or the number of entries.",
        calculateByAmount: 'Calculate based on an amount',
        calculateByDuration: 'Calculate based on a duration',
        addScheduledAmountChange: '+ Adjust later installments',
        scheduledAmountChangeFromDate: 'From date',
        createdAt: 'Created',
        startDate: 'Start date',
        startDateDescription: 'Payment date for the first entry.',
        upfrontPayment: 'Upfront payment',
        upfrontPaymentDescription: 'If an upfront payment that shows willingness to pay is needed, it can be switched on here.',
        upfrontPaymentDate: 'Date for upfront payment',
        interval: 'Interval',
        intervalDescription: 'Choose the timespan between payment plan entries.',
        interestFree: 'Interest free period',
        interestFreeDescription: 'If an interest free period is needed it can be selected here.',
        interestFreeFrom: 'From',
        interestFreeTo: 'To',
        interestFreeOnDefault: 'If the plan is defaulted',
        interestFreeOnDefaultKeepFrozen: 'Keep the period interest free, interest resumes from the default date',
        interestFreeOnDefaultReapply: 'Reapply the waived interest from the period',
        settlement: 'Settlement (accord)',
        settlementDescription: 'The debtor pays an agreed reduced total; the remainder is forgiven when the plan completes.',
        settlementEnable: 'Settle for less than the full debt',
        settlementAgreedTotal: 'Agreed total',
        settlementPercentOfBalance: 'Percent of balance',
        settlementAmountForgiven: 'Amount forgiven',
        settlementCurrentBalance: 'Current balance',
        settlementSettledSoFar: 'Settled so far',
        settlementRemainingToPay: 'Remaining to pay',
        settlementForgivenOnCompletion: 'Forgiven on completion',
        settlementSummary: 'The debtor pays {total} of {balance} ({percent}%)',
        settlementExceedsBalance: 'The agreed total must be less than the current balance',
        fees: 'Fees',
        feesDescription: 'Add optional fees to the payment plan.',
        initialFee: 'Initial fee',
        initialFeeDescription: 'Add a one-time fee when the payment plan starts.',
        perEntryFee: 'Per entry fee',
        perEntryFeeDescription: 'Add a fee for each payment plan entry.',
        selectVoucherType: 'Select voucher type',
        selectVoucherTypeRequired: 'Select a voucher type to apply this fee',
        defaultFees: 'Default fees',
        defaultFeesDescription: 'Configure default fees that will be applied to new payment plans.',
        feesWillBeApplied: 'Fees will be applied',
        overrideFees: 'Override fees on creditor',
        moreSettings: 'More settings',
        detailsWarning: 'This plan shows the case development if the plan is followed. Deviations may occur if, for example, payment dates differ from the installment schedule.',
        debtAmount: 'Debt amount',
        accumulatedInterest: 'Accumulated interest',
        planedAccumulatedPayments: 'Planned accumulated payments',
        disclaimerLastEntryVaries: 'If the entries are not paid on the specified date, the amount of the last entry may differ.',
        disclaimerVariableInterest: 'The interest rate on the case can change over time, which may also affect the amount of the last entry.',
        savedPaymentMethod: 'Saved payment method',
        removePaymentMethod: "Remove debtor's payment method",
        areYouSureRemovePaymentMethod: "Are you sure you want to remove the debtor's payment method?",
        paymentMethodSection: 'Payment method',
        noPaymentMethodConnected: 'No payment method connected',
        noPaymentMethodHint: 'Connect a payment method so installments can be charged automatically on the due date.',
        connectPaymentMethod: 'Connect payment method',
        connectCardOrBetalingsservice: 'Connect card or Betalingsservice',
        noActiveCardOption: 'The creditor has no active card payment method available.',
        createBSMandate: 'Create Betalingsservice mandate',
        bsMandateDescription: 'Register a Betalingsservice mandate on behalf of the debtor using their CPR and bank details.',
        bsMandateName: 'Name',
        bsMandateCpr: 'CPR number',
        bsMandateRegNo: 'Registration number',
        bsMandateAccountNo: 'Account number',
        bsMandateSubmit: 'Create mandate',
        bsMandateCreated: 'Betalingsservice mandate created. Awaiting confirmation from the bank.',
        recommendedBadge: 'Recommended',
        lastBankDayOfMonthDescription: 'Withdraw on payday — best chance of successful payment.',
        recalculate: 'Recalculate',
        recalculateDescription: 'Recalculation deletes all pending entries and regenerates the plan.',
        daily: 'Daily',
    },
    debtRegistration: {
        registration: 'Debt registration',
        tabGeneral: 'General',
        tabRki: 'RKI',
        tabDebitorRegistret: 'Debitor Registret',
        createNewRegistration: 'Create new registration',
        newRegistration: 'New debt registration',
        chooseDebtor: 'Choose debtor',
        amount: 'Amount',
        withFoundation: 'With foundation',
        chooseFoundationType: 'Choose foundation type',
        dateFoundation: 'Date for foundation',
        noFoundationsOnCase: 'No foundation found on the case. Add a foundation to the case to continue.',
        foundationCode: {
            [FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [FoundationCode.stævning]: 'Stævning',
            [FoundationCode.fogedsag]: 'Fogedsag',
            [FoundationCode.dom]: 'Dom',
            [FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [FoundationCode.konkurs]: 'Konkurs',
            [FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [FoundationCode.skylderklæring]: 'Skylderklæring',
            [FoundationCode.forlig]: 'Frivilligt forlig',
        },
        state: {
            [DebtRegistrationState.ACTIVE]: 'ACTIVE',
            [DebtRegistrationState.ERROR]: 'ERROR',
            [DebtRegistrationState.DELETED]: 'DELETED',
            [DebtRegistrationState.CONCLUDED]: 'CONCLUDED',
        },
        registry: {
            [RegistryType.OPEN]: 'OPEN',
            [RegistryType.CLOSED]: 'CLOSED',
        },
        status: 'Status',
        remark: 'Remark',
        deleteReason: 'Deletion cause',
        migrated: 'Migrated',
        latestWarningDate: 'Date for latest warning',
        errors: {
            [DebtRegistrationError.AlreadyRegistered]: 'The debtor is already registered',
            [DebtRegistrationError.MissingWarning]: 'Missing warning',
            [DebtRegistrationError.WrongCurrency]: 'Currency is not DKK',
            [DebtRegistrationError.WarningLetterWasReturned]: 'Warning letter was returned',
            [DebtRegistrationError.EmailWarningWasNeverDelivered]: 'Warning email was never delivered',
            [DebtRegistrationError.WarningIsOlderThanOneYear]: 'Warning is older than one year',
            [DebtRegistrationError.FoundationCouldNotBeMapped]: 'Foundation code could not be identified',
            [DebtRegistrationError.FoundationDateCouldNotFound]: 'Foundation date could not be found',
            [DebtRegistrationError.UnresolvedOpposition]: 'Unresolved interaction',
            [DebtRegistrationError.OppositionFound]: 'Active dispute',
            [DebtRegistrationError.NoRegistryFound]: 'Does not comply with requirements for any registry',
            [DebtRegistrationError.FoundationAmountCouldNotBeFound]: 'Amount on foundation is missing',
            [DebtRegistrationError.FoundationAmountTooSmall]: 'Amount on foundation is too small for open registry',
            [DebtRegistrationError.NameTooLong]: 'Debt registration allows a maximum of 60 characters in the name. For sole proprietorships, "v/" can be removed along with everything after "/v".',
            [DebtRegistrationError.OldestRegistrationIsTooOld]: 'The oldest registration is too old',
            [DebtRegistrationError.FoundationFileMissing]: 'Foundation document has no file (required for open registration without lawyer guarantee)',
            [DebtRegistrationError.FoundationMissing]: 'There is no foundation on the case, which is required for open registration',
            [DebtRegistrationError.BalanceTooSmallForOpen]: 'The balance on the case is too small for open registration',
        },
        infobox: {
            herebyRegister: 'hereby registers',
            open: 'Open',
            closed: 'Closed',
            inThe: 'in the',
            debtorNotPaid: 'debt register, since debtor has not paid the due amount of DKK',
            criteria: 'The case complies with the following criterias:',
            min18years: 'Debtor is minimun 18 years of age',
            min3messages: 'Debtor has recieved a minimun of 3 messages from creditor and/or collector regarding the debt',
            totalDebt: 'Total debt including rates and fees is of minimum DKK 1.000',
            hasFoundation: 'Has foundation',
            debtorWarning: 'Debtor has been warned for at least 15 days ago and at most 6 months ago',
            totalPrincipal: 'Total principal is minimum DKK 200',
            noDemurral: 'Debtor has not demurred',
            institutionsInfo: "Insurance companies, financial institutions and mortgage credit institutions are not allowed to register debtors in debt registries without the case has been heard by civil court or bailiff's court",
            incoming: 'Interactions marked as disputes and unresolved interactions',
            specialCreditors: "Insurance companies, financial institutions and mortgage credit institutions are not allowed to register debtors in debt registries without the case has been heard by civil court or bailiff's court",
            closedRegister: 'Closed registry',
            openRegister: 'Open registry',
            foundationType: 'Registration with the correct foundation type',
            registerButton: 'Register in debt register',
            finePrint: {
                NB: 'NB: Processing can take up to 10 minutes. If the registration requires manual processing, it may take several business days.',
                letter: 'Debtor will receive a letter after the registration has been published.',
                expiration: 'Registrations in the closed expires after 2 years. It can be extended up to 5 if it transfers to the open register. Registrations in the open exired after 5 years from the foundation date.',
                faultyData: 'If there are any problems with the data, please contact support.',
                newClient: 'For new client setup, please contact support.',
            },
        },
    },
    RKI: {
        registration: 'RKI registration',
    },
    debitorRegistret: {
        registration: 'Debitor Registret registration',
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Debt Expiring Within 3 months',
        debtExpired: 'Debt expired',
        principal: 'Principal',
        interests: 'Interests',
        costs: 'Costs',
        debt: 'Debt',
        deposit: 'Deposit',
        balance: 'Balance',
        revenue: 'Revenue',
        revenueBasedDepositOrder: 'Revenue based deposit order',
        interestBasedDepositOrder: 'Interest based deposit order',
        details: 'Details',
        invoiceId: 'Invoice ID',
        reminderFee: 'Reminder Fee',
        overpayment: 'Overpayment',
        repayment: 'Repayment',
        responsibleForRepayment: 'Responsible for repayment',
        sourceBankAccount: 'Source bank account',
        registrationNumber: 'Registration number',
        accountNumber: 'Account number',
        repaymentAmount: 'Repayment amount',
        sendRepaymentRequest: 'Send repayment request',
        currency: 'Currency',
        moneyScaleSuffixes: {
            thousands: 't',
        },
        moneyCalculator: {
            sum: 'Sum',
            average: 'Avg.',
            count: 'count',
        },
        imposedByCollector: 'Debt imposed by collector',
        imposedByCreditor: 'Debt imposed by creditor',
    },
    ultimateCreditors: {
        notes: 'Notes',
        ultimateCreditor: 'Ultimate creditor',
        ultimateCreditors: 'Ultimate creditors',
        explanation: 'An ultimate creditor is the original creditor behind the creditor on the case — for example when a debt collection agency forwards cases on behalf of its own client. On cases with an ultimate creditor, the creditor mentions (name, address and CVR) automatically use the details of the ultimate creditor.',
        name: 'Name',
        referenceId: 'Reference id',
        referenceIdAutoHint: 'Leave empty to assign automatically',
        registryIdentifier: 'Registry identifier',
        address: 'Address',
        newUltimateCreditor: 'New ultimate creditor',
        editUltimateCreditor: 'Edit ultimate creditor',
        deleteUltimateCreditor: 'Delete ultimate creditor',
        confirmDelete: 'Are you sure you want to delete this ultimate creditor?',
        noUltimateCreditors: 'No ultimate creditors have been created yet',
        none: 'No ultimate creditor',
        setUltimateCreditor: 'Set ultimate creditor',
        removeUltimateCreditor: 'Remove ultimate creditor',
        manageUltimateCreditor: 'Ultimate creditor',
    },
    sftp: {
        servers: 'SFTP servers',
        explanation: 'Create SFTP servers for exchanging files with creditors and partners. Each server has its own users, who log in with an SSH key.',
        name: 'Name',
        creditor: 'Creditor',
        noCreditor: 'No creditor',
        created: 'Created',
        newServer: 'New SFTP server',
        createServer: 'Create SFTP server',
        deleteServer: 'Delete SFTP server',
        deleteServerWarning: 'Deleting the SFTP server removes all of its users and their access. This cannot be undone.',
        typeNameToConfirm: 'Type the name of the SFTP server to confirm',
        noServers: 'No SFTP servers have been created yet',
        connection: 'Connection',
        host: 'Host',
        port: 'Port',
        users: 'Users',
        connectionExplanation: 'Users connect with an SFTP client to the host below and authenticate with their SSH key. No password is used.',
        keyType: 'Key',
        login: 'Login',
        deleteServerExplanation: 'Deletes the SFTP server and all of its users. Files already uploaded stay in the folder.',
        newUser: 'New user',
        createUser: 'Create user',
        username: 'Username',
        usernameHint: '3-100 characters: letters, digits, underscore, hyphen, period and @',
        publicKey: 'SSH public key',
        publicKeyHint: 'Paste the public key, e.g. "ssh-ed25519 AAAA... comment"',
        deleteUser: 'Delete user',
        confirmDeleteUser: 'Are you sure you want to delete this user? It will lose access immediately.',
        noUsers: 'No users have been created yet',
        backToServers: 'All SFTP servers',
    },
    navigation: {
        overview: 'Overview',
        home: 'Home',
        cases: 'Cases',
        views: 'Views',
        transactions: 'Transactions',
        economy: 'Economy',
        economyCaseVouchers: 'Case vouchers',
        economyBookkeeping: 'Bookkeeping',
        economyImposedDebt: 'Imposed debt',
        economyDeposits: 'Deposits',
        economySetup: 'Settings',
        economyBilling: 'Billing',
        economyPayment: 'Payment',
        economyPayouts: 'Payouts',
        economyChartOfAccounts: 'Chart of accounts',
        economyUnknown: 'Unknown Transactions',
        bankAccounts: 'Accounts',
        export: 'Export',
        transactionLookup: 'Transaction lookup',
        depositChanges: 'Changes',
        economyIrrecoverableDebt: 'Irrecoverable debt',
        economyExpiredDebt: 'Expired debt',
        reports: 'Insights',
        communication: 'Channels',
        content: 'Content',
        creditors: 'Creditors',
        creditorEconomy: 'Economy',
        creditorInvoicing: 'Billing',
        creditorCustomers: 'Customers',
        creditorCases: 'Cases',
        creditorCollector: 'Collector',
        creditorIrrecoverableDebt: 'Irrecoverable debt',
        creditorExpiredDebt: 'Expired debt',
        creditorEconomySetup: 'Setup',
        creditorTribunal: 'Tribunal',
        creditorSetup: 'Settings',
        creditorAISettings: 'AI',
        creditorWorkflows: 'Workflows',
        creditorUsers: 'Users',
        creditorUltimateCreditors: 'Ultimate creditors',
        creditorIntegrations: 'Integrations',
        journalizer: 'Journalizer',
        interactionHistory: 'Interaction history',
        returnLetters: 'Return letters',
        outbox: 'Outbox',
        outboundCalls: 'Outbound calls',
        import: 'Import',
        support: 'Support',
        search: 'Search cases...',
        settings: 'Settings',
        settingsDesc: 'Settings for tenant',
        user: 'My account',
        userDesc: 'Your settings',
        homeOverview: 'Overview',
        settingsGeneral: 'General',
        settingsTemplates: 'Templates',
        settingsDevelopers: 'Developers',
        settingsDevelopersDesc: 'Access to API and more',
        settingsSwitchAccount: 'Switch account',
        settingsSwitchAccountDesc: 'Switch between accounts',
        settingsTenantBilling: 'Billing',
        settingsTenantBillingDesc: 'See all invoices',
        settingsProperties: 'Properties',
        settingsCaseVoucherTables: 'Case voucher tables',
        settingsDocuments: 'Documents',
        settingsCaseGroups: 'Case groups',
        settingsEndReasons: 'End reasons',
        settingsCaseConfig: 'Case config',
        settingsWebhooks: 'Webhooks',
        settingsSftp: 'SFTP',
        settingsEmbed: 'Embed',
        settingsAPI: 'API',
        settingsCollectors: 'Collectors',
        settingsDebtRegister: 'Debt registration',
        settingsIntegrateCalendar: 'Synchronize tasks to calendar',
        settingsEconomy: 'Economy',
        settingsPriceList: 'Price list',
        settingsBookkeeping: 'Bookkeeping appendix',
        settingsBilling: 'Billing setup',
        settingsBankAccounts: 'Bank accounts',
        settingsCaseVoucherTypes: 'Case voucher types',
        settingsBillingVoucherTypes: 'Billing voucher types',
        settingsUsers: 'Users',
        settingsTribunal: 'Tribunal',
        settingsTeams: 'Teams',
        settingsTenant: 'Tenant',
        settingsUpdateTypes: 'Tasks',
        settingsProcedures: 'Shortcuts',
        settingsWorkflowStages: 'Stages',
        settingsApplications: 'Rule based vouchers',
        settingsCaseMergeRules: 'Case merge rules',
        settingsPaymentPlansConfig: 'Payment plans',
        settingsJournalizerConfig: 'Journalizer',
        settingsAI: 'AI',
        settingsAIGeneral: 'General',
        settingsAIReplies: 'Replies',
        settingsAICategories: 'Categories',
        reportsExorts: 'File Exports',
        reportsPaymentPlans: 'Payment plans',
        reportsCourtMeetings: 'Court meetings',
        reportsDistraints: 'Distraints',
        reportsGeneralManagement: 'Management reporting',
        reportsAI: 'AI',
        reportsPrevious: 'Previous reports',
        reportsSankey: 'Debbie flow chart',
        settingsWorkflows: 'Workflows',
        reportsPaymentDays: 'Payment days chart',
        myAccount: 'My account',
        integrations: 'Integrations',
        connect: 'Connect',
    },
    timespanUnits: {
        [TimespanUnit.Years]: 'Years',
        [TimespanUnit.Quarters]: 'Quarters',
        [TimespanUnit.Months]: 'Months',
        [TimespanUnit.Weeks]: 'Weeks',
        [TimespanUnit.Days]: 'Days',
        [TimespanUnit.Hours]: 'Hours',
        [TimespanUnit.Minutes]: 'Minutes',
        [TimespanUnit.Seconds]: 'Seconds',
        [TimespanUnit.MS]: 'Milliseconds',
    },
    paymentPlansConfig: {
        description: 'Setup what options the debtor should be offered when entering a payment plans by themselves.',
        minEntryAmountPlaceholder: 'Minimum amount per installment',
        daysBetweenEntriesPlaceholder: 'Days between',
        durationPlaceholder: 'Months',
        addOption: 'Add',
        save: 'Save',
        override: 'Override config on creditor',
        disablePaymentPlans: 'Turn off payment plans so that neither debtors nor case workers can set up payment plans.',
        requireCentralRegisterId: 'Require CPR/CVR number before signature',
        activationDeadlineDays: 'Cancel unactivated payment plans after number of days',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Reference id search',
        description: 'Journalize emails and match deposits based on reference numbers such as customer numbers or case voucher references (e.g., invoice number).',
        length: 'Number of digits in the reference number',
        min: 'Minimum possible reference number',
        max: 'Maximum possible reference number',
        createNew: 'Create new reference number search',
        add: 'Add',
        caseVoucherReference: 'Case voucher reference',
        caseVoucherReferenceDescription: 'Case voucher reference (e.g., invoice number)',
        customerReference: 'Customer reference',
        customerReferenceDescription: 'Customer reference (e.g. patient, client, or membership number)',
    },
    caseMergeRules: {
        description: 'Decide wether new vouchers regarding a customer should be added to existing cases or a new case should be created.',
        preventMerge: 'Prevent merge with cases',
        caseStatusVerified: 'Merge with verified cases',
        adjustVariableCaseVouchers: 'Adjust debt collection costs and fees',
        caseStatusPending: 'Merge with pending cases',
        hasFoundation: 'Merge with cases with foundation',
        caseVoucherConstraints: 'Case vouchers types with duplicate control',
        caseVoucherConstraintsDescription: 'Select which case voucher types should not appear on both cases if they are created within the specified number of days. The newest case vouchers will be removed.',
        caseVoucherConstraintsAllDays: 'Remove all',
        caseVoucherConstraintsDays: 'Days',
        addCaseVoucherConstraint: 'Add duplicate control',
        addCaseVoucherConstraintSelectVoucherType: 'Select case voucher type',
        addCaseVoucherConstraintUniqueInDays: 'Unique within number of days (leave empty if all should be removed)',
        addCaseVoucherConstraintAddButton: 'Add',
        doesNotHaveUpdateTypeIds: 'Do not merge with cases with these tasks',
        doesHaveUpdateTypeIds: 'Only merge with cases with these tasks',
        hasActivePaymentPlan: 'Merge cases with an active payment plan',
    },
    workflows: {
        workflows: 'Workflows',
        customWorkflows: 'Created workflows',
        standardWorkflow: 'Standard workflows',
        creditorStandardWorkflowDescription: 'Set up which workflow new cases are to be created in. If you change the workflow here, it will not change already created cases.',
        creditorInteraction: 'to creditor',
        removeVouchers: 'Remove',
        rollbackTask: 'Rollback task',
        rolledback: 'Rolled back',
        runTask: 'Move case to this task',
        sureYouWantToDeleteTask: 'Are you sure you want to delete the task?',
        addRequirement: 'Add requirement',
        searchUpdates: 'Search',
        noUpdatesToShow: 'No tasks to show',
        manualSelection: 'Manual selection',
        changeWorkflowOnCase: 'Change workflow',
        nextTaskASAP: 'Next task will be executed in a moment',
        workflowWillStartWhenCaseIsVerified: 'Workflow will start when case is verified',
        caseIsPaused: 'Case is paused',
        pausedBecauseOfPaymentPlan: 'Next task will be executed if payment plan defaults',
        priority: 'Priority',
        priorityDescription: 'If a path cannot be automatically found the priority will be used. 1 is top priority.',
        timing: 'Timing',
        requirements: 'Requirements',
        amount: 'Amount',
        imposedByCreditor: 'Imposed by creditor',
        text: 'Text',
        addTodo: 'Add todo',
        triggerAgent: {
            promptPlaceholder: "Custom prompt for the AI agent (e.g. 'Review this case and suggest next steps').",
        },
        selectTemplate: 'Choose template',
        includeVoucherAttachments: 'Attach voucher appendices (invoice for example).',
        attachFoundations: 'Attach foundations',
        selectEmailPDFAttachment: 'Choose template to be attached the email.',
        sendImmediatelyDeviateFromSettings: 'Should immediate sending differ from general settings in your account?',
        sendImmediately: 'Send immediately',
        doNotSendImmediately: "Don't send immediately",
        endCaseIfThereIsNoPrincipalLeft: 'End case if there is no principal remaining',
        endCaseReason: 'If the case is to be ended, what closure reason should be used?',
        selectCollector: 'Choose collector',
        useCreditorCollector: 'Use creditors identity',
        creditorCollector: 'Creditors identity',
        setAsPrincipalReferenceCaseVoucher: 'Set as reference case voucher of principal',
        setMaxTotalAmount: 'Set max. amount',
        maxTotalAmount: 'Max. amount',
        selectCaseGroup: 'Choose case group',
        addNewTemplate: 'Add template',
        addNewTemplateSubheading: 'Add a new template',
        timespan: 'Timespan',
        timespanUnit: 'Timespan unit',
        timespanUnitQuantity: 'Timespan',
        timeOfDay: 'Time of day',
        moreThan: 'More than',
        updateIsActive: 'Tasks should be active',
        onlySpecificDocumentTypes: 'Only specific document types',
        onlyOpenRegistries: 'Only open registrations',
        noSelectedRegistryNeverFulfilledWarning: 'No registries selected, this requirement will never be fulfilled.',
        noSelectedRegistryAlwaysFulfilledWarning: 'No registries selected, this requirement will always be fulfilled.',
        propertySingleLineTextOneOfFollowingStrings: 'Is one of the following strings (comma separated)',
        propertyDropdownOneOfFollowingValues: 'Is one of the following',
        thresholdAmount: 'Amount',
        caseGroup: 'Case group',
        percentageSplitFrom: 'Percentage split from',
        percentageSplitTo: 'Percentage split to',
        selectedCreditor: 'Creditor',
        noSelectedCreditorWarning: 'No creditors selected, this requirement will never be fulfilled.',
        onlySelectedVoucherCategories: 'Only selected voucher categories',
        noRequirements: 'No requirements',
        infoModalHeading: 'Settings for workflow',
        title: 'Title',
        description: 'Description',
        endCaseIfThereIsNoDebt: 'End case if there is no debt left',
        endCaseIfThereIsNoDebtDesc: 'If no end reason is selected, the case will just continue.',
        selectEndReason: 'End reason',
        newWorkflow: 'New workflow',
        createNewWorkflow: 'Create workflow',
        duplicateWorkflow: 'Duplicate workflow',
        deleteWorkflow: 'Delete workflow',
        deleteWorkflowConfirm: 'Are you sure you want to delete this workflow?',
        endedCasesPercentage: 'ended cases',
        casesInTask: 'cases in status',
        task: 'Task',
        remind: 'Remind',
        remindCase: 'Should the update be added to case as a reminder?',
        pause: 'Pause',
        pauseCase: 'Should the case be paused?',
        pauseUnlimited: 'Require manual continuation',
        remindNow: 'Remind now',
        stats: 'Statistics',
        endedCases: 'Ended cases',
        sum: 'Sum',
        totalCases: 'Total count of cases that have been in this status',
        currentCases: 'Cases rurrently in this status',
        incomingInteractionsStats: 'Incoming interactions',
        paymentPlansCreatedStats: 'Payment plans created',
        satisfactionStats: 'Reputation',
        alternativePaths: 'Alternative paths',
        alternativePath: 'Alternative path',
        addAlternativePath: 'Add alternative path',
        source: 'From task id',
        mergeCaseTodoDescription: 'The case will be tried merged with other cases on the customer based on the rules of merging. It is also possible to merge the case with related cases based on relation types selected below.',
        mergeWithRelatedCasesOfType: 'Possibility to merge with related cases with relation types',
        applyCustomMergeRules: 'Custom case merge rules',
        settings: {
            workflowSettings: 'Workflow settings',
            tenantDefaultsDescription: 'New cases start in this workflow. It can be overridden for specific case groups and individual creditors.',
            creditorDefaultsDescription: 'New cases for this creditor start in this workflow. Unset options inherit the tenant settings.',
            caseGroupDefaults: 'Case-group overrides',
            caseGroupDefaultsDescription: 'Use a different workflow for specific case groups. It takes precedence over the default workflow.',
            addCaseGroupDefault: 'Add override',
            noAvailableCaseGroups: 'No case groups available. You can choose one workflow per case group. Create more case groups to add more overrides.',
            newCaseGroupDefault: 'New override',
            newCasesOnly: 'Changes apply to new cases only.',
            executionSettings: 'Workflow execution',
            defaultWorkflow: 'Default workflow',
            disableWorkflows: 'Disable workflows',
            disableWorkflowsWarning: 'Are you sure that you want to disable ALL workflows?',
            workflowsDisabled: 'Workflows are disabled',
            limitExecutionInterval: 'Limit the time interval where workflows can run',
        },
    },
    workflowStages: {
        stage: 'Workflow stage',
        stages: 'Stages',
        selectStage: 'Choose workflow stage',
        createNewStage: 'Create new workflow stage',
        customStages: 'Created stages',
        standardStages: 'Standard stages',
        addStage: 'Add workflow stage',
        editStage: 'Edit workflow stage',
        title: 'Title',
        shortLabel: 'Short label',
        shortLabelPlaceholder: 'Short label shown on the case (e.g. "Rem.")',
        save: 'Save',
        deleteButton: 'Delete workflow stage',
        deleteWarning: 'Are you sure you want to delete this workflow stage?',
        missingStageWarning: 'This task has no workflow stage',
        stageDescription: 'The stage is used to show how far a case has progressed in the workflow.',
    },
    timingTypes: {
        [TimingType.Timespan]: 'Timespan',
        [TimingType.TimespanFromDueDate]: 'Timespan from newest due date',
    },
    updatesEditor: {
        update: 'Task',
        information: 'Information',
        informationDescription: 'Workflows that the task is added to.',
        standardSettings: 'General',
        standardSettingsDescription: 'General settings for this task.',
        label: 'Label',
        save: 'Save',
        important: 'Important',
        importantPlaceholder: 'This task is important and should be highlighted on the case.',
        pausing: 'Pausing',
        pausingPlaceholder: 'This task should be pausing the case',
        selectable: 'Selectable',
        selectablePlaceholder: 'This task can be selected on a case',
        procedure: 'Procedure',
        procedureDescription: 'The procedure that this task should execute. If turned on, the procedure defined will be executed if it is in a workflow.',
        procedureOn: 'Turn on procedure for this task',
        procedurePlaceholder: 'Turn on procedure',
        onCaseExit: 'On case exit',
        onCaseExitDescription: 'If a case is ended with this task, put on a self-chosen task.',
        onCaseExitContinueUpdates: 'Should tasks of this type be continued when a case is ended?',
        continueOnCaseExit: 'Continue on case end',
        onCaseExitPauseWith: 'On case exit put pause the case with this task',
        selectUpdateType: 'Update type',
        roles: 'Roles',
        rolesDescription: 'Choose responsible role',
        responsibleRole: 'Responsible role',
        hiddenForCreditors: 'Hidden for creditors',
        hiddenForCreditorsPlaceholder: 'Should this task be hidden for creditors?',
        introduction: 'Introduction',
        introductionDescription: 'Introduction to the update with text and possibly a picture. It is an advantage, if the creditor is responsible, to make a good introduction.',
        introductionHeaderImage: 'Hero image',
        introductionHeaderImageDropText: 'Drag and drop a hero image here',
        deleteButton: 'Delete task',
        deleteWarning: 'You both delete the update type but also all updates of the type. Do you want to continue?',
    },
    workflowTodoTypes: {
        [TodoType.AddVoucher]: 'Add voucher',
        [TodoType.AddBillingVoucher]: 'Add billing voucher',
        [TodoType.RemoveVoucher]: 'Remove voucher',
        [TodoType.CreateInteraction]: 'Create interaction',
        [TodoType.CreateCreditorInteraction]: 'Create interaction to creditor',
        [TodoType.CreateOtherInteraction]: 'Create interaction to other',
        [TodoType.SetCollector]: 'Set collector',
        [TodoType.SetCaseGroup]: 'Set case group',
        [TodoType.MoveToTenant]: 'Move case to tenant',
        [TodoType.ChangeCaseStatus]: 'Change case status',
        [TodoType.OutboundCall]: 'Outbound call',
        [TodoType.SetCaseTag]: 'Add case tag',
        [TodoType.RemoveCaseTag]: 'Remove case tag',
        [TodoType.DebtRegister]: 'Debt register',
        [TodoType.DebtRegisterSkip]: 'Ready to debt register?',
        [TodoType.SubmitToCourt]: 'Submit to court',
        [TodoType.ReadyToSubmitToCourt]: 'Ready to submit to court?',
        [TodoType.ConnectToDebtCollector]: 'Send to a connect partner',
        [TodoType.ReturnToConnectSource]: 'Return case to connect partner',
        [TodoType.SwitchWorkflow]: 'Switch workflow',
        [TodoType.SwitchBackToPreviousWorkflow]: 'Switch back to previous workflow',
        [TodoType.Bespoke]: 'Custom',
        [TodoType.MergeCase]: 'Merge case if possible',
        [TodoType.CreateProperties]: 'Create properties',
        [TodoType.SetResponsible]: 'Set responsible on case',
        [TodoType.MarkExpired]: 'Mark case vouchers as expired',
        [TodoType.SetCaseSetting]: 'Set case setting',
        [TodoType.TriggerAgent]: 'Trigger AI agent',
    },
    workflowPathWarnings: {
        [PathWarning.ReadyForEboksRequirementRecommended]: 'Requirement "Ready for e-Boks" recommended',
        [PathWarning.ValidEmailRequirementRecommended]: 'Requirement "Email valid" recommended',
        [PathWarning.ValidAddressRequirementRecommended]: 'Requirement "Address valid" recommended',
    },
    workflowRequirementTypes: {
        [RequirementType.MissingUpdate]: 'Does not have on of selected updates',
        [RequirementType.HasUpdate]: 'Does have on of selected updates',
        [RequirementType.HasNoValidAddress]: 'Address invalid',
        [RequirementType.HasValidCentralRegisterId]: 'Has cvr / cpr',
        [RequirementType.HasNoValidCentralRegisterId]: 'Does not have cvr / cpr',
        [RequirementType.HasValidAddress]: 'Address valid',
        [RequirementType.HasValidEmail]: 'Email valid',
        [RequirementType.HasNoValidEmail]: 'Email invalid',
        [RequirementType.IsCompany]: 'Is company',
        [RequirementType.ReadyForEInvoice]: 'Ready for e-invoice',
        [RequirementType.ReadyForEboks]: 'Ready for e-Boks',
        [RequirementType.DebtRemarks]: 'Debt remarks',
        [RequirementType.HasValidPhone]: 'Phone valid',
        [RequirementType.HasNoValidPhone]: 'Phone invalid',
        [RequirementType.IsPrivate]: 'Is private person',
        [RequirementType.AmountThreshold]: 'Amount threshold',
        [RequirementType.CaseGroup]: 'Is one of case groups',
        [RequirementType.PercentageSplit]: 'Percentage cases',
        [RequirementType.HasFoundation]: 'Has foundation',
        [RequirementType.DoesNotHaveFoundation]: 'Does not have foundation',
        [RequirementType.SpecificCreditor]: 'Specific creditor',
        [RequirementType.CustomerHasTag]: 'Customer has tag',
        [RequirementType.CaseHasTag]: 'Case has tag',
        [RequirementType.HasIncomingInteractions]: 'Has incoming interaction',
        [RequirementType.CaseStatusIn]: 'Case status is one of',
        [RequirementType.Property]: 'Rule based on property',
        [RequirementType.InDebtRegister]: 'Registered by us in debt registry',
        [RequirementType.NotInDebtRegister]: 'Not registered by us in debt registry',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Title of embed area',
        embedURL: 'URL to be called',
        embedHeight: 'Height of area in px',
        addEmbedArea: 'Add embed area',
        embedPlacement: 'Placement',
        embedToken: 'Validation token',
        embedCreatedAt: 'Created at',
        noAreasYet: 'No embed areas yet',
        couldNotLoad: 'Could not load',
        caseworkerNavMenuItemCategory: 'External',
        creditorNavMenuItemCategory: 'External',
        calledWithDescription: 'The URL will be called with a GET request with the following query parameters and headers',
        header: 'Header',
    },
    embedPlacements: {
        [EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Creditor page top right',
        [EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Case page under the economy panel',
        [EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Full page with link in the menu to the right',
        [EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Case page under the economy panel',
        [EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Front page to the right',
        [EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Full page with link in the menu to the right',
    },
    webhookSettings: {
        noWebhooksYet: 'No webhooks yet',
        hookNotFound: 'The associated webhook configuration could not be found. Please check that you are on the correct tenant.',
        failedToLoad: 'Failed to load webhook details. Please try again later.',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        columnEvent: 'Event',
        columnWebhook: 'Webhook',
        columnUrl: 'URL',
        columnDate: 'Date',
        columnState: 'State',
        stateAwaiting: 'Awaiting',
        statePermanentlyFailed: 'Permanently failed',
        stateSucceeded: 'Succeeded',
        namePlaceholder: 'Name of webhook',
        urlPlaceholder: 'Webhook url',
        emailPlaceholder: 'Email for fail notifications',
        requestHeaders: 'Request headers',
        otherSettings: 'Other settings',
        deepFlatten: 'Deep flatten request body to prevent nested JSON objects',
        pullWebhooks: 'Pull webhooks',
        advancedSettings: 'ADVANCED SETTINGS',
        addWebhook: 'Add webhook',
        pullWebhook: 'Pull webhook',
        verificationToken: 'Verification Token',
        headerKeyPlaceholder: 'Header key',
        headerValuePlaceholder: 'Header value',
        addHeader: 'Add header',
        eventDate: 'Event date',
        headers: 'Headers',
        body: 'Body',
        bodyMapping: 'Body mapping',
        resendWebhook: 'Resend webhook',
        attempts: 'Attempts',
        nextAttemptAt: 'Next attempt at:',
        attemptSuccess: 'Success',
        attemptFailed: 'Failed',
        copy: 'COPY',
        columnCreditor: 'Creditor',
        allCreditors: 'All creditors',
    },
    userOverrideSettings: {
        label: 'Debtor overwrites',
        description: 'You can use debtor overwrites to automatically change information for customers who fit certain criteria. When a customer who meets these criteria is updated, the chosen fields will automatically be replaced with the settings you have made.',
        whenMatching: 'When a debtor matches',
        overrideFields: 'Overwrite fields',
        deleteEmail: 'Remove email',
    },
    apiSettings: {
        documentation: 'API documentation',
        keys: 'API keys',
        noKeysYet: 'There is no keys yet',
        newKeyButton: 'Create new API key',
        newKey: 'New API key',
        newKeyCreatedInfo: 'That was it! Remember to store your key in a safe location. This is the first and last time you will be able to get it from Debbie.',
        closeModal: 'Understood',
        keyName: 'Name your API key',
        createNewKey: 'Create new API key',
    },
    updateTypeSettings: {
        label: 'Label',
        responsibleRole: 'Responsible role',
        isImportant: 'Important',
        tenantSpecific: 'Tenant specific',
        isTenantSpecific: 'Is tenant specific',
        referenceType: 'Reference type',
        onCaseExit: 'On case exit pause with',
        isPausing: 'Pausing',
        hiddenForRoles: 'Hidden for role',
        knowledgeBaseLink: 'Knowledge base',
        deadlineTitle: 'Deadline',
        deadlineDescription: 'Number of days a task of this type may stay on the task list before it is marked as past deadline. Leave the field empty for no deadline.',
        deadlinePlaceholder: 'E.g. 7',
        deadlineSave: 'Save',
    },
    overview: {
        todoList: 'Todo-list',
        noDescription: 'No description',
        noPauseStatus: 'No pause status',
        settlementTime: 'Settlement time in months',
        instalmentAgreement: 'Instalment agreement',
        statistics: 'Statistics',
        averageIntro: 'It takes an average of',
        averageOutro: 'days for a case to be settled.',
        quantityCases: 'Quantity of cases',
        quantifyCustomers: 'Quantity of customers',
        statusDistribution: 'Status distribution',
        chartStatuses: {
            Godkendt: 'Approved',
            'Afventer Godkendelse': 'Awaiting Approval',
            Afsluttet: 'Completed',
            Annuleret: 'Annulled',
            Afslutningsårsag: 'Completion cause',
        },
    },
    endReason: {
        [SystemEndReason.ErrorCreditor]: 'Error from creditor',
        [SystemEndReason.ErrorUs]: 'Wrong creation',
        [SystemEndReason.Expiration]: 'The case is expired',
        [SystemEndReason.Departed]: 'Debtor has departed (moved/left)',
        [SystemEndReason.Unidentified]: 'Debtor can not be validated',
        [SystemEndReason.AddressUnknown]: "Debtor's address is unknown",
        [SystemEndReason.Paid]: 'Debtor has paid the entire debt',
        [SystemEndReason.Transferred]: 'Case is transferred',
        [SystemEndReason.Dead]: 'Debtor has passed away',
        [SystemEndReason.Objection]: 'Closed because of objection',
        [SystemEndReason.Withdrawn]: 'The creditor has withdrawn the case',
        [SystemEndReason.OfferFromUs]: 'Paid according to composition offer from us',
        [SystemEndReason.OfferFromDebtor]: 'Paid according to composition offer from debtor',
        [SystemEndReason.DebtRelief]: 'Debtor has gained debt relief',
        [SystemEndReason.Bankruptcy]: 'Debtor is bankrupt',
        [SystemEndReason.ForcedDissolved]: 'Debtor has been forced to wind up',
        [SystemEndReason.ConflictOfInterest]: 'Conflict of interest between debtor and us',
        [SystemEndReason.NegativePayoff]: 'Negative payoff for the creditor',
        [SystemEndReason.Overpayment]: 'Debtor has paid too much',
        [SystemEndReason.Minor]: 'Debtor is a minor',
        [SystemEndReason.Irrecoverable]: 'The case is irrecoverable',
        [SystemEndReason.PartiallyPaid]: 'Partially paid',
        [SystemEndReason.CreditorUnresponsive]: 'The creditor is unresponsive',
        [SystemEndReason.Merged]: 'Case is merged',
        [SystemEndReason.FireAndForget]: 'Fire & forget',
        [SystemEndReason.SmallCaseNotWanted]: 'Small case not wanted',
        [SystemEndReason.NoDebt]: 'No debt',
        [SystemEndReason.Deleted]: 'Deleted',
        [SystemEndReason.NoCourt]: 'The case is through the extrajudicial process',
        [SystemEndReason.Other]: 'Other reason',
    },
    endReasonCategory: {
        [EndReasonCategory.Success]: 'Resolved',
        [EndReasonCategory.Unresolved]: 'Unresolved',
        [EndReasonCategory.NotPossible]: 'Not possible',
        [EndReasonCategory.Error]: 'Error',
    },
    endReasonCategoryDescription: {
        [EndReasonCategory.Success]: 'Cases where we collected money for the creditor – fully or partially – via payment or settlement. This is the category we try to maximize.',
        [EndReasonCategory.Unresolved]: 'Real cases that were not resolved, but where no outside factor made it impossible: the debt expired, was deemed irrecoverable, or the case was dropped because pursuing it further was not viable.',
        [EndReasonCategory.NotPossible]: 'Cases where collection became impossible due to external circumstances at the debtor – e.g. bankruptcy, death, debt relief or unknown address. Counts in the statistics but cannot be considered our fault.',
        [EndReasonCategory.Error]: 'Cases removed from the statistics (also from the net resolution rate) because they should never have been with us: case-creation errors, duplicates (merged), creditor withdrew the case, or the debtor was a minor.',
    },
    resolutionRate: {
        title: 'Resolution rate',
        description: 'Share of cases that were resolved, and how quickly the resolution happened.',
        headerEnded: 'Ended cases',
        headerSuccess: 'Resolved',
        headerNotPossible: 'Not possible',
        headerUnresolved: 'Unresolved',
        headerError: 'Errors (excluded from stats)',
        headerPending: 'Pending',
        headerVerified: 'Verified',
        grossRate: 'Gross resolution rate',
        grossRateInfo: 'Share of all ended cases that were resolved (paid, partially paid or settlement).',
        netRate: 'Net resolution rate',
        netRateInfo: 'Share of resolved cases out of ended cases — excluding cases removed from statistics as errors (case-creation errors, withdrawn, merged, etc.).',
        grossMoneyRate: 'Gross resolution rate (DKK)',
        grossMoneyRateInfo: 'Collected amount versus total principal across all cases ended in the period.',
        collectedAmount: 'Collected',
        totalPrincipalEnded: 'Principal ended',
        avgDaysToResolution: 'Avg. time to resolution',
        avgDaysToResolutionInfo: 'Average number of days from case creation until the case was ended as resolved.',
        medianDaysToResolution: 'Median time to resolution',
        speedHeader: 'Resolution speed',
        speedInfo: 'Share of resolved cases resolved within each time frame. Cumulative share.',
        speedWithinDays: 'Within {days} days',
        byMonthHeader: 'Ended cases per month',
        byEndReasonHeader: 'Distribution by end reason',
        legendHeader: 'What the categories mean',
        legendIntro: 'Each end reason belongs to one of four categories. The category determines whether the case counts as resolved, unresolved or is excluded from the statistics.',
        columnEndReason: 'End reason',
        columnCategory: 'Category',
        columnCount: 'Count',
        columnPrincipal: 'Principal',
        columnCollected: 'Collected',
        daysSuffix: 'days',
        explainCategories: 'Explain resolution categories',
        excludingErrors: (count) => `${count} excl. errors`,
        percentOfAll: (percent) => `${percent} of all`,
        medianPrefix: 'Median',
    },
    courtSubmitErrors: {
        [SubmitToCourtError.IsNotWarned]: 'Case not warned',
        [SubmitToCourtError.CurrencyNotDKK]: 'Currency not DKK',
        [SubmitToCourtError.WarningWasReturned]: 'Warning not delivered',
        [SubmitToCourtError.AlreadyHasFoundation]: 'A foundation has already been registered on this case',
        [SubmitToCourtError.MoreThanOneDebtor]: 'There is more than one debtor on this case',
        [SubmitToCourtError.HasAlternativeContact]: 'Case has alternative contact',
        [SubmitToCourtError.EconomyContactMissing]: 'A responsible for payment to court is missing',
        [SubmitToCourtError.CreditorNameMissing]: 'Creditor name missing',
        [SubmitToCourtError.CreditorAddressMissing]: 'Creditor address is missing',
        [SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: '"Fuldt ansvarlig deltager" Is missing',
        [SubmitToCourtError.CompanyDirectorNameMissing]: 'Name of director is missing',
        [SubmitToCourtError.CompanyDirectorAddressMissing]: 'Address of director is missing',
        [SubmitToCourtError.JurisdictionMissing]: 'Could not find court',
        [SubmitToCourtError.EconomicalSubmitThreshold]: 'Case balance less than the threshold',
        [SubmitToCourtError.SagsfremstillingMissing]: 'Case presentation is missing',
        [SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Case has exceeded creditors max debt registrations threshold',
        [SubmitToCourtError.AlreadyInCourt]: 'Already registered in court',
        [SubmitToCourtError.AddressNotInDK]: 'Address not danish',
        [SubmitToCourtError.DebtorMovedAbroad]: 'Debtor has moved abroad',
        [SubmitToCourtError.CaseHasDeposits]: 'Case has deposits',
        [SubmitToCourtError.DebtorBankrupt]: 'Debtor is bankrupt',
        [SubmitToCourtError.DebtorCompanyCeased]: 'Debtor company ceased',
        [SubmitToCourtError.DebtorDead]: 'Debtor is dead',
        [SubmitToCourtError.DebtorHomeless]: 'Debtor is homeless',
        [SubmitToCourtError.ExcessiveReminderFeeImposed]: 'Too many reminder fees imposed',
        [SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'Too many collection fees imposed',
        [SubmitToCourtError.ExcessiveCollectionCostImposed]: 'The collection costs do not match the calculated amount',
        [SubmitToCourtError.ExcessivePrincipal]: 'The principal is above the maximum allowed',
        [SubmitToCourtError.IsNotDebtor]: 'The selected contact person is a representative',
    },
    templateTags: {
        [TemplateTag.BPKWarning]: 'Bailiff warning',
        [TemplateTag.DebtRegistrationWarning]: 'RKI warning',
    },
    templates: {
        allTemplates: 'All templates',
        searchTemplates: 'Search templates',
        customTemplates: 'Created templates',
        standardTemplates: 'Standard templates',
        confirmDelete: 'Are you sure you want to delete this template?',
        delete: 'Delete',
        updateTypesUsingThisTemplate: 'Tasks using this template',
        newTemplate: 'New template',
        selectType: 'Select type',
        letter: 'Letter',
        name: 'Name',
        create: 'Create',
        quantityTemplates: 'Quantity Templates',
        singleOwner: 'Select a single owner',
        standard: 'Standard',
        alternativeContact: 'Alternative contact',
        saveDraft: 'Save Draft',
        saveAndPublish: 'Save and publish',
        preview: 'Preview',
        versions: 'Versions',
        publish: 'Publish',
        copyOtherTemplate: 'Import from template',
        copy: 'Copy template',
        settings: 'Settings',
        lastChangedOn: 'Last changed on',
        by: 'by',
        WIP: 'Work in progress',
        versionPublished: 'This version is Published',
        selectTestCase: 'Please select a test case',
        collector: 'Collector',
        ifCollectorSelected: 'If selected this template will only be show on cases with the collector.',
        selectCollector: 'Select collector',
        creditor: 'Creditor',
        ifCreditorSelected: 'If selected this template will only be show on cases with the creditor.',
        selectCreditor: 'Select creditor',
        letterTheme: 'Letter theme',
        ifThemeSelected: 'This selects the design of the template.',
        selectTheme: 'Select template theme',
        fileName: 'File name',
        docxTemplate: 'Word template (.docx)',
        docxTemplateDescription: 'Upload a Word document to render the letter from. Insert {~~body} where the rich-text editor content should appear (HTML is rendered via the docxtemplater HTML module). Other placeholders (e.g. {customer.name}) are filled in from case data.',
        uploadDocxTemplate: 'Upload .docx',
        removeDocxTemplate: 'Remove .docx template',
        docxTemplateUploaded: 'Word template uploaded',
        docxTemplateUploadFailed: 'Failed to upload Word template',
        docxAvailableTags: 'Available template tags',
        docxAvailableTagsDescription: 'Click any tag to copy it. Paste into the Word template where you want the value to appear.',
        docxTag: 'Tag',
        docxBodyTagDescription: 'Insert the rich-text editor content here (rendered as HTML).',
        docxConditionalBadge: 'Conditional',
        docxConditionalIfTrue: 'If true',
        docxConditionalIfFalse: 'If false',
        docxConditionalDescription: 'Use the first block to show content when the field is truthy and the second block when it is falsy. Copy only the block you need — both can be used together if you want different content for both cases.',
        docxHtmlDescription: 'The value contains HTML and is rendered as formatted text (line breaks, bold, etc. are preserved).',
        state: 'State',
        type: 'Type',
        savedAt: 'Saved at',
        firstName: 'First name',
        lastName: 'Last name',
        view: 'View',
        confirmDeleteItem: 'Are you sure you wish to delete this item?',
        confirmPublish: 'Changes are NOT saved. You are going to publish the last saved version of the template. Are you sure?',
        validations: {
            missing: 'Missing',
            invalidOrder: 'Invalid order',
            inSubject: 'in subject',
            inBody: 'in body',
        },
        addTag: 'Add tag',
        selectTag: 'Select tag',
    },
    templateTypes: {
        [TemplateType.AUTOCALL]: 'Autocall',
        [TemplateType.EBOKS]: 'e-Boks',
        [TemplateType.KIVRA]: 'Kivra',
        [TemplateType.DIGIPOST]: 'Digipost',
        [TemplateType.EMAIL]: 'E-mail',
        [TemplateType.LETTER]: 'Letter',
        [TemplateType.SMS]: 'SMS',
        [TemplateType.CREDITOR_MESSAGE]: 'Creditor message',
        [TemplateType.DEBTOR_MESSAGE]: 'Debtor message',
        [TemplateType.NOTE]: 'Note on case',
    },
    integrations: {
        chooseCreditor: 'Choose the creditor for integration',
        active: 'Active',
        activeIntegrations: 'Active integrations',
        available: 'Integrations available for creditor',
        unavailable: 'Integrations unavailable for creditor',
        isAvailable: 'Give creditor access to setup or disable integration',
        connect: 'Connect',
        deactivate: 'Pause integration',
        reactivate: 'Reactivate',
        integrationOptions: 'integration options',
        importAllText: 'Import invoices before due date',
        updateCustomers: 'Update customer data, when changed in e-conomic',
        cutoffDateText: 'Cutoff date (Only import invoices after this date, imports all if not set)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Number of days after the invoice date the postings should be transferred',
        dueDate: 'Number of days after the invoice due date the postings should be transferred',
        notChangable: 'The options can not be changed again later.',
        all: 'All',
        recommended: 'Recommended',
        essential: 'Essential',
        additionalCustomers: 'additional customers',
    },
    eConomicTypeName: {
        creditNote: 'Credit note',
        invoice: 'Invoice',
        payment: 'Payment',
        reminder: 'Reminder',
    },
    integrationMapper: {
        voucherNumber: 'Voucher number',
        invoiceNumber: 'Invoice number',
        amountLeftToMap: 'Amount left to map',
        totalAmount: 'Voucher amount',
        noMoreEntries: 'There are no more entries to map',
        selectEntries: 'Select an entry to start mapping',
        customerId: 'Customer id',
        map: 'Map',
        notAvailable: 'E-conomic mapping not available yet, contact the Debbie support for help with mapping',
        selectedEntryLabel: 'Selected entry without mapping',
        potentialMatches: 'Potential matches',
    },
    createdBy: {
        createdBy: 'Created by',
        goToImport: 'Go to import',
    },
    createdByType: {
        [PerformedByType.Connect]: 'connect',
        [PerformedByType.Import]: 'import',
        [PerformedByType.Integration]: 'integration',
        [PerformedByType.Key]: 'API key',
        [PerformedByType.User]: 'user',
        [PerformedByType.Workflow]: 'workflow',
        [PerformedByType.Trigger]: 'trigger',
        [PerformedByType.VoucherApplication]: 'rule based voucher',
        [PerformedByType.BulkAction]: 'bulk action',
        [PerformedByType.UpdateTypeOnCaseEnd]: 'update type on case end',
        [PerformedByType.InteractionCategory]: 'interaction category',
        [PerformedByType.AI]: 'AI',
        [PerformedByType.PaymentPlan]: 'payment plan',
        [PerformedByType.System]: 'system',
    },
    createdByTypeLabel: {
        [PerformedByType.PaymentPlan]: 'pp',
    },
    journalizer: {
        update: 'Update',
        deleteInteraction: 'Delete interaction',
        unknownEntityInteraction: 'Request journal number',
        recentlyJournalized: 'RECENTLY JOURNALIZED',
        unmap: 'UNMAP',
        suggested: 'SUGGESTED',
        noInteractions: 'There are currently no interactions',
        searchCreditors: 'Search creditors...',
        journalizeOnCase: 'Journalize on case',
        journalizeOnCreditor: 'Journalize on creditor',
    },
    returnLetter: {
        unknownAtAddress: 'Unknown recipient',
        addressNotAdequate: 'The address is inadequate',
        nameNotVisible: "The recipient's name is not visible on the mailbox",
        recipientMoved: 'The recipient moved and the new address is unknown or there are problems concerning moving',
        recipientNoExist: 'The recipient does not exist',
        letterCantBeDelivered: 'The letter can not be delivered',
        cantFindStreet: 'Street name/house number can not be found',
        mailboxIssue: 'Problems with the mailbox',
        emptyPlace: 'The residence is uninhabited/empty house/apartment',
        noHouseOrConstruction: 'There is no residence or it is under construction',
        otherIssues: 'Issues such as lack of snow removal or other issues that prevent access',
        deliveryRejected: 'Delivery rejected',
        recipientRejectsLetter: 'The recipient rejects the delivery and does not accept to receive the letter',
    },
    returnLetterReasons: {
        [ReturnReason.DENIED]: 'Denied',
        [ReturnReason.NOTDELIVERABLE]: 'Not deliverable ',
        [ReturnReason.UNKNOWNRECIPIENT]: 'Unknown recipient',
    },
    outbox: {
        verifyInteraction: 'Verify interaction',
        editTemplate: 'Edit template',
        deleteInteraction: 'Delete interaction',
        rollbackChain: 'Rollback workflow',
        goToCase: 'Go to case',
        envelope: 'Envelope',
        nextLetterSending: 'Next letter sending scheduled to',
        filters: 'Filters',
        includeInteractionsPaused: 'Include interactions on paused cases',
        aiFilterHeader: 'AI',
        aiFilterAll: 'All',
        aiFilterAi: 'AI',
        aiFilterNoAi: 'No AI',
        filterOnInteractionType: 'Filter on types of interactions',
        filterOnCreditor: 'Filter on creditor',
        filterOnTemplate: 'Filter on template',
        autoSendModalHeader: 'Set up automatic sending',
        autoSendDescription: 'Specify how many manual sends must be made from the outbox for each template version before messages are sent automatically. If you set the value to 0, all messages will be sent automatically without requiring approval. This allows for flexibility between full automation and manual control—depending on your needs.',
        configureAutoSend: 'Set up automatic sending',
        autoSendOn: 'Once {{autoSendQuantity}} messages using this template version have been sent, all future messages will be sent automatically.',
    },
    inputs: {
        creditorSelect: 'Select creditor',
        from: 'From',
        to: 'To',
        max: 'Max.',
        min: 'Min.',
        phoneNumber: 'Phone number',
        phoneLocale: 'Locale',
        searchForCompany: 'Search companies',
        search: 'Search',
        noResults: 'No results',
        recentlyUsed: 'Recently used',
        clear: 'Clear',
        searchAddress: 'Search address',
        manual: 'Manual',
        address: 'Address',
        noAddress: 'No address',
        co: 'C/O',
        zipcode: 'Zipcode',
        city: 'City',
        country: 'Country',
        done: 'Done',
        removeAddress: 'Remove address',
        remove: 'Remove',
        save: 'Save',
        saved: 'Saved',
        dropToUpload: 'Drop to upload',
        uploadFailed: 'Upload failed',
        overrideDefault: 'Override default value',
        overrideTenantSetting: 'Override tenant setting',
    },
    paymentOptions: {
        addNew: 'Add new payment option',
        currencies: 'Valutaer',
        bankName: 'Bank name',
        registrationNumber: 'Registration number',
        accountNumber: 'Account number',
        fi: 'FI creditor number',
        fikSyntax: 'Brug hovedstolsposteringens referencenummer som id i stedet for sagsnummer',
        useAlternativeCreditorNumberInCaseVoucherTables: 'Use alternative creditor number in case voucher tables',
        iban: 'IBAN creditor number',
        swift: 'SWIFT creditor number',
        reepayPrivateKey: 'Frisbii private API key',
        farpayPrivateKey: 'Farpay private API key',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Only selected currencies',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Active payment gateway',
        confirmChangeOfPaymentGateway: 'Are you sure you want to change your payment gateway?',
        mobilePeopleHmac: 'MobilePeople HMAC',
        mobilePeopleClientRef: 'MobilePeople Client Reference',
        url: 'Link to payment gateway',
        titleToDebtor: 'Debtorweb title',
        descriptionToDebtor: 'Debtorweb description',
        hideOnDebtorweb: 'Hide on debtor web',
    },
    paymentOptionTypes: {
        [PaymentOptionType.BANKTRANSFER]: 'Bank transfer',
        [PaymentOptionType.FI]: 'FIK line',
        [PaymentOptionType.SWIFT]: 'SWIFT',
        [PaymentOptionType.REEPAY]: 'Frisbii Payment Gateway',
        [PaymentOptionType.FARPAY]: 'Farpay Payment Gateway',
        [PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople Payment Gateway',
        [PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Link to own payment gateway',
    },
    todoPanel: {
        searchTodos: 'Search',
        overdueTooltip: (count) => `${count} ${count === 1 ? 'task is' : 'tasks are'} past deadline`,
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-en.svg',
        readMore: 'Read more',
    },
    home: {
        welcome: 'Welcome',
        todos: 'Todos',
        caseworkerTodo: 'Caseworker Todos',
        todoPlaceholder: 'Nothing to show',
        clientTodo: 'Creditor Todos',
        clientTodoPlaceholder: 'Nothing to show',
        noResponsibleTodo: 'Todos without any responsible',
        noResponsibleTodoPlaceholder: 'Nothing to show',
        pendingCases: 'Pending cases',
        pendingCasesPlaceholder: 'No pending cases to show',
        pendingDunningCases: 'New dunning cases',
        pendingDunningCasesPlaceholder: 'No new dunning cases to show',
        topCases: 'Top 150 cases by debt amount',
        topCasesPlaceholder: 'No case to show',
        unassigned: 'Unassigned',
        today: 'Today',
        yesterday: 'Yesterday',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        deposits: 'Deposits',
        depositsSmall: 'deposits',
        depositsToClient: 'Deposits to creditor',
        depositsToCollector: 'Deposits to collector',
        depositCount: 'Deposit count',
        paymentPlans: 'Payment Plans',
        totalPlans: 'Total plans',
        totalActivePlans: 'Active plans',
        totalSettledAmount: 'Total settled amount',
        settledAmountLastMonth: 'Settled amount last month',
        settledAmountThisMonth: 'Settled amount this month',
        plannedAmountNextMonth: 'Planned amount next month',
        cases: 'Cases',
        interactions: 'Interactions',
        foundations: 'Foundations',
        totalFoundations: 'Total foundations',
    },
    autoCall: {
        called: 'To',
        from: 'From',
        with: 'with',
        withVoice: "s' voice",
        call: 'Call',
        addAction: 'Add action',
        selectAction: 'Select action',
    },
    autoCallEvents: {
        started: 'Started',
        ringing: 'Ringing',
        answered: 'Answered',
        completed: 'Completed',
        inbound: 'Inbound',
        busy: 'Busy',
        timeout: 'Not answered',
        rejected: 'Rejected',
        machine: 'Voicemail',
    },
    interactionTypes: {
        [InteractionType.AutoCall]: 'Autocall',
        [InteractionType.ClientNote]: 'Creditor message',
        [InteractionType.DebtorNote]: 'Debtor message',
        [InteractionType.Eboks]: 'e-Boks',
        [InteractionType.Kivra]: 'Kivra',
        [InteractionType.Digipost]: 'Digipost',
        [InteractionType.Email]: 'Email',
        [InteractionType.Letter]: 'Letter',
        [InteractionType.Note]: 'Note',
        [InteractionType.Other]: 'Other',
        [InteractionType.Personal]: 'Personal',
        [InteractionType.Phone]: 'Call',
        [InteractionType.SMS]: 'SMS',
        [InteractionType.EInvoice]: 'E-Invoice',
    },
    interactions: {
        interaction: 'interaction',
        replyPrefix: 'Re:',
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'When registering the phone call the phone number will be deleted from debtor.',
        events: 'Events',
        send: 'Send',
        sendLetter: 'Send letter',
        addTemplate: 'Add from template',
        sendEBoks: 'Send',
        from: 'From',
        to: 'To',
        subject: 'Subject',
        sent: 'Sent',
        debtorInteraction: 'Message',
        messageFromCreditor: 'Message from creditor',
        messageToCreditor: 'Message to creditor',
        messageFromDebtor: 'Message from debtor',
        messageToDebtor: 'Message to debtor',
        messageFromCollector: 'Message from collector',
        messageToCollector: 'Message to collector',
        newInteractions: 'New interactions',
        courtEmailSubject: 'Case with {{collector.name}}: {{tribunal.latestReferenceId}} [case no.: {{journalNumber}}]',
        emailSubjectMessageFrom: 'Message from',
        areYouSureProcedure: 'Are you sure you want to execute this shortcut?',
        procedures: 'Shortcuts',
        reminder: 'Reminder',
        unlikelyToReceive: 'Prior interactions using this channel failed',
        removeMarking: 'Remove marking',
        attachment: 'attachment',
        other: 'Other',
        OUTGOING: 'Outgoing',
        INCOMING: 'Incoming',
        UNMAPPED: 'Unmapped',
        MAPPED: 'Mapped',
        HANDLED: 'Handled',
        DELETED: 'Deleted',
        PENDING: 'Pending',
        CANCELLED: 'Cancelled',
        SENT: 'Sent',
        QUEUED: 'Queued',
        delete: 'Delete',
        verify: 'Verify',
        transacted: 'Sent',
        journalizedAt: 'Journalized at',
        at: 'at',
        journaled: 'Interaction was journalized',
        unjournaled: 'Interaction was unjournalized',
        journaledBy: 'Journalized by',
        unjournaledBy: 'Unjournalized by',
        onCase: 'On case',
        copiedBy: 'Copied by',
        toCase: 'To case',
        fromCase: 'From case',
        rollback: 'Rollback',
        unmap: 'Unmap',
        editTemplate: 'Edit template',
        envelope: 'Envelope',
        readMore: 'Read More',
        readLess: 'Read Less',
        downloadFailed: 'Download failed',
        downloadSuccessful: 'Preview PDF is downoladed',
        selectTemplate: 'Select template',
        contact: 'Contact',
        preview: 'Preview',
        mention: 'Merge field',
        explanation: 'Explanation',
        example: 'Example',
        addDebtorDocuments: 'Add debtor documents',
        addIntent: 'Add intent',
        sendEmail: 'Send Email',
        reply: 'Reply',
        replyingTo: 'Replying to',
        thread: 'View thread',
        emailThread: 'Email thread',
        note: 'Note',
        addNote: 'Add note',
        sendNoteToDebtor: 'Send note to debtor',
        sendNoteToClient: 'Send note to creditor',
        recipients: 'Recipients',
        addRecipient: 'Add recipient',
        removeRecipient: 'Remove recipient',
        noClientUsersOnCreditor: 'There are no client users on this creditor. Invite a user to notify them by email.',
        noRecipientsSelected: 'No one will be notified by email',
        inviteClientUser: 'Invite client user',
        selectRecipient: 'Select recipient',
        selectMinimumOneTag: 'Select at least one tag',
        addFiles: 'Add files',
        remindingDescription: 'Reminding description',
        remindingDate: 'Reminding date',
        setReminder: 'Set reminder',
        download: 'Download',
        downloadDocx: 'Download Word',
        phoneNumber: 'Phone number',
        phoneNotes: 'Phone notes',
        registerPhoneCall: 'Register phone call',
        sendSMS: 'Send SMS',
        smsMultipleDeliveriesWarning: 'Multiple delivery events indicate a long SMS that was split into parts.',
        opposition: 'Dispute',
        notOpposition: 'Not a dispute',
        optionalNote: 'Optional note',
        visibilityCheckText: 'Visible to creditor',
        hideFromClient: 'Hide from creditor',
        hiddenFromClient: 'Hidden from creditor',
        showToClient: 'Show to creditor',
        printPDF: 'Download PDF',
        seeDocument: 'See document',
        clone: 'Clone to other case',
        cloned: 'Interaction cloned',
        generateReply: 'Generate AI reply',
        generatingReply: 'Generating reply...',
        aiGenerated: 'AI generated',
        replyGenerated: 'Reply generated and added to outbox',
        replyBlocked: 'Reply blocked for manual review',
        deliveredAt: 'Delivery time',
        failedAt: 'Time of failure',
        eBoksMessageId: 'e-Boks message ID',
        reason: 'Reason',
        recipientDomain: 'Recipient domain',
        recipient: 'Recipient',
        recipientIpAddress: 'Recipient IP address',
        deliveryMethod: 'Delivery method',
        routingDomain: 'Routing domain',
        openedAt: 'Opened at',
        emailOpenedWarning: 'Note: Email open statistics may be inaccurate. False positives can occur if the email client automatically loads images. False negatives can occur if the recipient has disabled images in their email client.',
        emailDelayed: 'Email could not be delivered - retrying later',
        delayedAt: 'Time of delay',
        delayReason: 'Delay reason',
        bounceCode: 'Bounce code',
        errorCode: 'Error code',
        complainedAt: 'Time of complaint',
        complaintType: 'Complaint type',
        letterReturned: 'Letter returned',
        operator: 'Operator',
        clickedLink: 'Clicked link',
        referer: 'Referer',
        userAgent: 'User agent',
        duration: 'Duration',
        network: 'Network',
        subState: 'Sub-state',
        digits: 'Digits entered',
        timedOut: 'Timed out',
        timedOutDescription: 'The user did not end with hash.',
        actions: 'Actions',
        template: 'Template',
        eInvoiceEvents: {
            created: 'Created',
            transmissionStarted: 'Transfer started',
            transmissionCompleted: 'Transfer completed',
            sent: 'Sent',
            received: 'Received',
            endpointNotFound: 'Error',
            error: 'Error',
            documentId: 'Document ID',
            statusCode: 'Status code',
            statusMessage: 'Status message',
            deliveryType: 'Delivery type',
            receiver: 'Receiver',
            receiverCvr: 'Receiver CVR',
        },
    },
    interactionEventTypes: {
        [InteractionEventType.Journaled]: 'Journaled',
        [InteractionEventType.Copied]: 'Copied',
        [InteractionEventType.Clicked]: 'Link clicked',
        [InteractionEventType.Complained]: 'Complained',
        [InteractionEventType.Delivered]: 'Delivered',
        [InteractionEventType.Failed]: 'Failed',
        [InteractionEventType.Opened]: 'Opened',
        [InteractionEventType.Delayed]: 'Queued',
        [InteractionEventType.Answered]: 'Answered',
        [InteractionEventType.Cancelled]: 'Cancelled',
        [InteractionEventType.Started]: 'Started',
        [InteractionEventType.Ringing]: 'Ringing',
        [InteractionEventType.Completed]: 'Completed',
        [InteractionEventType.Voicemail]: 'Voicemail',
        [InteractionEventType.HumanAnswered]: 'Human detected',
        [InteractionEventType.DigitsEntered]: 'Digits entered',
        [InteractionEventType.Inbound]: 'Inbound call',
        [InteractionEventType.Sent]: 'Sent',
        [InteractionEventType.TransmissionStarted]: 'Transmission started',
        [InteractionEventType.Created]: 'Created',
        [InteractionEventType.Received]: 'Received',
        [InteractionEventType.SendingApproved]: 'Sending approved',
        [InteractionEventType.TransferredToPrintAndDistribution]: 'Sent to print and distribution',
    },
    outboundPhone: {
        noCasesLeft: 'No cases to show',
        priority: 'Priority',
        nextCase: 'Next case',
    },
    outgoingPhoneCallTags: {
        [PhoneOutgoingTag.FullPayment]: 'Full payment',
        [PhoneOutgoingTag.IncorrectNumber]: 'Number does not exist',
        [PhoneOutgoingTag.NoAnswer]: 'No answer',
        [PhoneOutgoingTag.WrongNumber]: 'Wrong number',
        [PhoneOutgoingTag.Opposition]: 'Dispute',
        [PhoneOutgoingTag.Other]: 'Other reason',
        [PhoneOutgoingTag.OtherAgreement]: 'Other agreement',
        [PhoneOutgoingTag.PaymentPlan]: 'Payment plan',
    },
    incomingPhoneCallTags: {
        [PhoneIncomingTag.FullPayment]: 'Full payment',
        [PhoneIncomingTag.Opposition]: 'Dispute',
        [PhoneIncomingTag.Other]: 'Other reason',
        [PhoneIncomingTag.OtherAgreement]: 'Other agreement',
        [PhoneIncomingTag.PaymentPlan]: 'Payment plan',
        [PhoneIncomingTag.Billing]: 'Billing',
        [PhoneIncomingTag.Terms]: 'Terms',
        [PhoneIncomingTag.Caseworking]: 'Caseworking',
    },
    procedures: {
        procedure: 'Shortcut',
        customProcedures: 'Created shortcuts',
        standardProcedures: 'Standard shortcuts',
        deleteProcedure: 'Delete shortcut',
        confirmDeleteProcedure: 'Are you sure you want to delete this shortcut?',
        general: 'General',
        generalDescription: 'General settings for this shortcut',
        showOnCase: 'Show on case',
        save: 'Save',
        selectedProcedure: 'Shortcuts',
        createProcedure: 'Create shortcut',
        title: 'Title',
        description: 'Description',
        triggers: 'Triggers',
        defaultToSystemStandard: 'If no trigger selected:',
        emptyTrigger: 'No trigger selected',
        deleteConfirmation: 'You are about to remove this procedure from a trigger. Are you sure you want to continue?',
        associatedWithCollector: 'Associated with collector',
        selectCollector: 'Select collector',
        selectSetting: 'Select setting',
        associatedWithCreditor: 'Associated with creditor',
        selectCreditor: 'Select creditor',
        tasks: 'Tasks',
        tasksDescription: 'Tasks to be run.',
        automaticTask: 'Automatic tasks',
        selectUpdate: 'Select tasks',
        add: 'Add',
        taskOrderExplainer: 'Tasks are checked from the top down — the first task whose requirements are met is the one that runs. Drag tasks to change their order.',
        noTasksYet: 'No tasks yet — add the first one below.',
        otherwise: 'otherwise',
        untilManualContinuation: 'until manually continued',
        addTask: 'Add task',
        removeTask: 'Remove task',
        economyProcedureTriggers: 'Economy',
        paymentPlansProcedureTriggers: 'Payment plans',
        debtExpiredProcedureTriggers: 'Debt expiration',
        CosmoProcedureTriggers: 'Debtor events',
        interactionProcedureTriggers: 'Interactions',
        otherProcedureTriggers: 'Others',
        timeBeforeExpiration: 'Time before expiration',
        atExpiration: 'At expiration',
        beforeExpiration: 'before expiration',
        proceduresToRun: 'Procedures to run',
        foundationFilter: 'Foundation requirement',
        foundationFilterAny: 'With or without foundation',
        foundationFilterWithFoundation: 'Only with foundation',
        foundationFilterWithoutFoundation: 'Only without foundation',
        addTriggerConfiguration: 'Add configuration',
        duplicateProcedure: "You can't add the same procedure twice",
        deleteTriggerConfigurationConfirmation: 'Are you sure you want to delete this configuration?',
        emailJournalizedWithCategories: 'When an email is journalized on a case and no category handled it',
        courtEmailJournalizedWithCategories: 'When an email from the court is journalized on a case and no category handled it',
    },
    triggers: {
        [SystemProcedure.CreditorEndedCase]: 'When creditor ends a case',
        [SystemProcedure.EndCase]: 'On case end',
        [SystemProcedure.Overpayment]: 'On overpayment',
        [SystemProcedure.RemainderReminder]: 'On remainder reminder',
        [SystemProcedure.PrincipalPayment]: 'On remainder reminder matching principal',
        [SystemProcedure.PaymentOnCourtCase]: 'On payment on case in court',
        [SystemProcedure.EndCaseAccord]: 'On accord case end',
        [SystemProcedure.Update]: 'On case update',
        [SystemProcedure.InteractionSentToDebtor]: 'On manual interaction sent to debtor',
        [SystemProcedure.CaseStatusChange]: 'On case status change',
        [SystemProcedure.ObjectionOnRelatedCase]: 'When a new case is created and the customer has objected to a claim on another case',
        [SystemProcedure.PaymentPlanInitial]: 'On activation of payment plan',
        [SystemProcedure.PaymentPlanDocumentSigned]: 'On signing of document when activating a payment plan',
        [SystemProcedure.PaymentPlanReminder]: 'On reminder of payment plan entry',
        [SystemProcedure.PaymentPlanPayment]: 'On payment plan entry payment',
        [SystemProcedure.PaymentPlanAutoPaymentFailure]: 'On payment plan entry payment failure',
        [SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'On betalingsservice payment submit failure',
        [SystemProcedure.PaymentPlanBSLSRejected]: 'On betalingsservice payment rejected',
        [SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'On betalingsservice agreement cancelled',
        [SystemProcedure.PaymentPlanDeadline]: 'On payment plan entry deadline',
        [SystemProcedure.PaymentPlanCanceled]: 'On payment plan entry cancellation',
        [SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'Two hours after payment plan has been selected but not activated',
        [SystemProcedure.PaymentPlanOneDayActivationReminder]: 'One day after payment plan has been selected but not activated',
        [SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Three days after payment plan has been selected but not activated',
        [SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Cancel unactivated payment plans after activation deadline',
        [SystemProcedure.PaymentPlanCreationByCaseworker]: 'When a caseworker creates a payment plan',
        [SystemProcedure.BankAccountDetailsApprovalRefund]: 'Approval after typing in bank account details for payout of overpayment',
        [SystemProcedure.DebtExpires]: 'When a voucher expires',
        [SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in a debt register but is not yet registered',
        [SystemProcedure.DebtorIsUnderage]: 'On underage debitor',
        [SystemProcedure.Address]: 'On address change',
        [SystemProcedure.Active]: 'When a debtor becomes active',
        [SystemProcedure.Dead]: 'On death',
        [SystemProcedure.Disappeared]: 'On disappearance',
        [SystemProcedure.MovedAbroad]: 'When a debtor moves abroad',
        [SystemProcedure.Homeless]: 'When a debtor becomes homeless',
        [SystemProcedure.CompanyActive]: 'When a company becomes active',
        [SystemProcedure.Inactive]: 'When a company becomes inactive',
        [SystemProcedure.OperationsCeased]: 'When operation is ceased',
        [SystemProcedure.AddressProtection]: 'When address or name protection is registered',
        [SystemProcedure.NewRKIRegristration]: 'When new external RKI registration is registered',
        [SystemProcedure.DeletedRKIRegistration]: 'When external RKI registration is deleted',
        [SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'When external RKI registration is deleted with indication of willingness to pay',
        [SystemProcedure.GuardianStatus]: 'On change of guardian status',
        [SystemProcedure.DissolutionStatus]: 'On dissolution status change',
        [SystemProcedure.AKSFailed]: 'When AKS fails to subscribe',
        [SystemProcedure.BOBEHANDLING]: 'On bankruptcy or death',
        [SystemProcedure.EmailJournalized]: 'When an email is journalized on a case',
        [SystemProcedure.CourtEmailJournalized]: 'When an email from the court is journalized on a case',
        [SystemProcedure.NewAsset]: 'When a new asset is registered',
        [SystemProcedure.NewLien]: 'When a new lien is registered',
        [SystemProcedure.AssetChanged]: 'When an asset is updated',
        [SystemProcedure.LienChanged]: 'When a lien is updated',
        [SystemProcedure.AssetRemoved]: 'When an asset is removed',
        [SystemProcedure.LienRemoved]: 'When a lien is removed',
    },
    procedureTitles: {
        [SystemProcedureId.CreditorEndedCase]: 'When creditor ends a case trough the API',
        [SystemProcedureId.EndCase]: 'Fully paid case',
        [SystemProcedureId.Overpayment]: 'Overpayment',
        [SystemProcedureId.RemainderReminder]: 'Partial paid case',
        [SystemProcedureId.PrincipalPayment]: 'Partial paid case',
        [SystemProcedureId.PaymentOnCourtCase]: 'Payment on case in court',
        [SystemProcedureId.EndCaseAccord]: 'Accord payment',
        [SystemProcedureId.Update]: 'Case update',
        [SystemProcedureId.PaymentPlanInitial]: 'Payment Plan Initial',
        [SystemProcedureId.PaymentPlanReminder]: 'Payment Plan Reminder',
        [SystemProcedureId.PaymentPlanPayment]: 'Payment Plan Settle Success',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Payment Plan Settle Failure',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Payment Plan Submit Failure BS & LS',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Payment Plan rejected payment BS & LS',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Payment Plan agreement cancelled BS & LS',
        [SystemProcedureId.PaymentPlanDeadline]: 'Payment Plan Deadline',
        [SystemProcedureId.PaymentPlanCanceled]: 'Payment Plan Canceled',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Payment Plan Two Hour Activation Reminder',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Payment Plan One Day Activation Reminder',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Payment Plan Three Days Activation Reminder',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Manual Payment Plan Creation Send Offer',
        [SystemProcedureId.DebtExpired]: 'Debt expired',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Debt expires within 3 months',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Debt expires within 3 months with foundation',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in debt register but is not yet registered',
        [SystemProcedureId.DebtorIsUnderage]: 'Debtor is underage',
        [SystemProcedureId.Address]: 'Address',
        [SystemProcedureId.Active]: 'Active',
        [SystemProcedureId.Dead]: 'Dead',
        [SystemProcedureId.Disappeared]: 'Disappeared',
        [SystemProcedureId.MovedAbroad]: 'Moved abroad',
        [SystemProcedureId.Homeless]: 'Homeless',
        [SystemProcedureId.CompanyActive]: 'Company active',
        [SystemProcedureId.Inactive]: 'Inactive',
        [SystemProcedureId.OperationsCeased]: 'Operations ceased',
        [SystemProcedureId.AddressProtection]: 'Name/address protection',
        [SystemProcedureId.NewRKIRegristration]: 'New RKI registration',
        [SystemProcedureId.DeletedRKIRegistration]: 'Deleted RKI registration',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Deleted RKI registration with indication of willingness to pay',
        [SystemProcedureId.GuardianStatus]: 'Guardian status',
        [SystemProcedureId.DissolutionStatus]: 'Dissolution status',
        [SystemProcedureId.AKSFailed]: 'AKS failed',
        [SystemProcedureId.BOBEHANDLING]: 'Estate administration',
        [SystemProcedureId.AgentEscalatedToHuman]: 'Agent escalated to human',
        [SystemProcedureId.EmailJournalized]: 'Email journalized',
        [SystemProcedureId.CourtEmailJournalized]: 'Court email journalized',
    },
    procedureDescriptions: {
        [SystemProcedureId.CreditorEndedCase]: 'When creditor ends a case trough the API',
        [SystemProcedureId.EndCase]: 'Close case and inform contact person.',
        [SystemProcedureId.Overpayment]: 'More has been paid than has been charged.',
        [SystemProcedureId.RemainderReminder]: 'Case partially paid. Inform contact person',
        [SystemProcedureId.PrincipalPayment]: 'Case partially paid. Inform contact person',
        [SystemProcedureId.PaymentOnCourtCase]: 'Payment on case in court. Inform court',
        [SystemProcedureId.EndCaseAccord]: 'Close case with accord payment',
        [SystemProcedureId.Update]: 'The case has been updated.',
        [SystemProcedureId.PaymentPlanInitial]: 'Confirmation send out when creating new plans',
        [SystemProcedureId.PaymentPlanReminder]: 'Reminder send out before the payment date',
        [SystemProcedureId.PaymentPlanPayment]: 'When a payment plan is successfully settled',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'When a payment plan settlement is failed',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'When a payment plan with BS or LS failed to schedule payment',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'When a payment plan with BS or LS has a rejected payment after the first of the month',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'When a payment plan with BS or LS get the agreement cancelled',
        [SystemProcedureId.PaymentPlanDeadline]: 'When a payment plan is not paid before deadline',
        [SystemProcedureId.PaymentPlanCanceled]: 'When a payment plan is not paid after giving a second chance',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'When a payment plan is created but not activated after two hours',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'When a payment plan is created but not activated after one day',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'When a payment plan is created but not activated after three days',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Send Offer for Manual Payment Plan Created by a Caseworker',
        [SystemProcedureId.DebtExpired]: 'The debt is expired',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'The debt expires wihtin 3 months',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Debt with foundation expires within 3 months',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in debt register but is not yet registered',
        [SystemProcedureId.DebtorIsUnderage]: 'On underage debitor',
        [SystemProcedureId.Address]: 'On address change',
        [SystemProcedureId.Active]: 'When a debtor becomes active',
        [SystemProcedureId.Dead]: 'On death',
        [SystemProcedureId.Disappeared]: 'On disappearance',
        [SystemProcedureId.MovedAbroad]: 'When a debtor moves abroad',
        [SystemProcedureId.Homeless]: 'When a debtor becomes homeless',
        [SystemProcedureId.CompanyActive]: 'When a company becomes active',
        [SystemProcedureId.Inactive]: 'When a company becomes inactive',
        [SystemProcedureId.OperationsCeased]: 'When operation is ceased',
        [SystemProcedureId.AddressProtection]: 'When address or name protection is registered',
        [SystemProcedureId.NewRKIRegristration]: 'When new external RKI registration is registered',
        [SystemProcedureId.DeletedRKIRegistration]: 'When external RKI registration is deleted',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'When external RKI registration is deleted with indication of willingness to pay',
        [SystemProcedureId.GuardianStatus]: 'On change of guardian status',
        [SystemProcedureId.DissolutionStatus]: 'On dissolution status change',
        [SystemProcedureId.AKSFailed]: 'When AKS fails to subscribe',
        [SystemProcedureId.BOBEHANDLING]: 'On bankruptcy or death',
        [SystemProcedureId.AgentEscalatedToHuman]: 'When an AI agent escalates a case to a human',
        [SystemProcedureId.EmailJournalized]: 'Creates the "New email journalized" update on the case, pausing it until a caseworker handles the email',
        [SystemProcedureId.CourtEmailJournalized]: 'Creates the "New email from the court" update on the case, pausing it until a caseworker handles the email',
    },
    panels: {
        filters: 'Filters',
        selectAll: 'Select all',
        totalDebt: 'Total debt',
        clickToQueueText: 'Click to queue selected cases',
        queue: 'Queue',
    },
    misc: {
        selectAll: 'Select all',
        notChosen: 'Not chosen',
        showMore: 'show more',
        showLess: 'show less',
        copiedToClipboard: 'Copied to clipboard!',
        cosmoActivated: 'Activated',
        searchForAccount: 'Search for account',
        approve: 'Approve',
        cancel: 'Cancel',
        okay: 'Okay',
        create: 'Create',
        createdAt: 'Created',
        createdBy: 'Created by',
        updatedAt: 'Updated',
        updatedBy: 'Updated by',
        submit: 'Submit',
        save: 'Save',
        saved: 'Saved',
        edit: 'Edit',
        update: 'Update',
        errorCreating: 'Error creating',
        errorUpdating: 'Error updating',
        errorDeleting: 'Error deleting',
        errorPerforming: 'Error performing action related to',
        successCreating: 'created',
        successUpdating: 'updated',
        successDeleting: 'deleted',
        language: 'Language',
        chooseFile: 'Choose file',
        yes: 'Yes',
        no: 'No',
        all: 'All',
        add: 'Add',
        enabled: 'Enabled',
        search: 'Search',
        contactSupport: 'Contact our support',
        error: 'Error',
        errorOccured: 'An error occured',
        days: 'Days',
        date: 'Date',
        loadingError: 'Could not load data',
        export: 'Export',
        exported: 'Exported',
        goToCase: 'Go to case',
        after: 'after',
        skip: 'Skip',
        value: 'Value',
        delete: 'Delete',
        apply: 'Apply',
        unnamed: 'Unnamed',
        name: 'Name',
        description: 'Description',
        learnMore: 'Learn more',
        ascending: 'Ascending',
        descending: 'Descending',
        and: 'and',
        or: 'or',
        id: 'id',
        type: 'Type',
        text: 'Text',
        state: 'State',
        limitReached: 'Limit reached',
        accept: 'Accept',
        loading: 'Loading...',
        logo: 'Logo',
    },
    table: {
        selectedOptions: 'Selected',
        next: 'Next',
        previous: 'Previous',
        first: 'First',
        last: 'Last',
        showing: 'Showing',
        outOf: 'out of',
        loadMore: 'Load more',
        from: 'From',
        to: 'To',
        search: 'Search',
        noData: 'No data',
        clearFilters: 'Clear all filters',
    },
    history: {
        paymentPlanCreated: 'Payment plan created',
        tribunalCaseCreated: 'Tribunal case created',
        documentAdded: 'Document added',
        history: 'History',
        searchHistory: 'Search history',
        filterHistory: 'Filter history',
        filterEconomy: 'Economy',
        filterBilling: 'Billing',
        filterUpdates: 'Tasks',
        filterInteractions: 'Interactions',
        filterDebts: 'Debts',
        filterDebtorTransactions: 'Debtor Transactions',
        filterNotifications: 'Notifications',
        filterCaseStatus: 'Case Status',
        filterType: 'Type',
        filterTags: 'Tags',
        resetFilter: 'Reset',
        hideAll: 'Hide all',
        caseCreated: 'Case created',
        creditorDisbursement: 'Creditor disbursement',
        creditorVat: 'Creditor VAT',
        creditorFee: 'Creditor fee',
        deposit: 'Billing of deposit',
    },
    connect: {
        fromConnectPartner: 'From a connect partner',
        connection: 'Connection',
        connections: 'Connections',
        product: 'Product',
        products: 'Products',
        updates: 'Updates',
        mappedCases: 'Connected cases',
        noConnections: 'No connections yet',
        noProducts: 'No products yet',
        productLogo: 'Logo',
        editProduct: 'Edit product',
        saveProduct: 'Save product',
        productUpdatedTitle: 'Product updated',
        productCreatedTitle: 'Product created',
        invitations: 'Invitations',
        newInvitation: 'New invitation',
        noInvitations: 'No invitations yet',
        statusPending: 'Pending',
        statusAccepted: 'Accepted',
        statusRejected: 'Rejected',
        statusCancelled: 'Cancelled',
        statusExpired: 'Expired',
        receivingCreditor: 'Receiving creditor',
        selectCreditor: 'Select a creditor',
        recipientEmail: 'Recipient email',
        invitationMessage: 'Message (optional)',
        sendInvitation: 'Send invitation',
        invitationSentTitle: 'Invitation sent',
        productToUse: 'Product',
        selectProduct: 'Select a product',
        createNewProduct: 'Create a new product',
        productName: 'Product name',
        productDescription: 'Short description',
        productContent: 'Deal details',
        service: 'Service',
        serviceCollection: 'Collection',
        serviceCourtHandling: 'Court handling',
        workflow: 'Workflow',
        caseGroup: 'Case group',
        billingModel: 'Billing model',
        none: 'None',
        invitationFrom: 'Invitation from',
        invitationIntro: 'wants to receive cases from your organisation.',
        invitationUnavailable: 'This invitation is no longer available.',
        invitationNotPending: 'This invitation has already been handled.',
        sendingCreditor: 'Sending creditor',
        allCreditors: 'All creditors',
        searchProducts: 'Search products',
        searchWorkflows: 'Search workflows',
        propertyTypesToSend: 'Properties the receiver gets access to',
        caseProperties: 'Case properties',
        caseVoucherProperties: 'Case voucher properties',
        noPropertyTypes: 'No case property types available',
        sendInteractionsLabel: 'Also send interactions with each case',
        acceptInvitation: 'Accept and connect',
        invitationAcceptedTitle: 'Connected',
        receivedPropertyTypes: 'Received property types',
        receivedPropertyTypesDesc: 'Choose which of the offered property types to import with each case.',
        noOfferedPropertyTypes: 'The sender did not offer any property types.',
        saveReceivedTypes: 'Save',
        loading: 'Loading',
        mapPropertyTypes: 'Map property types',
        mapPropertyTypesDesc: 'Map each property type the sender sends to one of yours. Unmapped types are not received.',
        doNotReceive: 'Do not receive',
        createMatchingType: 'Create matching type',
        searchProperties: 'Search properties',
        receivesAs: 'Receive as',
        newBadge: 'New',
        mappedSummary: 'properties received',
        connectionSettings: 'Configuration',
        connectionSettingsDesc: 'How cases are shared on this connection.',
        optionOn: 'On',
        optionOff: 'Off',
        sendInteractionsDesc: 'Interactions (emails, SMS, letters, notes) are sent along with each case.',
        filterNonContactUsersLabel: 'Only share contact persons',
        filterNonContactUsersDesc: 'Users not marked as contacts are left out when sharing.',
        alwaysCreateNewCustomerLabel: 'Always create a new customer',
        alwaysCreateNewCustomerDesc: 'Each received case creates a new customer instead of matching an existing one.',
        sharedProperties: 'Shared properties',
        propertiesShare: 'properties shared',
        updatedBy: 'Updated by ',
        partner: 'connect partner',
        us: 'this tenant',
        thirdParty: 'a third party',
        sendsToConn: 'Connection sends cases to',
        sendsFromConn: 'Connection receives cases from',
        histItemHeader: 'Connect -',
        histItemExported: 'Sent to partner',
        histItemRetracted: 'Withdrawn',
        histItemCompleted: 'Task completed',
        histItemDataUpdated: 'Data updated',
        completedWithReason: 'Completed with reason',
        createdDocuments: 'Created documents',
        createdSatisfaction: 'Created satisfaction',
        goToConnection: 'Go to connection',
        goToCreditorWeb: 'Go to creditor web',
        goToCreditor: 'Go to receiving creditor',
        goToProduct: 'Go to product',
        goToCase: 'Go to case',
        creditorWebLinkError: 'Error getting link for creditor web',
        case: 'Case',
        state: 'State',
        exportedDate: 'Exported date',
        completedDate: 'Completed date',
        connectStateCompleted: 'Completed',
        connectStateInProgress: 'In progress',
    },
    connectConnectionUpdate: {
        [ConnectConnectionStatus.Active]: 'Active',
        [ConnectConnectionStatus.Paused]: 'Paused',
        [ConnectConnectionStatus.Disabled]: 'Disabled',
    },
    connectCaseMappingUpdate: {
        [ConnectCaseMappingStatus.Exported]: 'Exported',
        [ConnectCaseMappingStatus.Retracted]: 'Retracted',
        [ConnectCaseMappingStatus.Completed]: 'Completed',
        [ConnectCaseMappingStatus.DataUpdated]: 'Data updated',
    },
    connectRetractionReason: {
        [RetractionReason.Collected]: 'Debt collected',
        [RetractionReason.ConnectionDisabled]: 'Connect connection disabled',
        [RetractionReason.Rollback]: 'Rolled back',
        [RetractionReason.Other]: 'Other',
    },
    product: {
        productHandles: 'Product provides',
    },
    productService: {
        [ProductService.Collection]: 'collection',
        [ProductService.CourtHandling]: 'court handling',
    },
    documents: {
        documents: 'Documents',
        noDocuments: 'No documents',
        deleteDocument: 'Delete document',
        saveDocument: 'Save document',
        autoRKIAddFoundation: 'Auto-RKI is enabled and will attempt to move the RKI registration to the open registry after this foundation is added',
        autoRKIUpdateFoundation: 'Auto-RKI is enabled and will attempt to move the RKI registration to the open registry after this foundation is updated',
        file: 'File',
        signedFile: 'Signed file',
        createdBy: 'Created by',
        docId: 'Doc ID',
        type: 'Type',
        signingLink: 'Signing link',
        generateSigningLink: 'Generate signing link',
        createdAt: 'Created',
        date: 'Date',
        signedAt: 'signed',
        addDocument: 'Add document',
        fromFile: 'From file',
        fromTemplate: 'From template',
        selectCourt: 'Court',
        documentSignedCheckbox: 'Is the document signed?',
        visibleForDebtor: 'Visible for debtor',
        uploadDocument: 'Upload document',
        createDocument: 'Create document',
        preview: 'Preview',
        sendToCourt: 'Send to court',
        paidCourtFee: 'Paid court fee',
        createDate: 'Creation date',
        interestDates: 'Interest dates',
        interestAmount: 'Interest amount',
        totalAmount: 'Total amount',
        amount: 'Amount',
        note: 'Note',
        procesinterest: 'Proces interest',
        interestFromSubmitOfBPK: 'Interest from submit of bailiff claim',
        caseinterest: 'Case interest rate',
        preventForkyndt: 'Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er under rekonstruktion, konkurs eller gældssanering og derfor er beskyttet mod udlæg?',
        preventAutDistress: 'Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner ikke kommer med indsigelser (protester) mod dit krav?',
        preventAutCivilCourt: 'Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner kommer med indsigelser (protester) mod dit krav?',
        selectBPKWarningDate: 'Select BPK warning date',
        directorNameAddress: "Director's/chairman's name and address",
        directorNameAddressDescription: "If the debtor is a company/association – please specify the director's/chairman's name and address if possible:",
        selectDebtors: 'Select debtors',
        selectDebtorsDescription: 'Choose which debtors to include in the bailiff claim.',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        debtorsSelected: 'debtors selected',
        court: 'Court',
        selectType: 'Select type of document',
        sureYouWantToDelete: 'Sure you want to delete',
        sureYouWantToSave: 'Sure you want to save the changes?',
        documentSigned: 'Document signed',
        generateLinkForSigning: 'Generate link for signing',
        addCourtFeeToClientBilling: 'Add fee to creditor billing',
        addCourtDisbursementToClientBilling: 'Add disbursement to creditor billing',
        addCourtFeeToCase: 'Add cost to case',
        sendInfoAboutRequisitionToRes: 'Send information about requisition to the resposible',
        responsible: 'Responsible',
        isFoundation: 'Is foundation',
        [DocumentTypes.COURT]: 'Court',
        [DocumentTypes.FOUNDATION]: 'Foundation',
        [DocumentTypes.OTHER]: 'Other',
    },
    documentTypes: {
        [DocumentTypes.COURT]: 'Court',
        [DocumentTypes.FOUNDATION]: 'Foundation',
        [DocumentTypes.OTHER]: 'Other',
        [DocumentTypes.SKYLDERKLAERING]: 'Guilt statement',
        [DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [DocumentTypes.FORLIG]: 'Settlement',
        [DocumentTypes.DOM]: 'Verdict',
        [DocumentTypes.PAATEGNING]: 'Påtegning',
        [DocumentTypes.GAELDSBREV]: 'Loan',
    },
    files: {
        fileName: 'Filename',
        downloadFailed: 'Download failed',
    },
    updates: {
        continueCase: 'Continue case',
        continueCaseRemove: 'Remove',
        setRemindedAt: 'Set reminding date',
        remindDate: 'Remind at',
        pauseNow: 'Pause now',
        remindNow: 'Remind now',
        pauseUntilReminding: 'Pause on',
        pauseContinueAt: 'Continue on',
        pausedUntil: 'Paused until',
        dateSelectorTooltip: 'Select the date to show the pause status',
        updateWillBeShownIn: 'Will pause in',
        paused: 'Paused',
        reminded: 'reminded',
        pausedAndReminded: 'Paused and reminded in',
        pausedAndRemindedPast: 'Paused and reminded',
        ago: 'ago',
        pausedPast: 'Paused',
        andReminded: 'and reminded in',
        andRemindedPast: 'and reminded',
        expedientAKSActivated: 'Experian AKS activated',
        chooseMoreThanTwoBulkActions: 'Please select two or more tasks to make a bulk processing.',
        bulkActions: 'Bulk action',
        selectAll: 'Select all',
    },
    integrateCalendar: {
        name: 'Subscription name',
        newSubscription: 'New calendar subscription',
        create: 'Create calendar link',
        save: 'Save settings',
        edit: 'Edit',
        cancel: 'Cancel',
        delete: 'Delete subscription',
        confirmDelete: 'Delete this subscription? The calendar link will stop working.',
        courtMeetings: 'Court module meetings',
        updateTypes: 'Update types',
        empty: 'No calendar subscriptions yet.',
        description: 'Create a calendar subscription for this organisation. Select court meeting types and update types below. Only selected types are synchronised, from one month back to one year ahead.',
        privacy: 'Calendar events contain only generic titles and times. Names, notes, addresses and case details are excluded. Anyone with the link can read the calendar until you delete the subscription.',
        noTypes: 'No types selected: this subscription is paused.',
        subscription: 'calendar subscription',
        namePlaceholder: 'E.g. Court meetings',
        nameHint: 'Only used to tell subscriptions apart in Debbie.',
        courtMeetingsHelp: 'Choose the meeting types to include in the calendar. Each court meeting from the court module appears in the calendar on its meeting date.',
        updateTypesHelp: 'Choose the update types to include in the calendar. Each task appears in the calendar on its reminder date.',
        selected: 'selected',
        selectAll: 'Select all',
        clearSelection: 'Clear',
        paused: 'Paused',
        meetingTypesCount: 'court meeting types',
        updateTypesCount: 'update types',
        link: 'Calendar link',
        copyLink: 'Copy link',
        created: 'Created',
        connectToOffice365: 'Sync with Office 365',
        selectUpdateTypes: 'Select task types',
    },
    auth: {
        account: 'Account',
        logout: 'Log out',
        accountInactive: 'Your account is inactive',
        chooseBetweenAccounts: 'Choose between accounts',
    },
    rightNav: {
        creditors: 'Creditors',
    },
    login: {
        email: 'Email',
        password: 'Password',
        login: 'Login',
        twoFactorExplainer: 'We have sent a six digit code to your email. Enter it below to log in.',
        twoFactorPlaceholder: 'Code',
        reset: 'Reset',
        resetTokenExplainer: 'You will receive a code by email, which you must enter here to reset your password.',
        resetTokenPlaceholder: 'Code',
        newPasswordExplainer: 'Enter your new password',
        newPasswordPlaceholder: 'Your new password',
        updatePassword: 'Update',
        couldNotIdentifyYou: 'We could not identify you. Please contact',
        mitIdDescription: 'Log in with MitID to access your data.',
        loginWithMitId: 'Log in with MitID',
    },
    passwordResetEmail: {
        title: 'Reset password',
        body: 'You have requested to change your password. To change your password, enter the following on the page you requested it from:',
    },
    onboarding: {
        welcome: 'Welcome',
        passwordCreatorExplainer: 'To setup your account, please create a password.',
    },
    users: {
        userSettings: 'User settings',
        userCreated: 'User created',
        userUpdated: 'User updated',
        updateFailed: 'User update failed',
        createUser: 'Create user',
        inviteUser: 'Invite user',
        developEmailWarning: "You are on the develop (staging) environment. Invitation, password-reset and 2FA emails are delivered to the recipient's real inbox here — they are not mocked. Only invite real people.",
        name: 'Name',
        role: 'Role',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        username: 'Username',
        password: 'Password',
        users: 'Users',
        noUsers: 'No users to show',
        search: 'Search users',
        newUser: 'New user',
        passwordConfirmation: 'Confirm password',
        creditors: 'Creditors',
        tenants: 'Tenants',
        todoNotifications: 'Receive an email every morning with the new tasks',
        creditorMessageNotifications: 'Receive an email when the collector sends a message',
        selectCreditors: 'Select creditors',
        selectTenants: 'Select tenants',
        selectRole: 'Select role',
        selectUser: 'Select user',
        passwordTooShort: 'Password is too short',
        passwordsDontMatch: "The passwords don't match",
        sendInvite: 'Send email invite',
        sureYouWantToDeleteUser: 'Are you sure you want to delete this user permanently?',
        deleteUser: 'Delete user',
        deleteUserPermanently: 'Delete user permanently',
        archiveUser: 'Archive user',
        sureYouWantToArchiveUser: 'Are you sure you want to archive this user?',
        archiveUserDescription: "Archiving revokes the user's access to the platform but keeps their name and email so historical logs and activity remain readable.",
        archiveUserWarning: 'The user is signed out everywhere and loses their password. If they are reactivated later, they have to accept a new invitation.',
        reactivateUser: 'Reactivate user',
        sureYouWantToReactivateUser: 'Are you sure you want to reactivate this user?',
        reactivateUserDescription: 'The user regains their previous roles and access, and receives an invitation email to set a new password. They cannot sign in until the invitation is accepted.',
        userReactivated: 'The user has been reactivated and invited by email',
        userReactivatedInviteFailed: 'The user has been reactivated, but the invitation email could not be sent. Use "Resend invite" to try again.',
        archivedUsers: 'Archived users',
        activeUsers: 'Active users',
        stateActive: 'Active',
        stateInvited: 'Invited',
        invitedUsers: 'Invited users',
        resendInvite: 'Resend invite',
        inviteResent: 'Invitation has been resent',
        inviteResendFailed: 'Could not resend the invitation',
        inviteLinkExpired: 'This invitation link has expired',
        inviteLinkExpiredDescription: 'Invitation links are valid for 30 days. Request a new one and we will send a fresh link to your email.',
        inviteLinkAlreadyUsed: 'This invitation link has already been used',
        inviteLinkAlreadyUsedDescription: 'You have already created your password. Please log in with your email and password.',
        inviteLinkInvalid: 'This invitation link is invalid',
        inviteLinkInvalidDescription: 'The link could not be recognised. Make sure you opened the latest invitation email.',
        requestNewInvite: 'Request new invitation',
        inviteRequestSent: 'A new invitation has been sent. Please check your email.',
        changeRole: 'Change users role',
        changeRoleNotAdmin: 'Change of roles can be done by an administrator',
        cantChangeClientRole: `Clients' role can't be changed`,
    },
    rolesDescription: {
        [PermissionLevels.admin]: 'This role is for the company administrator/superuser who has access to all functions and can configure all available settings.',
        [PermissionLevels.caseworker]: 'This role is for the employee who must have access to all necessary functions at the case level. There is also access to everything at the creditor level, and under settings the role has access to templates.',
    },
    teams: {
        team: 'Team',
        user: 'User',
        namePlaceholder: 'Team name',
        saveName: 'Save',
        searchNewTeamMember: 'Search for new team member',
        createTeam: 'Create new team',
        assignedTasks: 'Responsible for tasks',
        catchAll: 'Catch all',
        responsibleForUpdateTypes: 'Responsible for tasks',
        addUpdateType: 'Add task',
        selectTeam: 'Team',
        selectUser: 'User',
        responsibleForCase: 'Responsible for case',
    },
    invite: {
        subject: 'Invitation to join',
        body: `Hi \${firstName},

You have been invited to join \${platform}. Please use the link below to accept the invitation.
\${url}?nu_token=\${token}`,
        html: `<p>Hi \${firstName},</p><p>You have been invited to join \${platform}. Please use the link below to accept the invitation.</p>`,
        linkText: 'Log in',
        creditorWeb: 'the creditorweb from',
    },
    roles: {
        'super-admin': 'Super admin',
        admin: 'Admin',
        caseworker: 'Caseworker',
        client: 'Creditor',
        debtor: 'Debtor',
        'alternative-contact': 'Alternative contact',
        unauthorized: 'Unauthorized',
    },
    mentionsConditional: {
        if: 'If',
        endIf: 'End If',
    },
    mentions: {
        [TemplateMention.PaymentPlanAmortisation]: 'Amortisation plan',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generic subject',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Principal',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Collection fees',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administration costs',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Compensation fees',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Interests',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Interest rate',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Collection costs',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Principals reference ids',
        [TemplateMention.CURRENCY]: 'Currency',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Payment Plan First Amount',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Payment Plan First Deadline',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Payment Plan First Date',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Payment Plan Last Amount',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Payment Plan Last Deadline',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Payment Plan Last Date',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Payment Plan Entry Amount',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Payment Plan Entry Deadline',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Payment Plan Entry Date',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Payment Plan Creation Date',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Payment plan length in days',
        [TemplateMention.PaymentPlanApr]: 'APR',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'APR per year',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has yearly interest',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Payment plan min. entry amount',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Payment plan max. entry amount',
        [TemplateMention.TOTAL_DEBT]: 'Total Debt',
        [TemplateMention.OVERPAYMENT]: 'Overpayment',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Accord: 10 % off',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Accord: 20 % off',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Accord: 30 % off',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Accord: 40 % off',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Accord: 50 % off',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Accord: 60 % off',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Accord: 70 % off',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Accord: 80 % off',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Accord: 90 % off',
        [TemplateMention.IF_IS_COMPANY]: 'If company',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'If debtor is registered in a debt registry',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'If case has multiple principals',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'If case has reminder fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'If case has collection fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'If case has collection costs',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'If case has compensation costs',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'If case has process interest',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'If case has fixed interest',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'If case has yearly interest in percent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'If case has deposit',
        [TemplateMention.DOCUMENTATION]: 'Documentation',
        [TemplateMention.DATE]: 'Date',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Date in 3 days',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Date in 6 days',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Date in 10 days',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Date in 11 days',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Date in 12 days',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Date in 14 days',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Date in 17 days',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Date in 30 days',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'The three preceding years',
        [TemplateMention.DEPOSIT]: 'Deposit',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Deposited to creditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Deposited to collector',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Interest paid last year',
        [TemplateMention.CONTACT_NAME]: 'Contact Name',
        [TemplateMention.DEBTOR_NAME]: 'Debtor Name',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debitor first name',
        [TemplateMention.CONTACT_ADDRESS]: 'Contact Street',
        [TemplateMention.CONTACT_COADDRESS]: 'Contact CoAddress',
        [TemplateMention.CONTACT_ZIPCODE]: 'Contact Zipcode',
        [TemplateMention.CONTACT_CITY]: 'Contact City',
        [TemplateMention.CONTACT_COUNTRY]: 'Contact Country',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'If creditor is a company',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'If creditor is vat registered',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'If ultimate creditor',
        [TemplateMention.CASE_CREDITOR_NAME]: 'Case creditor name',
        [TemplateMention.CASE_CREDITOR_ADDRESS]: 'Case creditor street',
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: 'Case creditor zipcode',
        [TemplateMention.CASE_CREDITOR_CITY]: 'Case creditor city',
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: 'Case creditor CVR',
        [TemplateMention.USER_NAME]: 'User name',
        [TemplateMention.USER_FIRST_NAME]: 'User first name',
        [TemplateMention.IF_USER]: 'If user is available',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'If creditor allows bank transfers',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'If creditor allows FI payments',
        [TemplateMention.DEBTOR_ADDRESS]: 'Debtor Street',
        [TemplateMention.DEBTOR_COADDRESS]: 'Debtor CoAddress',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Debtor Zipcode',
        [TemplateMention.DEBTOR_CITY]: 'Debtor City',
        [TemplateMention.DEBTOR_COUNTRY]: 'Debtor Country',
        [TemplateMention.DEBTOR_EMAIL]: 'Debtor email',
        [TemplateMention.DEBTOR_PHONE]: 'Debtor phone number',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Last Payment Date',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Last Payment Amount',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Debtor Seq ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debtor CVR and/or CPR',
        [TemplateMention.CREDITOR_NAME]: 'Creditor Name',
        [TemplateMention.CASE_ID]: 'Case ID',
        [TemplateMention.CASE_REFERENCE_ID]: 'Case reference ID',
        [TemplateMention.CREDITOR_ADDRESS]: 'Creditor Address',
        [TemplateMention.REMINDER_FEES]: 'Reminder Fees',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment Options',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Collector Account Number',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Collector Registration Number',
        [TemplateMention.COLLECTOR_PHONE]: 'Collector Phone',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Collector Court Phone',
        [TemplateMention.COLLECTOR_EMAIL]: 'Collector Email',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Collector Nickname',
        [TemplateMention.COLLECTOR_NAME]: 'Collector Name',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Collector address',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Collector city',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Collector zipcode',
        [TemplateMention.COLLECTOR_CVR]: 'Collector CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Creditor Zipcode',
        [TemplateMention.CREDITOR_CITY]: 'Creditor City',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Creditor CVR',
        [TemplateMention.PAYMENT_ID]: 'Payment ID',
        [TemplateMention.JOURNAL_NUMBER]: 'Journal Number',
        [TemplateMention.COURT_NAME]: 'Court Name',
        [TemplateMention.COURT_ADDRESS]: 'Court Address',
        [TemplateMention.COURT_CITY]: 'Court City',
        [TemplateMention.COURT_ZIP]: 'Court Zip',
        [TemplateMention.COURT_EMAIL]: 'Court Email',
        [TemplateMention.COURT_PHONE]: 'Court Phone',
        [TemplateMention.COURT_EAN]: 'Court EAN',
        [TemplateMention.REG_NO]: 'Court Registration Number',
        [TemplateMention.ACCOUNT_NO]: 'Court Account Number',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Payment Plan Installment Overview',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Contact Address Inline',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Contact Address Formatted',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternative contact reference id',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'If alternative contact has a reference id',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debtor Address Inline',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debtor Address Formatted',
        [TemplateMention.DEBTOR_TABLE]: 'Debtor table',
        [TemplateMention.SIGN_FIELDS]: 'Sign Fields',
        [TemplateMention.DK_BPK]: 'Betalingspåkrav',
        [TemplateMention.GL_BPK]: 'GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Page Break',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Payment Plan Entries',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Payment Plan Status',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Satisfaction Buttons',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link to payment plan options',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link to payment plan options',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link overpayment',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link overpayment QR code',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link to overpayment',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Payment plan options QR code',
        [TemplateMention.PAYMENT_LINK]: 'Link To Payment',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link To Payment',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link To Payment QR code',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link To Debtor Web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link To Debtor Web Long',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link To Debtor Web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link To Debtor Web Long',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link To Debtor Web QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [TemplateMention.CONDITIONAL_END_IF]: 'End If',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Foundation type',
        [TemplateMention.FOUNDATION_DATE]: 'Foundation date',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Latest FS no.',
    },
    mentionsExplanation: {
        [TemplateMention.PaymentPlanAmortisation]: 'Original payment schedule with principal, costs, interest and remaining debt. No payment progress.',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Text for the subject field on email',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'The total principal of the case',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'The total collection fee of the case',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'The total administration cost of the case',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'The total compensation fee of the case',
        [TemplateMention.FINANCIALS_INTERESTS]: 'The total interest of the case',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'The lowest current interest rate on the case',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'The total collection cost of the case',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Principals reference ids',
        [TemplateMention.CURRENCY]: 'Currency of the case economy',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'The amount of the first payment',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Due date of the first payment',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Date of the first payment',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'The amount of the last payment',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Due date of the last payment',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Date of the last payment',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'The amount of the latest payment',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Due date of the latest payment',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Date of the latest payment',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Creation date of the payment plan',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Number of days in the payment plan',
        [TemplateMention.PaymentPlanApr]: 'The annual percentage rate of charge of the payment plan as a single percentage, calculated per annex 1 of the Danish Credit Agreements Act',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Costs as a percentage of the principal, listed year by year of the payment plan',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has yearly interest',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Payment plan min. entry amount',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Payment plan max. entry amount',
        [TemplateMention.TOTAL_DEBT]: 'Amount of the total debt',
        [TemplateMention.OVERPAYMENT]: 'Overpayment amount',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Amount of the total debt 10 % off',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Amount of the total debt 20 % off',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Amount of the total debt 30 % off',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Amount of the total debt 40 % off',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Amount of the total debt 50 % off',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Amount of the total debt 60 % off',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Amount of the total debt 70 % off',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Amount of the total debt 80 % off',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Amount of the total debt 90 % off',
        [TemplateMention.IF_IS_COMPANY]: 'If company',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'If debtor is registered in a debt registry',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'If case has multiple principals',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'If case has reminder fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'If case has collection fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'If case has collection costs',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'If case has compensation costs',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'If case has process interest',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'If case has fixed interest',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'If case has yearly interest in percent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'If case has deposit',
        [TemplateMention.DOCUMENTATION]: 'Documentation',
        [TemplateMention.DATE]: 'Todays date',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Date in 3 days',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Date in 6 days',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Date in 10 days',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Date in 11 days',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Date in 12 days',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Date in 14 days',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Date in 17 days',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Date in 30 days',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'The three years preceding the current year',
        [TemplateMention.DEPOSIT]: 'Total amount of deposits',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Amount deposited to creditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Amount deposited to collector',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Amount paid in interest in the previous calendar year',
        [TemplateMention.CONTACT_NAME]: "Contact person's name",
        [TemplateMention.DEBTOR_NAME]: "Debtor's name",
        [TemplateMention.DEBTOR_FIRST_NAME]: "Debitor' first name",
        [TemplateMention.CONTACT_ADDRESS]: "Contact person's street",
        [TemplateMention.CONTACT_COADDRESS]: "Contact person's c/o",
        [TemplateMention.CONTACT_ZIPCODE]: "Contact person's zipcode",
        [TemplateMention.CONTACT_CITY]: "Contact person's city",
        [TemplateMention.CONTACT_COUNTRY]: "Contact person's country",
        [TemplateMention.DEBTOR_ADDRESS]: "Debtor's street",
        [TemplateMention.DEBTOR_COADDRESS]: "Debtor's c/o",
        [TemplateMention.DEBTOR_ZIPCODE]: "Debtor's zipcode",
        [TemplateMention.DEBTOR_CITY]: "Debtor's city",
        [TemplateMention.DEBTOR_COUNTRY]: "Debtor's country",
        [TemplateMention.DEBTOR_EMAIL]: "Debtor's email",
        [TemplateMention.DEBTOR_PHONE]: "Debtor's phone number",
        [TemplateMention.LAST_PAYMENT_DATE]: 'Date of last payment',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Amount of last payment',
        [TemplateMention.DEBTOR_SEQ_ID]: "Debitor's ID",
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: "Debtor's CVR and/or CPR",
        [TemplateMention.CREDITOR_NAME]: "Creditor's name",
        [TemplateMention.CASE_ID]: 'The case ID',
        [TemplateMention.CASE_REFERENCE_ID]: 'Case reference ID',
        [TemplateMention.CREDITOR_ADDRESS]: "Creditor's address",
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'If creditor is a company',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'If creditor is a vat registered',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'If the case has an ultimate creditor. The creditor mentions (name, address and CVR) automatically use the ultimate creditor on cases where one is set',
        [TemplateMention.CASE_CREDITOR_NAME]: "The name of the creditor on the case. Never replaced by the ultimate creditor's details",
        [TemplateMention.CASE_CREDITOR_ADDRESS]: "The address of the creditor on the case. Never replaced by the ultimate creditor's details",
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: "The zipcode of the creditor on the case. Never replaced by the ultimate creditor's details",
        [TemplateMention.CASE_CREDITOR_CITY]: "The city of the creditor on the case. Never replaced by the ultimate creditor's details",
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: "The CVR of the creditor on the case. Never replaced by the ultimate creditor's details",
        [TemplateMention.USER_NAME]: 'User name',
        [TemplateMention.USER_FIRST_NAME]: 'User first name',
        [TemplateMention.IF_USER]: 'If user is available',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'If creditor allows bank transfers',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'If creditor allows FI payments',
        [TemplateMention.REMINDER_FEES]: 'The total reminder fee of the case',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment Options',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: "Collector's bank account number",
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: "Collector's bank registration number",
        [TemplateMention.COLLECTOR_PHONE]: "Collector's phone number",
        [TemplateMention.COLLECTOR_COURT_PHONE]: "Collector's court phone number",
        [TemplateMention.COLLECTOR_EMAIL]: "Collector's email",
        [TemplateMention.COLLECTOR_NICKNAME]: "Collector's nickname",
        [TemplateMention.COLLECTOR_NAME]: "Collector's name",
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: "Collector'd address",
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: "Collector's city",
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: "Collector's zipcode",
        [TemplateMention.COLLECTOR_CVR]: "Collector's CVR",
        [TemplateMention.CREDITOR_ZIPCODE]: "Creditor's zipcode",
        [TemplateMention.CREDITOR_CITY]: "Creditor's city",
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: "Creditor's CVR",
        [TemplateMention.PAYMENT_ID]: 'Payment ID / FIK number',
        [TemplateMention.JOURNAL_NUMBER]: 'Journal number',
        [TemplateMention.COURT_NAME]: "Court's name",
        [TemplateMention.COURT_ADDRESS]: 'Civil court Address',
        [TemplateMention.COURT_CITY]: "Court's city",
        [TemplateMention.COURT_ZIP]: "Court's zip",
        [TemplateMention.COURT_EMAIL]: "Court's email",
        [TemplateMention.COURT_PHONE]: "Court's phone",
        [TemplateMention.COURT_EAN]: "Court's EAN",
        [TemplateMention.REG_NO]: "Court's registration Number",
        [TemplateMention.ACCOUNT_NO]: "Court's account Number",
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Overview of number of payments and amounts',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: "Contact person's full address on one line",
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: "Contact person's full address on muliple lines",
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternative contact reference id',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'If alternative contact has a reference id',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: "Debtor's full address on one line",
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: "Debtor's full address on muliple lines",
        [TemplateMention.DEBTOR_TABLE]: 'Table showing all debtors in case',
        [TemplateMention.SIGN_FIELDS]: 'Signing fields',
        [TemplateMention.DK_BPK]: 'PDF of Order for payment',
        [TemplateMention.GL_BPK]: 'PDF of Order for payment (GL)',
        [TemplateMention.PAGE_BREAK]: 'Page Break',
        [TemplateMention.PAYMENT_LINK]: 'Link to pay the full debt',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link to the debtor-facing payment plan page. If no payment plan ' +
            'exists, the debtor can choose from the available predefined ' +
            'payment-plan options.',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR code for the debtor-facing payment plan page. If no payment plan ' +
            'exists, the debtor can choose from the available predefined ' +
            'payment-plan options.',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link To Payment (QR-kode)',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link To Debtor Web (QR-kode)',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link to debtor web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link to debtor web long',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link to pay the full debt',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabel showing payment, date and status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Status card with progress, paid amount, remaining amount and next payment',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Satisfaction Buttons',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'HTML link to the debtor-facing payment plan page. If no payment ' +
            'plan exists, the debtor can choose from the available predefined ' +
            'payment-plan options.',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link overpayment',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link overpayment QR code',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link to overpayment',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link to debtor web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link to debtor web long',
        [TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [TemplateMention.CONDITIONAL_END_IF]: 'End If',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Foundation type',
        [TemplateMention.FOUNDATION_DATE]: 'Foundation date',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Latest FS no.',
    },
    mentionsExample: {
        [TemplateMention.PaymentPlanAmortisation]: 'Date | Principal | Costs | Interest | Accrued interest | Total | Installment | Remaining debt',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Regarding your debt to Testkreditor ApS [j.nr.: 171001-171533]',
        [TemplateMention.FINANCIALS_PRICIPAL]: '8.570,14 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: '10%',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124, and 125',
        [TemplateMention.CURRENCY]: 'DKK',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20. october 2021',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15. october 2021',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20. august 2024',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15. august 2024',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20. november 2021',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15. november 20211',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17. september 2021',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [TemplateMention.PaymentPlanApr]: '12,34',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1. year APRC: 1,33',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has interests',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [TemplateMention.TOTAL_DEBT]: '6.770,14',
        [TemplateMention.OVERPAYMENT]: '123,23',
        [TemplateMention.ACCORD_TEN_PERCENT]: '6.093,13',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: '5.416,11',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: '4.739,10',
        [TemplateMention.ACCORD_FORTY_PERCENT]: '4.062,08',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: '3.385,07',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: '2.708,06',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: '2.031,04',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: '1.354,03',
        [TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [TemplateMention.IF_IS_COMPANY]: 'Condition if company',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Condition if debtor is registered in a debt registry',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Condition if case has multiple principals',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Condition if case has reminder fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Condition if case has collection fees',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Condition if case has collection costs',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Condition if case has compensation costs',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Condition if case has process interest',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Condition if case has fixed interest',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Condition if case has yearly interest',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Condition if case has deposit',
        [TemplateMention.DOCUMENTATION]: 'Documentation',
        [TemplateMention.DATE]: '23. november 2021',
        [TemplateMention.DATE_IN_THREE_DAYS]: '26. november 2021',
        [TemplateMention.DATE_IN_SIX_DAYS]: '29. november 2021',
        [TemplateMention.DATE_IN_TEN_DAYS]: '3. december 2021',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: '4. december 2021',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: '5. december 2021',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7. december 2021',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10. december 2021',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: '23. december 2021',
        [TemplateMention.PREVIOUS_THREE_YEARS]: '2018, 2019 and 2020',
        [TemplateMention.DEPOSIT]: '400,00',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: '1,234.56',
        [TemplateMention.CONTACT_NAME]: 'Debbie Contactsen',
        [TemplateMention.DEBTOR_NAME]: 'Debbie Debtorsen',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [TemplateMention.CONTACT_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [TemplateMention.CONTACT_ZIPCODE]: '1411',
        [TemplateMention.CONTACT_CITY]: 'Copenhagen',
        [TemplateMention.CONTACT_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [TemplateMention.DEBTOR_ZIPCODE]: '1411',
        [TemplateMention.DEBTOR_CITY]: 'Copenhagen',
        [TemplateMention.DEBTOR_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_EMAIL]: 'debtor@example.com',
        [TemplateMention.DEBTOR_PHONE]: '88888888',
        [TemplateMention.LAST_PAYMENT_DATE]: '12. october 2021',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [TemplateMention.CREDITOR_NAME]: 'Testkreditor A/S',
        [TemplateMention.CASE_ID]: '12345678',
        [TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [TemplateMention.CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logic if creditor is a company',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Logic if creditor is vat registered',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'Logic if the case has an ultimate creditor',
        [TemplateMention.CASE_CREDITOR_NAME]: 'Testkreditor A/S',
        [TemplateMention.CASE_CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: '1411',
        [TemplateMention.CASE_CREDITOR_CITY]: 'Copenhagen',
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.USER_NAME]: 'Peter Petersen',
        [TemplateMention.USER_FIRST_NAME]: 'Peter',
        [TemplateMention.IF_USER]: 'Logic if user is available',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logic if creditor allows bank transfers',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logic if creditor allows FI payments',
        [TemplateMention.REMINDER_FEES]: '300,00',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment options',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [TemplateMention.COLLECTOR_PHONE]: '11223344',
        [TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [TemplateMention.COLLECTOR_EMAIL]: 'collector@debbie.dk',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Testcollector',
        [TemplateMention.COLLECTOR_NAME]: 'Testcollector A/S',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Copenhagen',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: '1411',
        [TemplateMention.COLLECTOR_CVR]: '88776655',
        [TemplateMention.CREDITOR_ZIPCODE]: '1411',
        [TemplateMention.CREDITOR_CITY]: 'Copenhagen',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [TemplateMention.COURT_NAME]: 'Københavns Byret',
        [TemplateMention.COURT_ADDRESS]: 'Hestemøllestræde 6',
        [TemplateMention.COURT_CITY]: 'København K',
        [TemplateMention.COURT_ZIP]: '1464',
        [TemplateMention.COURT_EMAIL]: 'foged.kbh@domstol.dk',
        [TemplateMention.COURT_PHONE]: '99687000',
        [TemplateMention.COURT_EAN]: '5798000161252',
        [TemplateMention.REG_NO]: '0216',
        [TemplateMention.ACCOUNT_NO]: '4069134793',
        [TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Deposit of DKK 200,00 before 15. october 2021',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logic if alternative contact reference id exists',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.DEBTOR_TABLE]: 'Debtor 1|Debtor 2|...',
        [TemplateMention.SIGN_FIELDS]: 'Date\n_______________________\nSignature',
        [TemplateMention.DK_BPK]: 'PDF',
        [TemplateMention.GL_BPK]: 'PDF',
        [TemplateMention.PAGE_BREAK]: 'Page Break',
        [TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR code',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Amount | Date | Status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: '3 of 8 entries · Next 31.05.26',
        [TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [TemplateMention.CONDITIONAL_END_IF]: 'End if',
        [TemplateMention.BANK_CREDITOR_NUMBER]: 'N/A',
        [TemplateMention.FOUNDATION_TYPE]: 'Verdict',
        [TemplateMention.FOUNDATION_DATE]: '23. november 2021',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        result: {
            description: 'Your data has been imported. Review the results and continue working with the cases.',
            finishedWithErrors: 'Import completed with errors',
            errorsDescription: 'The import has finished, but some rows could not be imported.',
            processedSheets: 'Imported sheets',
            processedRows: 'rows processed',
            sheet: 'Sheet',
            viewCases: 'View created cases',
            failedTitle: 'These rows need attention',
            failedDescription: 'Download the failed rows, correct the errors and import only the corrected rows in a new import.',
            viewFailedRows: 'View failed rows',
            nextStep: 'Ready for the next step',
            approveDescription: 'After reviewing the results, approve the created cases that are awaiting approval.',
            actionStarted: 'The action has been queued. You will receive an email when it is complete.',
            noCreatedCases: 'This import has no created cases.',
            endTitle: 'End the created cases',
            endDescription: 'This ends the created cases that are pending or approved with the reason Error on our part. Do you want to continue?',
        },
        progress: {
            linking: 'Linking contact people',
            title: 'Importing your data',
            description: 'You can leave this page. The import continues in the background and saves its progress as it runs.',
            preparing: 'Preparing the import',
            rows: 'rows imported',
            pending: 'Waiting',
            running: 'Importing',
            completed: 'Completed',
            failed: 'Stopped',
            pausedTitle: 'The import needs attention',
            pausedDescription: 'A task failed after several attempts. Resolve the cause and resume the import. Previously imported data will not be created again.',
            retry: 'Resume import',
            finishing: 'Finishing the import',
            legacy: 'This import was started without saved progress. Its status will update when it finishes.',
        },
        workbook: {
            otherCaseGroup: 'Another case group · saved but not used in this import',
            otherCaseGroupMappings: 'The mapping includes attributes for other case groups. They are preserved and used when importing into the relevant case group.',
            unavailableField: 'Unavailable field',
            unavailableMappings: 'Some mappings use unavailable fields',
            unavailableMappingsDescription: 'A selected field no longer exists or cannot be imported in this sheet. Open the column’s field selector and remove or replace the unavailable field. Attributes for other case groups are preserved and do not trigger this warning.',
            selectField: 'Select field',
            reuploadForHeaders: 'Upload the file again to change its header row.',
            fields: {
                accountNumber: 'Bank account number',
                address: 'Address',
                administrationCost: 'Administration cost',
                alternativeContactAddress: 'Alternative contact: address',
                alternativeContactCity: 'Alternative contact: city',
                alternativeContactCoAddress: 'Alternative contact: c/o address',
                alternativeContactCountry: 'Alternative contact: country',
                alternativeContactEmail: 'Alternative contact: email',
                alternativeContactName: 'Alternative contact: name',
                alternativeContactPhone: 'Alternative contact: phone number',
                alternativeContactType: 'Alternative contact: type',
                alternativeContactZipcode: 'Alternative contact: postal code',
                amount: 'Amount',
                bailifsFee: 'Bailiffs fee',
                bailifsSalary: 'Bailiffs salary',
                birthdate: 'Birthdate',
                bpkWarnedAt: 'BPK Warned At',
                caseCreatedAt: 'Case created at',
                caseGroup: 'Case Group',
                caseReferenceId: 'Case reference',
                caseSeqId: 'Case number',
                caseStatus: 'Case status',
                caseTags: 'Case tags',
                centralRegisterId: 'Company registration number',
                city: 'City',
                clientContactUserEmail: "Contact person's email",
                coAddress: 'C/o address',
                collectionCost: 'Collectioncosts',
                collectionFee: 'Collectionfee',
                compensationCost: 'Compensationcosts',
                compoundInterestRate: 'Compound interest rate',
                continuedAt: 'Resumed date',
                controlFee: 'Control fee',
                country: 'Country',
                countryCode: 'Country code',
                cpr: 'CPR',
                createdAt: 'Created',
                createdByUserWithEmail: 'Created by user with email',
                creditNote: 'Credit note',
                creditorReferenceId: 'Creditor Reference Id',
                currency: 'Currency',
                customerReferenceId: 'Customer reference',
                customerTerminated: 'Customer terminated',
                cvr: 'CVR',
                date: 'Date',
                debtDescription: 'Voucher Description',
                debtReferenceId: 'Invoice id',
                defaultBillingModelId: 'Default billing model',
                defaultWorkflowId: 'Default workflow',
                deposit: 'Deposit',
                dueDate: 'Due date',
                economyBillingModelId: 'Billing model',
                email: 'Email',
                endReason: 'Exit reason',
                experianClientId: 'Experian client ID',
                expirationFromDate: 'Expiration from date',
                fiPaymentIdRaw: 'FI Payment Id',
                fileId: 'File ID',
                fileName: 'Filename',
                fileNote: 'File note',
                finalSettlement: 'Final Settlement',
                finalStatement: 'Final statement',
                firstName: 'First name',
                fixedInterest: 'Fixed Interest',
                fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
                from: 'Sender',
                html: 'Content (HTML)',
                imposedByCreditor: 'Imposed by creditor',
                interestEndDate: 'Interest end date',
                interestRate: 'Interest rate',
                interestStartDate: 'Interest start date',
                interval: 'Interval',
                isCompany: 'Is company',
                issueDate: 'Date',
                lang: 'Language',
                lastName: 'Last name',
                loan: 'Loan',
                migratedId: 'Migrated journalnumber',
                migratedStepId: 'Migrated task ID',
                name: 'Name',
                newUserToken: 'New user invitation token',
                note: 'Note',
                notes: 'Notes',
                onAccount: 'On Account',
                pausedAt: 'Paused date',
                phone: 'Phone',
                phoneLocale: 'Phone country code',
                phoneNumber: 'Phone number',
                policePresentationFee: 'Police presentation fee',
                principal: 'Principal',
                referenceId: 'Reference number',
                referenceVoucherReferenceId: 'Related voucher reference',
                referenceVoucherTypeId: 'Related voucher type',
                refund: 'Refund',
                registrationNumber: 'Bank registration number',
                registryIdentifierScheme: 'Registry identifier scheme',
                registryIdentifierValue: 'Registry identifier',
                remindedAt: 'Reminder date',
                reminderFee: 'Reminder Fees',
                reminderFeeCollector: 'Reminderfees from collector',
                rkiWarnedAt: 'RKI Warned At',
                role: 'Role',
                settlement: 'Settlement',
                signedAt: 'Signature date',
                startDate: 'Start date',
                state: 'State',
                subject: 'Subject',
                text: 'Text',
                to: 'Recipient',
                type: 'Type',
                udtraeksgebyr: 'Credit initiation fee',
                ultimateCreditorReferenceId: 'Ultimate creditor reference number',
                update: 'Update',
                updateTypeId: 'Update type',
                vatRegistered: 'VAT registered',
                visibleForDebtor: 'Visible to debtor',
                voucherReferenceId: 'Voucher reference number',
                writFee: 'Writt fee',
                writSalary: 'Writt salary',
                zipcode: 'Zipcode',
            },
            mappedFromColumn: 'Column in file',
            mappedColumns: 'mapped columns',
            columnHint: 'Click the field below a column heading to choose where its values belong.',
            missingFields: 'Required fields without a column',
            emptySheet: 'This sheet has no data rows. Select another sheet or change the header row.',
            mappingHint: 'Choose one or more fields for this column. Selecting a field moves its mapping from any other column.',
            sheets: 'sheets',
            skipped: 'Will not be imported',
            importAs: 'Import as',
            skipSheet: 'Skip this sheet',
            headerRow: 'Header row',
            skippedDescription: 'This sheet is excluded from the import. You can still inspect its contents.',
            sourcePreview: 'Source data',
            searchFields: 'Search fields…',
            searchTypes: 'Search sheet types…',
            addFixedValue: 'Add fixed value',
            fixedValue: 'Fixed value',
            mappingSaving: 'Saving setup…',
            mappingSaved: 'Setup saved',
            mappingSaveFailed: 'The setup could not be saved. Your changes are still on this page.',
            retryMappingSave: 'Retry',
            unsavedMapping: 'Your changes have not been saved yet. Leave this page?',
            attachmentNotUploaded: 'Attachment has not been uploaded',
            fixedFileHint: 'Upload the attachment under Upload attachments, then select the file here.',
            fixedValueHint: 'Applies to every row and replaces the field’s Excel column mapping.',
            removeFixedValue: 'Remove',
            imposedBy: 'Imposed by',
            creditor: 'Creditor',
            collector: 'Collector',
            attribute: 'Attribute',
            createAttribute: 'Create new attribute',
            mappingSettings: 'Settings',
            invertSign: 'Reverse sign',
            voucherSignHint: 'Amounts in the table must use these signs:',
            voucherDebtSign: 'Debt, interest and costs: a negative amount, e.g. −1,000.00. This increases the debt.',
            voucherCreditSign: 'Credit notes and payments received: a positive amount, e.g. +250.00. This reduces the debt.',
            invertSignDescription: 'Positive values become negative, and negative values become positive. The table shows values with your settings applied.',
            duplicateHeaders: 'Column names must be unique. Choose the correct header row or rename duplicate columns in the file.',
            missingColumns: 'Some saved columns are missing. Select a new column or clear the mapping.',
            types: {
                cases: 'Cases',
                customers: 'Customers',
                vouchers: 'Vouchers',
                creditors: 'Creditors',
                ultimateCreditors: 'Ultimate creditors',
                users: 'Users',
                billingVouchers: 'Billing vouchers',
                notes: 'Notes',
                emails: 'Emails',
                letters: 'Letters',
                sms: 'SMS',
                steps: 'Tasks',
                updates: 'Updates',
                documents: 'Documents',
                paymentPlans: 'Payment plans',
            },
        },
        importedData: 'Imported data',
        downloadInvoiceExampleHeader: 'Invoice Debts',
        downloadInvoiceExampleText: 'Download import-sheet with examples of invoice cases.',
        downloadFinancialExampleHeader: 'Bank cases',
        downloadFinancialExampleText: 'Download import-sheet with example bank cases.',
        downloadAcontoExampleHeader: 'Aconto cases',
        downloadAcontoExampleText: 'Download import-sheet with aconto invoiced cases.',
        downloadMigrationExampleHeader: 'Migrate cases',
        downloadMigrationExampleText: 'Download migration sheet with migration data examples.',
        download: 'Download example',
        import: 'Import',
        backToImports: 'Back to imports',
        newImport: 'New import',
        noImports: 'No imports to show',
        casesCreated: 'Cases created',
        casesUpdated: 'Cases updated',
        companyStatuses: 'Company statuses',
        noStatus: 'No status',
        caseUpdates: 'Case updates',
        [ImportState.CANCELED]: 'Canceled',
        [ImportState.CREATED]: 'Created',
        [ImportState.DELETED]: 'Deleted',
        [ImportState.IMPORTED]: 'Imported',
        [ImportState.IMPORTING]: 'Importing',
        [ImportState.SHEETADDED]: 'Sheet added',
        create: 'Create',
        uploadFile: 'Upload file',
        uploadedAppendicies: 'Uploaded appendicies',
        mapColumns: 'Map columns',
        imported: 'Imported',
        dropFileHereOr: 'Drop file here or',
        dropAppendixHereOr: 'Drop appendix here or',
        uploadImport: 'Upload import sheet',
        uploadAppendix: 'Upload appendix',
        workbookGuide: {
            title: 'Upload your Excel workbook',
            description: 'Collect your data in an Excel file and connect its columns to the fields in Debbie.',
            dropFile: 'Drag and drop your Excel workbook here',
            fileFormats: 'Choose an Excel file in .xlsx or .xls format.',
            replaceFile: 'A new file replaces the current import workbook.',
            chooseFile: 'Choose file',
            uploadTitle: 'Upload the workbook',
            uploadDescription: 'Choose the Excel file containing the data you want to import. It can contain multiple sheets.',
            sheetsTitle: 'Choose what each sheet contains',
            sheetsDescription: 'Specify whether the sheet contains cases, customers or vouchers, for example. Skip sheets you do not want to import.',
            mappingTitle: 'Map the columns and check the data',
            mappingDescription: 'Connect the columns to fields in Debbie and correct any errors before importing.',
        },
        appendixGuide: {
            title: 'Link attachments to your Excel rows',
            description: 'Upload your files here, then use their names in Excel to connect each attachment to the right row.',
            dropFiles: 'Drag and drop your attachments here',
            multipleFiles: 'You can upload several files at once.',
            chooseFiles: 'Choose files',
            uploadTitle: 'Upload the attachments',
            uploadDescription: 'Choose the files to include in the import, such as invoices or agreements.',
            referenceTitle: 'Enter the file name in Excel',
            referenceDescription: 'Add a column with the file name on the row the attachment belongs to. Include the full name and extension, such as .pdf.',
            mappingTitle: 'Map the column to a file field',
            mappingDescription: 'Upload the updated Excel workbook under “Upload import sheet”. Map the column to “Filename” or a file property before importing.',
        },
        migration: 'Migration',
        createdAt: 'Created',
        state: 'State',
        appendixUploaded: 'Appendix uploaded',
        dropAnotherFileHereOr: 'Drop another file here or',
        uploadFileBtn: 'Upload file',
        deleteImport: 'Delete import',
        importFinished: 'Import finished',
        withRKIRegistrations: 'with RKI registrations',
        endAll: 'End all',
        approveAll: 'Approve all cases',
        createdCases: 'created cases.',
        startedEnding: 'Started ending',
        cases: 'cases.',
        found: 'Found',
        rows: 'rows',
        and: 'and',
        debtors: 'debtors',
        chain: 'Workflow',
        billingModel: 'Billing model',
        tenantStandard: 'Account standard',
        creditorStandard: 'Creditor standard',
        systemStandard: 'System standard',
        more: 'more.',
        showMore: 'Show more',
        importCases: 'Import cases',
        youWillreceiveAnEmailWhenItIsDone: 'You will receive an email when the import is ready.',
        importHasStarted: 'Import has started',
        see: 'See',
        seeMore: 'See more',
        here: 'here',
        file: "the file's",
        asWell: 'and',
        notMappedColumns: 'Following columns not mapped',
        errors: 'errors',
        error: 'Error',
        row: 'Row',
        column: 'Column',
        columnNotFound: 'Column not found',
        noErrorsFound: 'No errors found',
        rowsHeader: 'Rows',
        columnsHeader: 'Columns',
        failedRows: 'Failed rows',
        failedImportRows: 'Failed import rows',
        referenceId: 'Reference Id',
        creditorReferenceId: 'Creditor Reference Id',
        ultimateCreditorReferenceId: 'Ultimate Creditor Reference Id',
        isCompany: 'Is company',
        caseCreatedAt: 'Case created at',
        caseStatus: 'Case status',
        endReason: 'Exit reason',
        caseGroup: 'Case Group',
        migratedId: 'Migrated journalnumber',
        name: 'Name',
        birthdate: 'Birthdate',
        cpr: 'CPR',
        cvr: 'CVR',
        email: 'Email',
        phone: 'Phone',
        lang: 'Language',
        address: 'Address',
        coAddress: 'C/O Address',
        zipcode: 'Zipcode',
        city: 'City',
        country: 'Country',
        fiPaymentIdRaw: 'FI Payment Id',
        caseTags: 'Case tags',
        economyBillingModelId: 'Billing model',
        debtReferenceId: 'Invoice id',
        fileName: 'Filename',
        issueDate: 'Date',
        dueDate: 'Due date',
        expirationFromDate: 'Expiration from date',
        currency: 'Currency',
        debtDescription: 'Voucher Description',
        principal: 'Principal',
        controlFee: 'Control fee',
        onAccount: 'On Account',
        finalSettlement: 'Final Settlement',
        deposit: 'Deposit',
        loan: 'Loan',
        settlement: 'Settlement',
        fixedInterest: 'Fixed Interest',
        udtraeksgebyr: 'Credit initiation fee',
        administrationCost: 'Administration cost',
        reminderFee: 'Reminder Fees',
        reminderFeeCollector: 'Reminderfees from collector',
        refund: 'Refund',
        compensationCost: 'Compensationcosts',
        collectionCost: 'Collectioncosts',
        collectionFee: 'Collectionfee',
        writFee: 'Writt fee',
        writSalary: 'Writt salary',
        policePresentationFee: 'Police presentation fee',
        fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
        bailifsSalary: 'Bailiffs salary',
        bailifsFee: 'Bailiffs fee',
        creditNote: 'Credit note',
        interestStartDate: 'Interest start date',
        interestRate: 'Interest rate',
        finalStatement: 'Final statement',
        customerTerminated: 'Customer terminated',
        rkiWarnedAt: 'RKI Warned At',
        bpkWarnedAt: 'BPK Warned At',
        errorWarning: 'Your file contains errors that are preventing the import.',
        faqHeader: 'Need help to import cases?',
        faqText: 'We have written an article about File import in our Help section. Here you will also find an explanation of typical errors when importing files.',
        newCase: 'New case',
        selectColumn: '-- Select column --',
        debtorMessages: 'Debtor messages',
        importDebtorMessages: 'Import debtor messages',
    },
    updateTypesSettings: {
        addUpdateType: 'Create update type',
        title: 'Update type label',
        editUpdateType: 'Edit update type',
        createNewUpdateType: 'Create new update type',
        customUpdateTypes: 'Created update types',
        standardUpdateTypes: 'Standard update types',
        allUpdateTypes: 'All update types',
        filterAutomatic: 'Automatic',
        filterPause: 'Pause',
        filterInfo: 'Info',
    },
    updateTypes: {
        [UpdateType.CreditorEndedCase]: 'Creditor ended case',
        [UpdateType.AKSStatus]: 'AKS status',
        [UpdateType.AKSFailed]: 'AKS enroll failed',
        [UpdateType.EXITREQUEST]: 'Exit Request From Creditor',
        [UpdateType.CASESTATUSMOVE]: 'Changed Case Status',
        [UpdateType.SOP]: 'Final Statement',
        [UpdateType.UPDATE]: 'Update',
        [UpdateType.NOCONTACTINFORMATION]: 'Missing Contact Information',
        [UpdateType.DEPOSIT]: 'Deposit',
        [UpdateType.NEWDEBT]: 'New Debt',
        [UpdateType.NEWINTERACTION]: 'New incoming e-mail',
        [UpdateType.eBoksFailed]: 'e-Boks message could not be delivered',
        [UpdateType.TECHNICALINVESTIGATION]: 'Investigated by a technician',
        [UpdateType.TERMINATIONREQUEST]: 'Termination request sent to creditor',
        [UpdateType.PENDINGTERMINATION]: 'Pending termination by caseworker',
        [UpdateType.CANCELTERMINATION]: 'Canceled termination',
        [UpdateType.CASECONTINUED]: 'Case Continued',
        [UpdateType.POSTPONECASEWORKING]: 'Postpone Caseworking',
        [UpdateType.RETURNLETTER]: 'Return Letter',
        [UpdateType.BOBEHANDLING]: 'Estate Administration',
        [UpdateType.BOBEHANDLET]: 'Estate Administered',
        [UpdateType.NotSureCourtSubmit]: 'Awaiting Money-Claim form',
        [UpdateType.YesCourtSubmit]: 'Ready to auto submit to court',
        [UpdateType.NoCourtSubmit]: 'Not selected for automatic submission to the court',
        [UpdateType.AWAITINGSTAEVNING]: 'Awaiting Writ',
        [UpdateType.AFDRAGSORDNINGER]: 'Payment Plan',
        [UpdateType.ApprovedByCreditor]: 'Approved By Creditor',
        [UpdateType.ApprovedByDatahub]: 'Approved By Datahub',
        [UpdateType.CancelApprovedByDatahub]: 'Cancel Approved By Datahub',
        [UpdateType.REMOVEFROMRKI]: 'Remove from RKI',
        [UpdateType.AUTOREMOVEFROMRKI]: 'Automatic deletion of RKI registration',
        [UpdateType.CancelRejectedByDatahub]: 'Cancel Rejected By Datahub',
        [UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Cancel Requested Because Of Payment To Creditor',
        [UpdateType.RejectedByCreditor]: 'Rejected By Creditor',
        [UpdateType.RejectedByDatahub]: 'Rejected By Datahub',
        [UpdateType.PAYMENTPLANINITIAL]: 'New Payment Plan Created',
        [UpdateType.NEWCLIENTINTERACTION]: 'New creditor interaction',
        [UpdateType.NEWDEBTORINTERACTION]: 'New debtor interaction',
        [UpdateType.DEBTORPERSONALDATAREQUEST]: 'Debtor info change request',
        [UpdateType.AWAITINGCLIENTANSWER]: 'Awaiting Response From Creditor',
        [UpdateType.DEFAULTEDPAYMENTPLAN]: 'Defaulted Payment Plan',
        [UpdateType.OVERPAYPAYMENTPLAN]: 'Overpay Payment Plan',
        [UpdateType.RKIApprovalRequest]: 'RKI-request For Case Worker',
        [UpdateType.RKIREGISTRATION]: 'RKI Registration Required',
        [UpdateType.DOCSIGNED]: 'Document Signed',
        [UpdateType.COSMOSUBSCRIBED]: 'Subscribed to Cosmo',
        [UpdateType.COSMOUNSUBSCRIBED]: 'Unsubscribed from Cosmo',
        [UpdateType.AWAITINGFOGEDREKVISITION]: 'Awaiting Enforcement Application',
        [UpdateType.ISINFOGEDRETTEN]: "In Bailiff's Court",
        [UpdateType.ISINCIVILCOURT]: 'In Civil Court',
        [UpdateType.PAYMENTONCASEINCOURT]: 'Payment on case in court',
        [UpdateType.RECEIVEDCOURTFOUNDATION]: 'Received Sentence/Money-Claim form/Court Settlement awaits Enforcement',
        [UpdateType.POLITIFREMSTILLING]: 'Arrest For Non-appearance',
        [UpdateType.DECIDECOURT]: 'Decide Court Decision',
        [UpdateType.RKISTATUS]: 'RKI status',
        [UpdateType.AWAITINGPOWERTERMINATION]: 'Awaiting Power Termination',
        [UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI approved by creditor',
        [UpdateType.REQUESTCLIENTRKI]: 'RKI-request For Creditor',
        [UpdateType.TERMINATEDCUSTOMER]: 'Terminated Customer',
        [UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Enforcement Application Request For Creditor',
        [UpdateType.TICKETRESOLVED]: 'Ticket resolved',
        [UpdateType.MIGRATIONNOTE]: 'Migration Note',
        [UpdateType.TILJURIDISKBEHANDLING]: 'To legal Processing',
        [UpdateType.COURTEVENTS]: 'Court Events',
        [UpdateType.AFTEROFFICEHOURS]: 'Postponed for After Office Hours',
        [UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Awaiting Payment After Conciliation',
        [UpdateType.PHONEMEETING]: "Summoned for Telephonic Bailiff's Meeting",
        [UpdateType.INSOLVENS]: 'Insolvency',
        [UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Debt Expires Within Three Months',
        [UpdateType.DEBTEXPIRED]: 'Debt Expired',
        [UpdateType.EMAILFAILED]: 'Email Failed',
        [UpdateType.EINVOICEFAILED]: 'E-invoice Failed',
        [UpdateType.AWAITINGCIVILCOURT]: 'Awaiting Civil Court',
        [UpdateType.AWAITINGFINALSTATEMENT]: 'Awaiting Final Statement',
        [UpdateType.MIGRATEDJOURNALNUMBER]: 'Migrated Journal Number',
        [UpdateType.RKIREGISTRATIONOPEN]: 'RKI Registration (Open)',
        [UpdateType.RKIREGISTRATIONCLOSED]: 'RKI Registration (Closed)',
        [UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI Registration (Open)',
        [UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI Registration (Closed)',
        [UpdateType.DEBTREGISTRATIONWARNED]: 'Debt register warned',
        [UpdateType.STAEVNINGREQUSTCLIENT]: 'Should Debtor get a Writ',
        [UpdateType.UDLAEG]: 'Distress',
        [UpdateType.UDLAEGCIVIL]: 'Distress',
        [UpdateType.NEWCOURTINTERACTION]: 'New Court Interaction',
        [UpdateType.REMINDER]: 'Reminder',
        [UpdateType.OUTBOUNDCALL]: 'Outbound Call',
        [UpdateType.UDLAEGAFLYSES]: 'Distress should be cancelled',
        [UpdateType.OPPOSITION]: 'Dispute',
        [UpdateType.NOTOPPOSITION]: 'Not a dispute',
        [UpdateType.FSNUMMER]: 'FS-number',
        [UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Handover case to external debt collection partner',
        [UpdateType.AKSUpdateName]: 'AKS Updated: Name',
        [UpdateType.AKSUpdateAddress]: 'AKS Updated: Address',
        [UpdateType.AKSUpdateStatus]: 'AKS Updated: Status',
        [UpdateType.AKSUpdateProtection]: 'AKS Updated: Name/Address Protection',
        [UpdateType.AKSUpdateNewRKI]: 'AKS Updated: New RKI Registration',
        [UpdateType.AKSUpdateDeletedRKI]: 'AKS Updated: Deleted RKI Registration',
        [UpdateType.AKSUpdateCreditWarning]: 'AKS Updated: Credit Warning',
        [UpdateType.AKSUpdateAdvertisementPreference]: 'AKS Updated: Advertisement Preference',
        [UpdateType.AKSUpdateGuardianStatus]: 'AKS Updated: Guardian Status',
        [UpdateType.AKSUpdateRKI]: 'AKS Updated: RKI Remark',
        [UpdateType.COURTREMINDER]: 'Court reminder',
        [UpdateType.DEPARTED]: 'Departed',
        [UpdateType.DECIDECONTINUE]: 'Decide continuation',
        [UpdateType.Dead]: 'Debtor has died',
        [UpdateType.MovedAbroad]: 'Debtor has moved abroad',
        [UpdateType.Disappeared]: 'Debtor has disappeared',
        [UpdateType.Homeless]: 'Debtor has become homeless',
        [UpdateType.Inactive]: 'Company is inactive',
        [UpdateType.OperationsCeased]: 'Company has ceased operations',
        [UpdateType.GuardianStatus]: 'Guardian-status updated',
        [UpdateType.DeletedRKIRegistration]: 'RKI Registration Deleted',
        [UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI registration deleted - indication of willingness to pay',
        [UpdateType.NewRKIRegristration]: 'New RKI Registration',
        [UpdateType.Address]: 'Address updated',
        [UpdateType.AddressProtection]: 'Name/Address-Protection updated',
        [UpdateType.RKIRemark]: 'RKI Remark updated',
        [UpdateType.Active]: 'Debtor is now active',
        [UpdateType.CompanyActive]: 'Company is now active',
        [UpdateType.DissolutionStatus]: 'Dissolution status',
        [UpdateType.PAYMENTPLANCANCLED]: 'Payment plan canceled',
        [UpdateType.INTERNALREMARK]: 'Internal remark',
        [UpdateType.MOVETOOPENRKI]: 'Move to open RKI',
        [UpdateType.DebtorIsUnderage]: 'Debtor is under 18 years old',
        [UpdateType.SentToConnectPartner]: 'Sent to connect partner',
        [UpdateType.ReturnedToConnectPartner]: 'Returned to connect partner',
        [UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Debtor can be registered in a debt register',
        [UpdateType.PAYMENTREVOKED]: 'Payment revoked',
    },
    updateTypesClient: {
        [UpdateType.AWAITINGCLIENTANSWER]: 'New message from collector',
    },
    caseFilter: {
        moreFilters: 'Filters',
        advancedFilters: 'Advanced filters',
        casesSelected: 'selected cases',
        aggregationSum: 'Sum',
        unknownEndReason: 'Unknown end reason',
        orderCaseOverview: 'Order case overview',
        creditorsGroup: 'Creditors',
        contactsGroup: 'Contact persons',
        maxRkiRegistrations: 'Max. RKI-registrations',
        maxRkiRegistrationsSub: 'Choose maximum RKI-registrations debtor can have.',
        maxRkiRegistrationsBadge: 'RKI max.',
        minRkiRegistrations: 'Min. RKI-registrations',
        minRkiRegistrationsSub: 'Choose minimum RKI-registrations debtor can have.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Is RKI registered by collector',
        isRegisteredByCollector: 'Is registered',
        isNotRegisteredByCollector: 'Is not registered',
        contactHasEmail: 'Contact person has an email',
        contactHasEmailBadge: 'Has email',
        contactHasPhone: 'Contact person has phone number',
        contactHasPhoneBadge: 'Has phone',
        contactHasAddress: 'Contact person has an address',
        contactHasAddressBadge: 'Has address',
        contactPersonIs: 'Contact person is',
        debtor: 'Debtor',
        debtorBadge: 'Debtor is contact person',
        alternativeContact: 'Alternative contact person',
        alternativeContactBadge: 'Has alternative contact person',
        company: 'Company',
        companyBadge: 'Is company',
        person: 'Is person',
        personBadge: 'Is person',
        paymentMethod: 'Payment method',
        hasCard: 'Has payment card',
        doNotHaveCard: 'Does not have payment card',
        companyStatus: 'Company status',
        selectCompanyStatus: 'Select company status',
        companyTypes: 'Company types',
        selectCompanyTypes: 'Select company types',
        court: 'Court',
        courtBadge: 'Court selected',
        selectCourt: 'Select court',
        companyBranch: 'Company branch',
        selectCompanyBranch: 'Select branches',
        gender: 'Gender',
        [Gender.MALE]: 'Male',
        [Gender.FEMALE]: 'Female',
        [Gender.BOTH]: 'Both',
        zipcode: 'Zipcode',
        selectZipcode: 'Select zipcode',
        satisfactions: 'Satisfactions',
        aiGroup: 'AI',
        casesGroup: 'Cases',
        caseStatus: 'Case status',
        selectCaseStatus: 'Select case status',
        endReasons: 'Exit reason',
        selectEndReasons: 'Select exit reasons',
        caseGroup: 'Case group',
        selectCaseGroup: 'Select case group',
        caseImport: 'Case import',
        selectCaseImport: 'Select case import',
        caseCreatedAfter: 'Case created after',
        caseCreatedAfterPlaceholder: 'After',
        caseCreatedBefore: 'Case created before',
        caseCreatedBeforePlaceholder: 'Before',
        caseEndedAfter: 'Case ended after',
        caseEndedAfterPlaceholder: 'After',
        caseEndedBefore: 'Case ended before',
        caseEndedBeforePlaceholder: 'Before',
        caseSeqIds: 'Case numbers',
        exceptCaseSeqIds: 'Except case numbers',
        caseSeqIdsDescription: 'Case numbers seperated by newline, semi colon, comma or space.',
        caseSeqIdFilterBadge: 'By case numbers',
        updatesGroup: 'Case statuses',
        caseIsCurrently: 'Cases which is',
        caseIsCurrentlyPaused: 'Paused',
        caseIsCurrentlyNotPaused: 'Not paused',
        paused: 'Paused',
        notPaused: 'Not paused',
        selectStatus: 'Select status',
        hasFollowingStatus: 'Has status',
        hasFollowingStatusSub: 'Have or have had one of the following statuses',
        hasFollowingStatusBadge: 'Has status',
        doNotHaveFollowingStatus: 'Do not have status',
        doNotHaveFollowingStatusSub: 'Do not have or have had one of the following statuses',
        doNotHaveFollowingStatusBadge: 'Do not have status',
        isPausedFollowingStatus: 'Is paused with status',
        isPausedFollowingStatusSub: 'Is paused with one of the following statuses right now',
        isPausedFollowingStatusBadge: 'Is paused with status',
        isNotPausedFollowingStatus: 'Not paused',
        isNotPausedFollowingStatusSub: 'Is not paused with one of the following statuses',
        isNotPausedFollowingStatusBadge: 'Is not paused with status',
        economyFilter: {
            postingsGroup: 'Case vouchers',
            billingStatus: 'Billing status',
            amountMode: 'Apply the amount to',
            individualAmount: 'An individual voucher',
            totalAmount: 'The vouchers combined',
            totalAmountLabel: 'Total for selected vouchers',
            individualExample: '200–200 finds cases with at least one voucher of 200, including cases with several vouchers of 200.',
            totalExample: '200–200 matches 100 + 100, for example, but not 200 + 200.',
            totalHint: 'Only vouchers matching your selections count towards the total. Reversals are deducted.',
            paymentType: 'Payment method',
            allPaymentTypes: 'All payment methods',
            voucherState: 'Payment status',
            allVoucherStates: 'All payment statuses',
            paymentHint: 'Payment method and status must match the same vouchers as the amount.',
            postings: 'Vouchers',
            postingsHint: 'Find cases with at least one matching voucher.',
            types: 'Voucher type',
            anyType: 'All voucher types',
            typesHint: 'When you select several types, any one of them can match.',
            amount: 'Amount per voucher',
            amountHint: 'Enter amounts without a minus sign — for debt, payments and credit notes alike.',
            debt: 'Total debt',
            debtHint: 'The amount left to pay on the case, after payments and credit notes.',
            debtNote: 'Debt includes all case vouchers, regardless of the types selected above.',
            billing: 'Billing',
            billingHint: 'Find cases by their billing vouchers.',
            allCases: 'All cases',
            allCasesHint: 'Any billing status',
            pending: 'Has pending billing',
            pendingHint: 'At least one voucher awaits billing',
            billed: 'Has billed vouchers',
            billedHint: 'At least one voucher has been billed',
            both: 'Has both',
            bothHint: 'Both pending and billed vouchers',
            overlapHint: 'A case can have both. It also appears under “Has pending billing” and “Has billed vouchers”.',
            minimum: 'From, inclusive',
            maximum: 'To, inclusive',
            noLimit: 'No limit',
            rangeError: 'The minimum cannot exceed the maximum. Correct the range to apply it.',
            currencyHint: 'Amounts are in the case currency. Fill in either or both amount fields.',
            anyAmount: 'Any amount',
            combinedHint: 'Filters are combined: the case must match all completed filters.',
        },
        economyGroup: 'Economy',
        economyOnlyVoucherTypeIds: 'Only selected voucher types',
        economyMinAmount: 'Min.-balance',
        economyMaxAmount: 'Max.-balance',
        economyBillingModels: 'Cases with billing model',
        economyBillingAppendixSetups: 'Cases with billing appendix setup',
        billingModels: 'Billing models',
        economyMin: 'Min.',
        economyMax: 'Max.',
        economySelectedBillingModels: 'Selected billing models',
        economySelectedBillingAppendixSetups: 'Selected appendix setups',
        workflowsGroup: 'Workflows',
        inSelectedWorkflows: 'Selected workflows',
        isInWorkflows: 'Is in workflow',
        selectWorkflows: 'Selected workflows',
        selectNextTaskIds: 'Select tasks',
        nextTaskIds: 'Next task in workflow',
        selectCurrentTaskIds: 'Select tasks',
        currentTaskIds: 'Current task in workflow',
        noNextTask: 'No next task',
        documentsGroup: 'Documents',
        hasDocumentOfType: 'Has document of type',
        hasDocumentOfTypeBadge: 'Has document of type',
        selectDocumentTypes: 'Select document types',
        documentsIsSigned: 'Select only signed documents',
        hasFoundation: 'Has foundation',
        hasNoFoundation: 'Has no foundation',
        paymentPlansGroup: 'Payment Plans',
        paymentPlanStatuses: 'payment plans with status',
        selectPaymentPlanStatus: 'Select status',
        paymentPlanIsNotHavingStatuses: 'Select payment plans without the above statuses',
        paymentPlanIsNotHavingStatusesBadge: 'Payment plans without statuses',
        interactionsGroup: 'Interactions',
        interactionType: 'Interaction type',
        selectInteractionType: 'Select interaction type',
        interactionState: 'Interactions state',
        selectInteractionState: 'Select interaction state',
        interactionDirection: 'Interaction direction',
        selectInteractionDirection: 'Select interaction direction',
        noneOfTheAboveBadge: 'None of selected interactions',
        noneOfTheAbove: 'Cases with interactions with none of the above',
        accountsGroups: 'Users',
        selectedCreditors: 'creditor(s) selected',
        caseVisitedBy: 'Case visted by',
        selectAccount: 'Select users',
        caseVisitedBefore: 'Case visited before',
        to: 'To',
        caseVisitedAfter: 'Case visited after',
        from: 'From',
        offset: 'Offset',
        offsetExplanation: 'Choose the number of cases to skip',
        limit: 'Limit',
        limitExplanation: 'Choose the number of cases to select',
        pagination: 'Pagination',
        properties: 'Properties',
        property: 'Property',
        propertyExplanation: 'Filer',
        bulkActions: 'Bulk actions',
        bulkActionsConfirm: 'Are you sure that you want to run the selected bulk action on the selected cases?',
        approveVerifyAllCases: 'Are you sure you want to verify all selected cases?',
        casesVerified: 'Selected cases are now getting verified',
        pauseCasesBulk: 'Selected cases is now getting paused. You will receive an email when the system is done.',
        continueCasesBulk: 'Your selected pause status will be continued on the selected cases. You will receive an email when the system is done.',
        runProcedureBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeBillingModelBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeBillingModelDesc: 'Move cases to selected billing model for cases that is not invoiced.',
        changeBillingModelPlaceholder: 'Billing model',
        changeWorkflowBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeWorkflowDesc: 'Move cases to selected workflow.',
        changeWorkflowPlaceholder: 'Workflows',
    },
    aggregations: {
        aggregate: 'Aggregate cases',
    },
    aggregationTypes: {
        [AggregationType.CountAll]: 'Quantity cases',
        [AggregationType.ByCaseGroup]: 'Case group',
        [AggregationType.ByBillingModel]: 'Billing model',
        [AggregationType.ByBillingAppendixSetup]: 'Billing appendix setup',
        [AggregationType.ByWorkflow]: 'Workflow',
        [AggregationType.ByCaseStatus]: 'Case status',
        [AggregationType.ByCreditor]: 'Creditor',
        [AggregationType.ByMigratedWorkflowTaskId]: 'Migrated workflow task',
    },
    bulkActions: {
        runBulkAction: 'Run bulk action',
        bulkActionStarted: 'Bulk action started',
        bulkActions: 'Bulk action',
        bulkActionsConfirm: 'Are you sure you want to run this bulk action?',
        bulkActionBillingModelPlaceholder: 'Billing model',
        bulkActionWorkflowPlaceholder: 'Workflow',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Choose task in workflow',
        bulkActionChangeCaseGroup: 'Select case group',
        pleaseSelectAWorkflow: 'Please select a workflow in case filter',
    },
    bulkActionTypes: {
        [BulkActionType.MoveCaseStatus]: 'Change case status',
        [BulkActionType.PauseCases]: 'Pause selected cases',
        [BulkActionType.ContinueCases]: 'Continue selected cases',
        [BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [BulkActionType.ChangeBillingModel]: 'Change billing model',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [BulkActionType.ChangeWorkflow]: 'Change workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [BulkActionType.RollbackOneTask]: 'Rollback latest workflow task',
        [BulkActionType.RollbackAllTasks]: 'Rollback all workflow tasks',
        [BulkActionType.RunBillingModel]: 'Run billing model',
        [BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Delete RKI registrations on ended cases',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Move RKI registrations to merged cases',
        [BulkActionType.ChangeCaseGroup]: 'Change case group',
        [BulkActionType.ResyncCosmo]: 'Resync cosmo',
    },
    bulkActionDescriptions: {
        [BulkActionType.MoveCaseStatus]: 'Change case status to',
        [BulkActionType.PauseCases]: 'Pause selected cases',
        [BulkActionType.ContinueCases]: 'Continue selected cases',
        [BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [BulkActionType.ChangeBillingModel]: 'Change billing model',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [BulkActionType.ChangeWorkflow]: 'Change workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [BulkActionType.RollbackOneTask]: 'Rollback latest workflow task',
        [BulkActionType.RollbackAllTasks]: 'Rollback all workflow tasks',
        [BulkActionType.RunBillingModel]: 'Run billing model',
        [BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Delete RKI registrations on ended cases',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Move RKI registrations to merged cases',
        [BulkActionType.ChangeCaseGroup]: 'Change case group',
        [BulkActionType.ResyncCosmo]: 'Resync cosmo',
    },
    bulkActionsEmailConfirmationSubject: {
        [BulkActionType.MoveCaseStatus]: 'Change case status',
        [BulkActionType.PauseCases]: 'Pause selected cases',
        [BulkActionType.ContinueCases]: 'Continue selected cases',
        [BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [BulkActionType.ChangeBillingModel]: 'Change billing model',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [BulkActionType.ChangeWorkflow]: 'Change workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [BulkActionType.RollbackOneTask]: 'Workflow tasks rolled back',
        [BulkActionType.RollbackAllTasks]: 'Workflow tasks rolled back',
        [BulkActionType.RunBillingModel]: 'Billing model has been run',
        [BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo has been run',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI registrations on ended cases have been deleted',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI registrations have been moved to merged cases',
        [BulkActionType.ChangeCaseGroup]: 'Case groups have been changed',
        [BulkActionType.ResyncCosmo]: 'Cosmo resynced',
    },
    bulkActionsEmailConfirmationBody: {
        [BulkActionType.MoveCaseStatus]: 'Changed case status on the selected cases.',
        [BulkActionType.PauseCases]: 'Pausing selected cases done.',
        [BulkActionType.ContinueCases]: 'Continued selected cases.',
        [BulkActionType.RunProcedure]: 'Shortcut executed on selected cases.',
        [BulkActionType.ChangeBillingModel]: 'Changed billing model on the selected cases.',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Changed billing appendix setup on the selected cases.',
        [BulkActionType.ChangeWorkflow]: 'Changed workflow on the selected cases.',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Moved workflow task on the selected cases.',
        [BulkActionType.RollbackOneTask]: 'Workflow tasks rolled back.',
        [BulkActionType.RollbackAllTasks]: 'Workflow tasks rolled back.',
        [BulkActionType.RunBillingModel]: 'Billing model has been run',
        [BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo has been run',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI registrations on ended cases have been deleted',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI registrations have been moved to merged cases',
        [BulkActionType.ChangeCaseGroup]: 'Case groups has been changed',
        [BulkActionType.ResyncCosmo]: 'Cosmo has been resynced',
    },
    paymentPlansInsights: {
        paymentPlans: 'Payment plans',
        quantityEntries: 'Quantity of entries',
        amountEntries: 'Amount',
        funnelHeader: 'Lifecycle',
        totalCreated: 'Created',
        activated: 'Activated',
        inProgress: 'In progress',
        completed: 'Completed',
        defaulted: 'Defaulted',
        deletedAfterActivation: 'Deleted',
        awaitingActivation: 'Awaiting activation',
        neverActivated: 'Never activated',
        ofCreated: (share) => `${share}% of created`,
        ofActivated: (share) => `${share}% of activated`,
        churnHeader: 'Churn',
        churnRate: 'Churn rate',
        churnRateInfo: 'Share of activated plans that ended in default.',
        defaultedPlans: 'Defaulted plans',
        churnedBeforeFirstPayment: 'Before first payment',
        churnedAfterFirstPayment: 'After first payment',
        ofDefaulted: (share) => `${share}% of defaulted`,
        neverActivatedHeader: 'Created but never activated',
        neverActivatedInfo: 'Plans that were created but never activated, split by who created them.',
        createdByDebtor: 'Created by debtor',
        createdByCaseworker: 'Created by caseworker',
        paymentMethodsHeader: 'Payment methods',
        methodColumn: 'Method',
        plansColumn: 'Plans',
        activationRateColumn: 'Activation rate',
        defaultRateColumn: 'Default rate',
        methodBetalingsservice: 'Betalingsservice',
        methodLeverandorservice: 'Leverandørservice',
        methodVisa: 'Visa',
        methodMastercard: 'Mastercard',
        methodDankort: 'Dankort',
        methodCard: 'Card',
        methodMobilePay: 'MobilePay',
        methodVipps: 'Vipps',
        methodSwish: 'Swish',
        methodOther: 'Other',
        methodNone: 'No payment method',
        creditorsHeader: 'Creditors with most payment plans',
        creditorColumn: 'Creditor',
        finishedColumn: 'Completed',
        defaultedColumn: 'Defaulted',
        vintageHeader: 'Cohort analysis (vintage)',
        vintageInfo: 'Each row is the month plans were created, tracked by age. Read down a column (same age) to see whether newer cohorts default more or less than older ones. Cells stay blank until a cohort is old enough to be observed at that age.',
        vintageCohortColumn: 'Created',
        vintageAgeAxis: 'Months since creation',
        vintageActivatedShort: (n) => `${n} activated`,
        vintageLegendLabel: 'Cumulative default rate',
        vintageLow: 'lower',
        vintageHigh: 'higher',
        vintageCellInfo: (rate, defaults, activated) => `${rate}% cumulative default (${defaults} of ${activated} activated)`,
    },
    insights: {
        showingNewest: 'Showing the newest {count}.',
        lastDays: 'Last {days} days',
        fromDate: 'From date',
        toDate: 'To date',
        getReport: 'Get report',
        powerbi: {
            title: 'Your data. Your insights.',
            intro: 'Select the data sources for your report. Download a Power BI project (.pbip), packaged with its required folders, queries and data dictionary in one ZIP file.',
            openInstructions: 'Extract the ZIP file and open Debbie.pbip in Power BI Desktop for Windows. Enable Power BI Project and enhanced report format (PBIR) in Preview features if your version requires it. Choose Anonymous authentication for the web source: the API key is already sent in the request header. Refresh to load data.',
            dataSources: 'Data sources',
            selectSources: 'Select at least one data source and accept the API key warning.',
            selectAll: 'Select all data sources',
            includeSource: 'Include in project',
            downloadProject: 'Create key and download Power BI project (.pbip)',
            downloadAgain: 'Download the same project again',
            securityWarning: 'Downloading creates an API key with read access to the selected data sources. The key is stored in plain text in the project and query files. Anyone with the files can use this access. Store them securely and share them only with trusted recipients. Sharing them with other people or external services also shares the key and access to the data. You can revoke the key below.',
            acceptWarning: 'I understand that an API key will be created and included in the files.',
            keyCreated: 'The API key has been issued and appears below. Downloading this project again reuses the same key. Changing the selection or key name creates a new key on the next download.',
            noAccess: 'Creating a project requires permission to issue API keys. In the creditor portal, select a creditor first.',
            extendTitle: 'Add data sources to an existing report',
            manualInstructions: 'Select the additional sources here and download a project. In your existing Power BI report, choose Transform data → New source → Blank query → Advanced Editor. Paste the contents of the matching file in queries/, name the query after the source and choose Close & Apply. This adds a source using its new key and preserves existing queries, visuals and measures. Add relationships in Model view using data-dictionary.json. Do not replace your existing project with the downloaded project.',
            manualConnection: 'API / add manually',
            manualKeyInstructions: 'For manual setup, copy the query below and replace PASTE_API_KEY_HERE with an API key that grants the displayed scope. You can issue a key by selecting this source and downloading a project, or in API settings. Existing keys do not automatically gain access to new sources.',
            copyQuery: 'Copy Power Query',
            keysDescription: 'Issued keys with access to reporting data, including keys created in API settings. The secret cannot be retrieved again. Revoking a key stops future access for every report or integration using it; already imported data remains in Power BI.',
            issuedAt: 'Issued',
            revoke: 'Revoke key',
            revokeWarning: 'Revoke this API key? All reports and integrations using it will lose access on their next requests, after the short authentication cache expires. Data already downloaded will remain in their files.',
            refreshInstructions: 'The API limits requests per source to once per day. Avoid frequent previews and refreshes. For scheduled refresh in Power BI Service, configure the web connection as Anonymous; the key remains in the query. Service refresh and credentials must be configured separately after publishing.',
            modelNotes: 'Join using stable identifiers such as caseId, customerId and creditorId; cases.id and referenceId are display/external references, not global join keys. Each feed describes its row grain below. Relationships use single-direction filtering from the one side to the many side; only links between selected tables are included. Other useful links: cases.creditorId → creditors.creditorId, cases.workflowId → workflows.id, workflow-tasks.updateTypeId → update-types.updateTypeId, billing-vouchers.caseVoucherId → case-vouchers.caseVoucherId, payment-plans.documentId → documents.documentId. Add these carefully to avoid ambiguous filter paths. Updates.referenceId is polymorphic: check update-types.referenceType; interactions and documents have referenceType, and properties has ref. Filter the reference type before joining to cases or customers. Never assume all references are cases. Monetary amounts retain API units (minor currency units, e.g. øre); divide by 100 for DKK/SEK/NOK/EUR and aggregate each currency separately. Payment-plan-entries has no currency column; obtain currency from the appropriate case context, never assume mixed portfolios use one currency. Voucher amounts are signed; do not calculate balances by indiscriminately summing every voucher type. Avoid double counting when joining multiple detail tables. Status and type labels follow the chosen language. Timestamps with time zones are converted to UTC; date-only values remain dates at midnight. Nested records/lists are preserved as JSON text. Empty feeds keep their columns; missing optional fields become null. The model includes the standard feed columns, not optional detailed fields. It contains no cached customer data until refreshed.',
            shortIntro: 'Connect Debbie to Power BI and build reports with the data you need.',
            help: 'Getting started',
            chooseSources: 'Choose your data sources',
            chooseHint: 'Select sources for Power BI, or use </> to connect manually.',
            clearSelection: 'Clear selection',
            groupCases: 'Cases & customers',
            groupEconomy: 'Economy & payments',
            groupActivity: 'Activity & documents',
            groupOrganisation: 'Organisation & workflows',
            yourProject: 'Your Power BI project',
            projectContents: 'Data connections, relationships and a data dictionary — ready for your report.',
            selectedSources: 'data sources selected',
            emptySelection: 'Choose sources on the left to build your project.',
            downloadLabel: 'Download Power BI project',
            downloadFormat: '.pbip project · Delivered as ZIP · Power BI Desktop',
            shortSecurity: 'A new API key is included in the project. You can review access before downloading and revoke it at any time.',
            confirmTitle: 'Create access to your data',
            projectReady: 'Your project is ready',
            manageKeys: 'View and manage API keys',
            openProject: 'Open the project in Power BI',
            refreshTitle: 'Keep your report up to date',
            extendHint: 'Use the </> button on a data source for a step-by-step guide to adding it to your existing Power BI report. Your current visuals and measures are preserved.',
            guideKeyTitle: 'Create an API key in Debbie',
            guideKey: 'Open Settings → Developers → API and choose Create API key. Give it a name you recognise and select the permission shown below. Create the key and save it securely — it is only shown once. If you already have a key with this permission, you can reuse it.',
            guideWebTitle: 'Add a web source in Power BI',
            guideWeb: 'Open your existing report in Power BI Desktop. Choose Home → Get data → Web, then Advanced. Copy the address below into the first URL field.',
            guideAuthTitle: 'Enter your API key',
            guideAuth: 'Under HTTP request header parameters, choose Authorization. In the field next to it, enter Bearer, followed by a space and your API key. In the image, replace <your URL> with the address above and <your token> with your key. Choose OK. If asked how to connect, choose Anonymous — the key has already been entered in the header.',
            guideImageAlt: 'Power BI Web connection: URL at the top and Authorization with Bearer followed by the API key below.',
            guideLoadTitle: 'Load the data into your report',
            guideLoad: 'If Power Query shows a list, choose To Table and accept the default settings, then expand the column using the two-arrow icon and select the fields you need. Give the query the source’s name and choose Close & Apply. The new table appears alongside your existing data. You can connect it to other tables in Model view using matching IDs, for example caseId. Your existing report is preserved.',
            advancedQuery: 'Advanced: use Power Query code',
            dictionaryInstructions: 'data-dictionary.json describes the selected sources, columns and relationships without containing the API key. Use it as a reference when building or extending reports. The project also includes table descriptions and predefined relationships.',
            sourceDescriptions: {
                cases: 'One row per non-deleted case, with customer, creditor, status and workflow references.',
                creditors: 'One row per creditor with identity, state and contact references.',
                satisfactions: 'One row per satisfaction response for a case, including score (1–5) and comment.',
                'case-vouchers': 'One row per non-deleted case voucher, with signed amount, currency, category and dates.',
                'billing-vouchers': 'One row per non-deleted billing voucher. Creditors only see billed entries.',
                users: 'One row per user on the tenant, with role and contact details. Deleted users are excluded.',
                updates: 'One row per task/update. referenceId can identify different entity types; resolve via the task type.',
                'update-types': 'One row per task type, with its label, reference type and behavior flags.',
                workflows: 'One row per workflow. Its key is id.',
                'workflow-tasks': 'One row per task in a workflow, with workflowId and updateTypeId.',
                'case-statuses': 'One row per case status change. Multiple rows can exist for each case.',
                interactions: 'One row per interaction, with channel, direction, state and reference type.',
                documents: 'One row per document, with reference type, dates and file metadata; no file content.',
                'payment-plans': 'One row per payment plan for a case, with status and reminder flags.',
                'payment-plan-entries': 'One row per payment plan installment, with amount, due dates and status. No currency field.',
                customers: 'One row per non-deleted customer belonging to a creditor. A customer can have multiple cases.',
                'users-on-customers': 'One row per contact/customer relationship. Contact details are JSON, not a tenant userId.',
                properties: 'One row per current property value. ref specifies the entity type of refId; data is JSON.',
            },
            sourceSummaries: {
                cases: 'Status, customers and workflows',
                creditors: 'Creditor details and contacts',
                satisfactions: 'Scores and feedback from cases',
                'case-vouchers': 'Amounts, currencies and voucher types',
                'billing-vouchers': 'Billing, settlements and VAT',
                users: 'Team members and roles',
                updates: 'Tasks, dates and progress',
                'update-types': 'Task categories and behavior',
                workflows: 'Workflow definitions',
                'workflow-tasks': 'Steps within each workflow',
                'case-statuses': 'A history of case status changes',
                interactions: 'Channels, direction and delivery status',
                documents: 'Document types, dates and signatures',
                'payment-plans': 'Agreements and payment plan status',
                'payment-plan-entries': 'Installments, amounts and deadlines',
                customers: 'Customer records and references',
                'users-on-customers': 'Contacts and their customer relationships',
                properties: 'Custom attributes and values',
            },
        },
        connectToApi: 'Connect to your data via an API',
        downloadLimit: 'The limit for requesting a specific data source is one time per day',
        apiTypes: {
            ['cases']: 'Cases',
            ['users']: 'Users',
            ['satisfactions']: 'Satisfactions',
            ['case-vouchers']: 'Case vouchers',
            ['billing-vouchers']: 'Billing vouchers',
            ['creditors']: 'Creditors',
            ['updates']: 'Tasks',
            ['update-types']: 'Task types',
            ['workflows']: 'Workflows',
            ['workflow-tasks']: 'Workflow tasks',
            ['case-statuses']: 'Cases status log',
            ['interactions']: 'Interactions',
            ['documents']: 'Documents',
            ['payment-plans']: 'Payment plans',
            ['payment-plan-entries']: 'Payment plan entries',
            ['users-on-customers']: 'Users on customers',
            ['customers']: 'Customers',
            ['properties']: 'Properties',
        },
        connectGuide: {
            description: 'You can access your data through an API for external use',
            liIntroStep1: 'Go to Settings and choose Developers',
            liIntroStep2: 'Create a new API-Key',
            liIntroStep3: 'Name the key and choose the corresponding scope',
            liIntroStep4: 'The corresponding scope is',
            liIntroStep5: 'You can now use your new API-key to connect to',
            powerbiDescription: 'The walkthrough below shows how to connect to Power BI',
            liPowerbiStep1: "Connect to a new 'Web' data source inside Power BI",
            liPowerbiStep2: 'Fill out the configurations as the picture below where you replace',
            liPowerbiStep3: 'with the web address from above and',
            liPowerbiStep4: 'with your newly created API-key',
            liPowerbiStep5: 'Press OK and you are good to go',
            understood: 'Close',
        },
        connect: 'Connect',
        download: 'Download',
        orderReport: 'Order report',
        billingFile: 'Billing file',
        billingFileDesc: 'Billing file for debtor transactions per creditor per day.',
        caseOverview: 'Case Overview',
        caseOverviewDesc: 'Overview of all active and ended cases including status, financials and debtor information.',
        includeDocuments: 'Include documents',
        includeVouchers: 'Include vouchers',
        includeRki: 'Include RKI reports',
        documents: 'Documents',
        steps: 'Steps',
        vouchers: 'Vouchers',
        cases: 'Cases',
        collector: 'Collector',
        creditor: 'Creditor',
        rki: 'RKI',
        downloadsYourExportIsReady: 'Your report is ready',
        downloadsYourExportIsReadyBody: '<p>Hi</p><p>Your report is ready to download.</p>',
        downloadsYourExportIsReadyButton: 'Download report',
        caseOverviewHeaderDocumentId: 'Doc Id',
        caseOverviewHeaderFileLink: 'Link to file',
        caseOverviewHeaderType: 'Type',
        caseOverviewHeaderSignedAt: 'Date of signature underskrift',
        caseOverviewHeaderCreatedAt: 'Date of creation',
        caseOverviewHeaderDate: 'Date',
        caseOverviewHeaderDueDate: 'Due date',
        caseOverviewHeaderCategory: 'Category',
        caseOverviewHeaderImposedBy: 'Imposed by',
        caseOverviewHeaderText: 'Text',
        caseOverviewHeaderInterest: 'Interest rate',
        caseOverviewHeaderInterestStartDate: 'Interest start date',
        caseOverviewHeaderInterestEndDate: 'Interest end date',
        caseOverviewHeaderAmount: 'Amount',
        caseOverviewHeaderExpirationDate: 'Expiration date',
        caseOverviewHeaderExpired: 'Expired',
        caseOverviewCompany: 'Company',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Creditor',
        caseOverviewHeaderCreditorSeqId: 'Creditornummer',
        caseOverviewHeaderCaseGroup: 'Case group',
        caseOverviewHeaderImportedAt: 'Import date',
        caseOverviewHeaderCaseSeqId: 'Case number',
        caseOverviewHeaderMigratedJournalNumber: 'Migrated j.no.',
        caseOverviewHeaderReferenceId: 'Reference',
        caseOverviewHeaderDebtorSeqId: 'Debtor number',
        caseOverviewHeaderDebtorName: 'Name',
        caseOverviewHeaderDebtorEmail: 'Email',
        caseOverviewHeaderDebtorPhone: 'Phone',
        caseOverviewHeaderDebtorSatisfaction: 'Satisfaction',
        caseOverviewHeaderDebtorSatisfactionComment: 'Satisfaction comment',
        caseOverviewHeaderDebtorRKICount: 'RKI registration count',
        caseOverviewHeaderDebtorCompanyStatus: 'Company status',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Birthdate',
        caseOverviewHeaderDebtorAddressProtection: 'Address protected',
        caseOverviewHeaderDebtorCountry: 'Country',
        caseOverviewHeaderDebtorZipCode: 'Zipcode',
        caseOverviewHeaderDebtorCity: 'City',
        caseOverviewHeaderDebtorAddress: 'Address',
        caseOverviewHeaderDebtorCoAddress: 'Co address',
        caseOverviewHeaderDebtorType: 'Debtor type',
        caseOverviewHeaderDebtorCount: 'Debtor count',
        caseOverviewHeaderCreditScore: 'Credit Score',
        caseOverviewHeaderCurrency: 'Currency',
        caseOverviewHeaderPrincipal: 'Principal',
        caseOverviewHeaderPrincipalPaid: 'Paid of principal',
        caseOverviewHeaderPrincipalLeft: 'Remaining of principal',
        caseOverviewHeaderReminderFeeCreditor: 'Reminder fee from creditor',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Paid of reminder fee from creditor',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Remaining of reminder fee from creditor',
        caseOverviewHeaderReminderFeeCollector: 'Reminder fee from collector',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Paid of reminder fee from collector',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Remaining of reminder fee rom collector',
        caseOverviewHeaderCompensationCostCreditor: 'Compensation fee from creditor',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Paid of compensation fee from creditor',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Remaining of compensation fee from creditor',
        caseOverviewHeaderCompensationCostCollector: 'Compensation fee from collector',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Paid of compensation fee from collector',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Remaining of compensation fee from collector',
        caseOverviewHeaderCollectionCostCreditor: 'Collection cost from creditor',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Paid of collection cost from creditor',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Remaining of collection cost from creditor',
        caseOverviewHeaderCollectionCostCollector: 'Collection cost from collector',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Paid of collection cost from collector',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Remaining of collection cost from collector',
        caseOverviewHeaderCollectionFeeCreditor: 'Collection fee from creditor',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Paid of collection fee from creditor',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Remaining of collection fee from creditor',
        caseOverviewHeaderCollectionFeeCollector: 'Collection fee from collector',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Paid of collection fee from collector',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Remaining of collection fee from collector',
        caseOverviewHeaderCourtCostCreditor: 'Court costs from creditor',
        caseOverviewHeaderCourtCostCreditorPaid: 'Paid of court costs from creditor',
        caseOverviewHeaderCourtCostCreditorLeft: 'Remaining of court costs from creditor',
        caseOverviewHeaderCourtCostCollector: 'Court costs from collectors',
        caseOverviewHeaderCourtCostCollectorPaid: 'Paid of court costs from collectors',
        caseOverviewHeaderCourtCostCollectorLeft: 'Remaining of court costs from collectors',
        caseOverviewHeaderInterestCreditor: 'Interests from creditor',
        caseOverviewHeaderInterestCreditorPaid: 'Paid of interests from creditor',
        caseOverviewHeaderInterestCreditorLeft: 'Remaining of interests from creditor',
        caseOverviewHeaderInterestCollector: 'Interests from collector',
        caseOverviewHeaderInterestCollectorPaid: 'Paid of interests from collector',
        caseOverviewHeaderInterestCollectorLeft: 'Remaining of interests from collector',
        caseOverviewHeaderCreditorTotal: 'Total from creditor',
        caseOverviewHeaderCreditorTotalPaid: 'Paid of total from creditor',
        caseOverviewHeaderCreditorTotalLeft: 'Remaining of total from creditor',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Deposited to creditor in total',
        caseOverviewHeaderCollectorTotal: 'Total from collector',
        caseOverviewHeaderCollectorTotalPaid: 'Paid of total from collector',
        caseOverviewHeaderCollectorTotalLeft: 'Remaining of total from collector',
        caseOverviewHeaderTotal: 'Total',
        caseOverviewHeaderTotalPaid: 'Paid of total',
        caseOverviewHeaderTotalLeft: 'Remaining of total',
        caseOverviewHeaderLastDepositDate: 'Latest deposit date',
        caseOverviewHeaderCurrentWorkflow: 'Workflow',
        caseOverviewHeaderCurrentWorkflowTask: 'Current task',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Current task date',
        caseOverviewHeaderNextWorkflowTask: 'Next task',
        caseOverviewHeaderNextWorkflowTaskTime: 'Next task date',
        caseOverviewHeaderFoundation: 'Foundation',
        caseOverviewHeaderPaymentPlan: 'Payment plan',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Paid entries',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Total payment plan entries',
        caseOverviewHeaderCaseStatus: 'Case status',
        caseOverviewHeaderEndReason: 'End reason',
        caseOverviewHeaderExitDate: 'End date',
        caseOverviewHeaderStepTitle: 'Step title',
        caseOverviewHeaderStepCategory: 'Step category',
        caseOverviewHeaderNextStepTitle: 'Next step title',
        caseOverviewHeaderNextStepCategory: 'Next step category',
        caseOverviewHeaderSignedFoudations: 'Signed foundations',
        caseOverviewHeaderPaymentPlans: 'Payment plans created',
        caseOverviewHeaderFoundationDate: 'Foundation Date',
        caseOverviewHeaderFoundationCode: 'Foundation Code',
        caseOverviewHeaderFoundationType: 'Fundaments Type',
        caseOverviewHeaderRkiRegistry: 'Registry',
        caseOverviewHeaderState: 'State',
        caseOverviewHeaderReportedAt: 'Reported At',
        caseOverviewHeaderError: 'Error Meassage',
        caseOverviewHeaderRKIReference: 'RKI Reference Number',
        caseOverviewHeaderClientNumber: 'Creditor Number',
        caseOverviewHeaderSurveillance: 'Surveillance',
        caseOverviewHeaderSurveillanceDate: 'Surveillance Date',
        paymentPlansOverview: 'Payment Plans Overview',
        paymentPlansOverviewTabPaymentPlans: 'Payment Plans',
        paymentPlansOverviewTabPaymentPlanEntries: 'Installments',
        paymentPlansOverviewHeaderPaymentPlanId: 'Payment Plan ID',
        paymentPlansOverviewHeaderCaseSequentialId: 'Case Number',
        paymentPlansOverviewHeaderCaseStatus: 'Case Status',
        paymentPlansOverviewHeaderCreditorName: 'Creditor Name',
        paymentPlansOverviewHeaderStatus: 'Status',
        paymentPlansOverviewHeaderCreatedAt: 'Date Created',
        paymentPlansOverviewHeaderSettledEntries: 'Paid Installments',
        paymentPlansOverviewHeaderTotalEntries: 'Total Installments',
        paymentPlansOverviewHeaderAmount: 'Installment Amount',
        paymentPlansOverviewHeaderFromDate: 'From Date',
        paymentPlansOverviewHeaderToDate: 'To Date',
        paymentPlansOverviewEntriesHeaderPaymentPlanId: 'Installment ID',
        paymentPlansOverviewEntriesHeaderCaseSequentialId: 'Case Number',
        paymentPlansOverviewEntriesHeaderCaseStatus: 'Case Status',
        paymentPlansOverviewEntriesHeaderCreditorName: 'Creditor Name',
        paymentPlansOverviewEntriesHeaderAmount: 'Amount',
        paymentPlansOverviewEntriesHeaderEntryStatus: 'Status',
        paymentPlansOverviewEntriesHeaderReminderDate: 'Reminder Date',
        paymentPlansOverviewEntriesHeaderDate: 'Installment Date',
        paymentPlansOverviewEntriesHeaderDeadlineDate: 'Final Deadline',
        paymentPlansOverviewEntriesHeaderCancelDate: 'Default Date',
        reportOrdered: 'Report ordered',
        reportOrderedText: 'You will soon receive an email with your report.',
        reportOrderedCloseButton: 'Close',
        interactionsReports: 'Interactions Report',
        interactionsReportsDesc: 'Report for all incoming and outgoing interactions',
        interactionsReportsCreatedAt: 'Created',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Type',
        interactionsReportsDirection: 'Direction',
        interactionsReportsCreditorSeqId: 'Creditor number',
        interactionsReportsCreditor: 'Creditor',
        interactionsReportsCaseSeqId: 'Case id',
        interactionsReportsAddress: 'Address',
        interactionsReportsZipcode: 'Zipcode',
        interactionsReportsCity: 'City',
        interactionsReportsCountry: 'Country',
        creditorsReportSeqId: 'Creditor number',
        creditorsReportName: 'Creditor name',
        creditorsReportCentralRegisterId: 'CVR / CPR',
        creditorsReportStatus: 'Status',
        creditorsReportAddress: 'Address',
        creditorsReportZipcode: 'Zip code',
        creditorsReportCity: 'City',
        creditorsReportContactPerson: 'Contact person at creditor',
        creditorsReportAcquisitionResponsible: 'Acquisition responsible',
        creditorsReportCaseworkerContact: 'Caseworker contact',
        creditorsReportDefaultWorkflow: 'Default workflow',
        creditorsReportCatchAllResponsible: 'Catch-all responsible for tasks',
        creditorsReportExperianClientNumber: 'Experian client number',
        creditorsReportCaseCount: 'Number of cases',
        creditorsReportLatestCaseCreatedAt: 'Date of latest case creation',
        creditorsReportCollectorName: 'Collector name',
        creditorsReportDefaultBillingModel: 'Default billing model',
        creditorsReportDefaultBillingAppendixSetup: 'Default billing appendix setup',
        creditorsReportBillingEmailTo: 'Billing email to',
        creditorsReportBillingEmailCc: 'Billing email cc',
        creditorsReportBillingEmailBcc: 'Billing email bcc',
        creditorsReportPaymentDays: 'Payment days',
        creditorsReportMinimumBillingThreshold: 'Minimum threshold for case billing',
        creditorsReportCreatedAt: 'Created',
        dailyDeposits: 'Daily Deposits',
        dailyDepositsDesc: 'Daily deposits pr. creditor',
        paymentPlanReport: 'Payment Plan Report',
        paymentPlanReportDesc: 'Report containing information about active, canceled and past payment plans.',
        dailyDepositsEconomic: 'Daily deposits pr. creditor (e-conomic)',
        dailyDepositsEconomicDesc: 'Daily deposits pr. creditor. per creditor to e-conomic uden Frisbii',
        invoiceAppendix: 'Invoice Appendix',
        invoiceAppendixDesc: 'Sheet to show financial transactions for creditors in a period of time.',
        employeePerformance: 'Employee Performance',
        employeePerformanceDesc: 'Report showing the effectiveness of each employee.',
        phoneCalls: 'Phone Call Overview',
        phoneCallsDesc: 'Overview showing who called and amount of resulting deposits.',
        phoneCallsDays: 'Number of days after call the deposit has to be registered.',
        depositAmount: 'Deposited amount',
        depositCount: 'Deposit count',
        selectCreditor: 'Select creditor',
        quarter: 'Quarter',
        optional: 'optional',
        noDownloads: 'There are no reports to download.',
    },
    tribunal: {
        tribunal: 'Tribunal',
        couldNotCreateTribunalCase: 'Could not create Tribunal case',
        createTribunalCase: 'Create',
        noTribunalCases: 'No Tribunal cases yet',
        addTribunalCase: 'Add Tribunal case',
        fsNo: 'FS no.',
        editFsNo: 'Edit FS no.',
        FsNoUpdated: 'FS no. updated',
        document: 'Document',
        addDocument: 'Add document',
        closedObjection: 'Closed because of objection',
        insolvency: 'Insolvency',
        insolvencyDate: 'Insolvency date',
        phoneCourtMeeting: 'Court phone meeting',
        register: 'Register',
        date: 'Date',
        meetingLocation: 'Meeting location',
        meetingDate: 'Meeting date',
        courtCaseCosts: 'Court case costs',
        notRegistered: 'Not registered',
        createFogedrekvisition: "Create 'fogedrekvisition'",
        assignee: 'Assignee',
        selectDistraintType: 'Select distraint type',
        registerDistraint: 'Register distraint',
        distraintType: 'Distraint type',
        amount: 'Amount',
        comment: 'Comment',
        address: 'Address',
        licenseplate: 'Licenseplate',
        vin: 'VIN',
        distraintDate: 'Date of distraint',
        distraintReferenceId: 'Tinglysning registration number',
        distraintUpdated: 'Distraint updated',
        distraintCancelled: 'Distraint cancelled',
        distraintCancelledDate: 'Date of distraint cancellation',
        registerPolicePresentation: 'Register police presentation',
        register1Paategning: "Register '1.-påtegning'",
        foerstePaategningDate: "Date of '1.-påtegning'",
        register2Paategning: "Register '2.-påtegning'",
        andenPaategningDate: "Date of '2.-påtegning'",
        resendBPK: "Resend 'betalingspåkrav'",
        editBPK: "Edit 'betalingspåkrav'",
        debtorSentToPolicePresentation: 'Debtor sent to police presentation',
        resendStaevning: "Resend 'stævning'",
        editStaevning: "Edit 'stævning'",
        resendFogedbegaering: "Resend 'fogedbegæring'",
        editFogedbegaering: "Edit 'fogedbegæring'",
        courtMeetingType: 'Meeting type',
        previousMeetingTypes: 'Previous meeting types',
        unknownMeetingType: 'Unknown meeting type',
        noMeetingDate: 'No date',
        meetingDocumentFileName: 'document.pdf',
        bailiffInvoice: {
            bailiffInvoice: 'Bailiff invoice',
            client: 'Creditor',
            debt: 'Debt',
            paymentFee: 'Demand for payment fee',
            distress: 'Distress',
            yesStartDistress: 'Yes to initiation of distress',
            yesAutoCase: 'Yes to automatic case introduction in civil court',
            createInvoice: 'Create invoice',
        },
        noFoundation: 'No foundation found. Please add one to the case.',
        addFoundation: 'Add foundation',
        foundation: 'Foundation',
        economy: 'Economy',
        jurisdiction: 'Jurisdiction',
        requisition: 'Requisition',
        court: 'Court',
        responsible: 'Responsible',
        sendRequisition: 'Send requisition',
        debt: 'Debt',
        noCourt: 'No court found',
        typeOfRequisituion: 'Type of requisition',
        types: {
            [UdbetalingsRekvisitioner.Politifremstilling]: 'Police presentation',
            [UdbetalingsRekvisitioner.Betalingspåkrav]: 'Demand for payment',
            [UdbetalingsRekvisitioner.Fogedrekvisition]: 'Bailiff requisition',
        },
        claim: 'Claim',
        sendToCourt: 'Send to court',
        smallCase: 'Small Case',
        commonCivilCase: 'Common civil case',
        shortDescription: 'Short description',
        statementClaim: 'Case presentation and facts',
        addAppendix: 'Add appendix',
        additionalInformation: 'Additional information',
        caseCreation: 'Creating case',
        caseCreationDescription: `The case is now being created in the court system. It takes some time, but the case will be updated in Debbie once it has finished.`,
        keyCodeTitle: 'Type keycode for',
        keyCodeDescription: 'Use the NemID key card to find the key which corresponds to',
        sessionCreation: 'Creating session',
        sessionCreationFailure: 'Session creation failed',
        keySubmittedExplainer: 'The keycode is being used to log in.',
        sessionCreationExplainer: 'For a case to be sent to the court, there needs to be created a session in tribunal. To do that we need a keycode from your NemID key card.',
        keycode: 'NemID keycode',
        authKey: 'Key',
        missingKeyTitle: 'Missing tribunal key',
        missingKeyExplainer: 'To send cases to the court, you need a key for tribunal.',
        meetings: 'Meetings',
    },
    courtMeetingState: {
        [CourtMeetingState.Accepted]: 'Meeting accepted',
        [CourtMeetingState.Concluded]: 'Done',
        [CourtMeetingState.NeedsApproval]: 'Awaiting approval',
        [CourtMeetingState.NeedsRevision]: 'Awaiting revision',
        [CourtMeetingState.NotesSent]: 'Notes received',
        [CourtMeetingState.ReadyForMeeting]: 'Awaiting meeting notes',
        [CourtMeetingState.Rejected]: 'Rejected by assignee',
        [CourtMeetingState.Canceled]: 'Canceled',
    },
    debtorWeb: {
        overpaymentHeader: 'You have money owed to you',
        overpaymentSuccessHeader: 'Your account details have been received',
        overpaymentSuccessTextHeader: 'Your refund will be paid out as soon as possible. If you made a mistake in your entry, you can update your details below.',
        overpaymentPreAmount: 'You are due to get',
        overpaymentPostAmount: "back. Write your bank account number below, and we'll send them to you.",
        userInfoUpdateSuccess: 'Your request have been sent. Thank you.',
        userInfoUpdateNoDataChanged: 'No changes registered',
        congratsNoDebt: 'Congratulations. You have no more debt on this case.',
        congratsDeposit: 'Thank you for your deposit on this case.',
        congratsCaseEnd: 'The case has been closed.',
        satisfactionOne: 'We would like to hear about your experience. Please click',
        satisfactionTwo: 'here',
        satisfactionThree: 'to tell about it.',
        documentation: 'Documentation',
        goToPayment: 'Go to payment',
        signingPageSigned: 'You have signed the document',
        signingPageDeclinedSigning: 'You have declined to sign the document',
        seeMore: 'See more',
        noCasesFound: 'No cases found',
    },
    associateCases: {
        associateCase: 'Joint liability',
        associateWithCase: 'Find the case with the jointly liable debtor.',
        associateWithCaseSearch: 'Search for case',
        associateCaseVoucher: 'Do you want to synchronize this case voucher with the other cases?',
        caseVoucherIsAssociated: 'This case voucher is synchronized with other cases in the joint liability.',
        joinExistingCase: 'Join existing case',
        createNewAssociatedCase: 'Create new associated case',
        selectVouchers: 'Select vouchers',
        selectVouchersDescription: 'Choose which vouchers to copy to the new case.',
        createAssociatedCaseButton: 'Create associated case',
        noVouchersAvailable: 'No vouchers available to clone',
    },
    caseGroups: {
        caseGroups: 'Case Groups',
        aiSettings: 'AI Settings',
        aiSettingsDescription: 'Instructions here will be used for all cases in this case group.',
        createCaseGroup: 'Create case group',
        addCaseGroup: 'Add case group',
        editCaseGroup: 'Edit case group',
        selectCaseGroup: 'Select case group',
        searchCaseGroups: 'Search case groups',
        confirmDelete: 'Are you sure you want to delete the case group? All cases will be removed from the group.',
        caseGroup: 'Case group',
        deleteCaseGroup: 'Delete',
        label: 'Name',
        categorisedDebtOverview: 'Add properties to categorized debt overview',
        showPropertyLabel: 'Name',
        addShowProperty: 'Add property',
    },
    costCeiling: {
        failedToLoad: 'Something went wrong. Please try again later.',
        costCeiling: 'Cost ceiling',
        customAmount: 'Custom cost ceiling amount (defaults to the principal)',
        defaultForNewCases: 'Cost ceiling on new cases',
        caseGroupDefaultDescription: 'Whether cost ceiling is enabled on new cases created in this case group. If no case group setting is specified, the setting from the creditor or tenant is used.',
        noCreditorSetting: 'No creditor setting',
        noCaseGroupSetting: 'No case group setting',
        enabled: 'Enabled',
        disabled: 'Disabled',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Cases for collection',
        defaultBankAccountName: 'Bank account',
    },
    tenants: {
        tenantDetails: 'Tenant details',
        status: 'Status',
        goLive: 'Set live',
        disableTenant: 'Disable tenant',
        disableTenantWarning: 'Are you sure you want to disable this tenant? Users will lose access, and this action cannot be undone from Lighthouse.',
        tenantTypeNotSet: 'Not set',
        prices: 'Prices',
        identityCollector: 'Collector',
        invoicePipeFilter: 'Invoicing filter',
        defaultBillingModel: 'Default billing model',
        defaultBillingAppendixSetup: 'Default billing appendix setup',
        configurationOptions: 'Configurations',
        depositBankAccountForCreditors: 'Deposit account for creditors',
        depositBankAccountForCreditorsName: 'Bank name',
        billingCustomText: {
            title: 'Custom text for billing',
            underCreditorName: 'Under creditor name',
            endWhenReceivingPayment: 'Under payment information when creditor should pay something',
            endWhenSendingPayment: 'Under payment information when creditor should receive something',
        },
        collectionCommission: 'Collection commission',
        depositOrder: 'Deposit order',
        date: 'Date',
        voucherFrom: 'Voucher imposed by',
        voucherType: 'Voucher type',
        voucherCategory: 'Voucher category',
        newestFirst: 'Newest first',
        oldestFirst: 'Oldest first',
        caseCloseFee: 'Case close fee',
        clientCaseCreationFee: 'Creditor case creation fee',
        tenantCaseCreationFee: 'Tenant case creation fee',
        debtRegisterRegistrationFee: 'Debt register registration fee',
        paymentDemandFee: 'Payment demand fee',
        fogedrekvisitionFee: 'Fogedrekvisition fee',
        folkeregisteropslagsFee: 'Folkeregisteropslag',
        anmeldelseAfKravFee: 'Anmeldelse af krav',
        legalAdviceHourlyRate: 'Hourly rate for legal advice',
        afslysningAfUdlaeg: 'Aflysning af udlæg',
        autoDebtRegisterHeader: 'Auto debt registration',
        automaticDebtRegister: 'Automatically register',
        autoRegisterInOpenRegistry: 'Open registry',
        autoIgnoreUnresolvedOppositions: 'Ignore unresolved interactions (disputes)',
        autoDeleteDebtRegistrationOnCaseEnd: 'Delete debt registration automatically on case end',
        autoDebtRegisterInfoTip: 'Click here for more info',
        areYouSureAutoDebtRegister: 'Are you sure?',
        autoDebtRegisterRKI: {
            headline: 'Automatic registration in debt registries.',
            info: 'This function takes into account the following: ',
            exclude: 'It does NOT take into account the following: : ',
            endingInfo: 'Only enable this function if you know your cases comply with the above.',
            note: 'Note this function can also be enabled/disabled on creditor level.',
        },
        autoImposeCompensationCost: 'Automatically impose compensation costs when importing company cases',
        autoSendInteractionsAfterXVerifications: 'Automatically send interactions after x verifications',
        preventSendingLetters: 'Prevent sending physical letters (Webhooks can be used to send them in other ways)',
        selfCollection: 'Impose self collection debt collection costs',
        twoFactorRequired: 'Two factor authentication required for users',
        outboundCall: 'Outbound call',
        autoExpireVouchers: 'Automatic expiration of vouchers',
        hideDocumentsFromCreditors: 'Hide documents from creditors',
        allowDebtorSelfOverwrite: 'Allow debtors to overwrite their own information without approval',
        costCeilingEnabledByDefault: 'Enable cost ceiling on new cases by default',
        deleteCaseDataAfterYears: 'Delete case data after x years after case has ended (GDPR)',
        enableGdprDataDeletion: 'Enable automatic GDPR data deletion',
        dangerZone: 'Danger zone',
        AKSSettings: 'RKI settings',
        rkiEnabled: 'Enable RKI',
        AKSKey: 'AKS key',
        AKSCode: 'AKS code',
        AKSUsername: 'AKS username',
        AKSPassword: 'AKS password',
        manglerAdvokatindestaaelse: 'Missing advokatindeståelse',
        debitorRegistretEnabled: 'Enable Debitor Registret',
        debitorRegistretClientId: 'Client ID',
        debitorRegistretClientSecret: 'Client Secret',
        debitorRegistretCredentialsRequired: 'Enter both Client ID and Client Secret to save the credentials',
        debitorRegistretSetupCreditors: 'Create creditors in Debitor Registret',
        debitorRegistretSetupCreditorsDescription: 'Creates all active creditors in Debitor Registret and saves their creditor number.',
        debitorRegistretSetupCreditorsSuccess: 'Creditors created in Debitor Registret',
        debitorRegistretSetupCreditorsSkipped: 'Already set up',
        debitorRegistretSetupCreditorsFailed: 'Error creating creditors in Debitor Registret',
        affiliatePartners: 'Affiliate partners',
        createNewTenant: 'Create new tenant',
        createNewTenantAsAffiliatePartner: 'Create new tenant as an affiliate partner',
        disableAi: 'Disable AI',
        disableCreditorCreationFromUi: 'Disable creditor creation from UI',
        autoVerifyCases: 'Auto verify cases',
    },
    intents: {
        intent: 'Intent',
        days: 'Days',
        discount: 'Discount',
        percentDiscount: 'Percent discount',
        type: 'Type',
        noDiscount: 'No discount',
    },
    intentDiscountTypes: {
        [DiscountType.Amount]: 'Amount',
        [DiscountType.Fraction]: 'Fraction',
    },
    intentTypes: {
        [IntentType.Unknown]: 'Unknown',
        [IntentType.Deposit]: 'Deposit',
    },
    errors: {
        notFound: 'The page you are looking for was not found.',
        caseNotFound: 'The case could not be found',
        pleaseCreateTicket: 'Please create a ticket if you think this is an error.',
        unknownError: 'An error occured.',
        authError: 'You do not have access.',
        meError: 'There was an error getting your user information. If this is unexpected, try again.',
        unauthorizedError: 'You do not have permission to perform this action',
        invalid: 'invalid',
        missing: 'Missing',
        loadingError: 'Error loading data',
    },
    letterTemplates: {
        journalNumber: 'Re:',
        caseReferenceId: 'Reference:',
        caseVoucherReferenceIds: 'References:',
        returnAddress: 'Return address:',
        w: 'W',
        e: 'E',
        t: 'P',
        centralRegisterId: 'CVR',
    },
    mentionContent: {
        amortisationRemainingAfterFinalPayment: 'Remaining debt after final installment',
        amortisationForgivenOnCompletion: 'Forgiven upon successful completion',
        amortisationDebtAfterSettlement: 'Debt after successful settlement',
        amortisationPaymentDate: 'Payment date',
        amortisationAddedFees: 'Fees added',
        amortisationRemainingAfterPayment: 'Remaining debt after payment',
        amortisationRemainingDebt: 'Remaining debt',
        amortisationPrincipal: 'Principal',
        amortisationCosts: 'Costs',
        amortisationInterest: 'Interest',
        amortisationAccruedInterest: 'Interest added',
        amortisationPayment: 'Installment',
        amortisationCurrentBalance: 'Current debt',
        reminderFeeRow: 'Reminder fee, cf. Interest Act section 9b, subsection 2',
        debtCollectionFeeRow: 'Collection fee cf. Interest Act section 9b, subsection 3',
        debtCollectionCostRow: 'Collection cost cf. Interest Act section 9a, subsection 1',
        compensationFeeRow: 'Compensation fee cf. Interest Act section 9a, subsection 3',
        fixedInterestRow: 'Previously accrued interest',
        processInterestRow: 'Accrued interests from the due date',
        yearlyInterestRow: 'Accrued interests',
        otherCosts: 'Other costs',
        sum: 'Total outstanding',
        subTotal: 'Subtotal',
        paid: 'Already paid',
        invoice: 'Invoice',
        caseVoucher: 'Voucher',
        currency: 'Currency',
        date: 'Date',
        dueDate: 'Due date',
        amount: 'Amount',
        deposited: 'Deposited',
        residue: 'Residue',
        text: 'Text',
        appliedToPrincipal: 'Applied to principal',
        appliedToInterest: 'Applied to interest',
        appliedToCosts: 'Applied to costs',
        principalBalance: 'Principal balance',
        interestBalance: 'Interest balance',
        costsBalance: 'Costs balance',
        expiredSince: 'Of which expired',
        total: 'Total',
        email: 'Email',
        phone: 'Phone',
        signature: 'Signature',
        journalNumber: 'Re:',
        genericEmailSubjectPre: 'Regarding your outstanding to',
        genericEmailSubjectForAlternativeContactPre: 'Regarding',
        satisfactionsOrClick: 'or click',
        satisfactionsHere: 'here',
        principalReferenceIdsAnd: ', and ',
        previousYearsAnd: ' and ',
        nameAndAddressProtectedPerson: 'Person with name and address protection',
    },
    emailSignature: {
        privacyPolicyText: 'Data processing. We may process personal data about you. You can read our privacy policy here:',
        regards: 'Kind regards',
    },
    notificationEmail: {
        newPendingMessages: 'New pending messages',
        from: 'from',
        regarding: 'regarding',
        goToApp: 'Go to webapp',
        newNotifications: 'New notifications',
        newTodos: 'New tasks',
    },
    newNoteEmail: {
        dear: 'Dear',
        newMessageFromCollector: 'You have received a new message from',
        subjectNewMessageFrom: 'New message from',
        clickHereToAnswer: 'Click the button below to read more or reply to the message.',
        answerAndReadMore: 'Reply or read more',
        sentTo: 'Sent to',
    },
    invoice: {
        deposit: 'Deposit',
        overpayment: 'Overpayment',
        inclVat: 'incl. VAT',
        deposits: 'Deposits',
        creditorSeqId: 'Id',
        period: 'Period',
        description: 'Description',
        amount: 'Amount',
        ofVoucher: 'Of voucher',
        subTotal: 'Subtotal',
        customerReferenceId: 'Customer reference id',
        imposedBy: 'Imposed by',
        vat: 'Vat',
        total: 'Total',
        date: 'Date',
        number: 'Number',
        appendix: 'Appendix',
        voucher: 'Voucher',
        voucherReferenceId: 'Voucher reference',
        text: 'Text',
        disbursements: 'Disbursements',
        fees: 'Fees',
        collectionCommission: 'Collection commission',
        creditorName: 'Creditor',
        creditorReference: 'Creditor reference id',
        ultimateCreditor: 'Ultimate creditor',
        ultimateCreditorName: 'Ultimate creditor name',
        ultimateCreditorReference: 'Ultimate creditor reference id',
        caseGroup: 'Case group',
        caseSeqId: 'Case id',
        caseReferenceId: 'Case reference id',
        depositId: 'Deposit id',
        paidToClient: 'Paid to creditor',
        economicMovement: 'Creditor movement',
        debtorName: 'Debtor name',
        creditorDeposit: 'Creditor Deposit',
        previous: 'Prev.',
        credited: 'Credited',
        currency: 'Currency',
    },
    properties: {
        selectProperty: 'Select a property',
        searchProperties: 'Search properties',
        properties: 'Properties',
        createNewPropertyType: 'Create new property type',
        infoGuideMentions: 'To insert the data into a template please use this tag',
        infoGuideAPI: 'To access the property via API you can use the field',
        infoGuideImport: 'To import data into the property you can make a column in your excel sheet with one of the following column headers',
        newProperty: 'New property type',
        newPropertyFor: 'Create a new property type for',
        label: 'Label',
        description: 'Description',
        searchable: 'Searchable',
        handle: 'Handle',
        type: 'Type',
        selectType: 'Select a type',
        ref: 'Reference',
        scope: 'Affiliation',
        addedToAllCases: 'The property is added to all cases',
        required: 'Required',
        usage: 'Usage',
        historical: 'Historical data',
        create: 'Create',
        defaultDropdownOptions: 'Option 1\nOption 2',
        dropdownOptions: 'Dropdown options',
        cases: 'Cases',
        caseVouchers: 'Case vouchers',
        creditors: 'Creditors',
        delete: 'Delete',
        or: 'or',
        deleteAreYouSure: 'If this property is deleted, it will be removed from all cases and templates. Are you sure?',
        option: 'Option',
    },
    entities: {
        [Entity.Billing]: 'Billing',
        [Entity.Case]: 'Case',
        [Entity.Creditor]: 'Creditor',
        [Entity.Customer]: 'Customer',
        [Entity.TribunalCase]: 'Tribunal case',
        [Entity.Debtor]: 'Debtor',
        [Entity.Collector]: 'Collector',
        [Entity.BillingVoucher]: 'Billing voucher',
        [Entity.CaseVoucher]: 'Case voucher',
        [Entity.Template]: 'Template',
        [Entity.Workflow]: 'Workflow',
    },
    filterType: {
        [FilterType.Exact]: 'Filter on exact match',
        [FilterType.Containing]: 'Filter on containing match',
    },
    propertyDataTypes: {
        [PropertyDataType.checkbox]: 'Yes/no',
        [PropertyDataType.datePicker]: 'Date',
        [PropertyDataType.dropdown]: 'Choice',
        [PropertyDataType.singleLineText]: 'Text',
        [PropertyDataType.multiLineText]: 'Long text',
        [PropertyDataType.number]: 'Number',
        [PropertyDataType.file]: 'File',
        [PropertyDataType.address]: 'Address',
        [PropertyDataType.money]: 'Amount',
    },
    propertyDataTypeDescriptions: {
        [PropertyDataType.checkbox]: 'A checkbox that can be checked or unchecked',
        [PropertyDataType.datePicker]: 'A date selected from a calendar',
        [PropertyDataType.dropdown]: 'A single choice from a predefined list of options',
        [PropertyDataType.singleLineText]: 'A short, single line of text',
        [PropertyDataType.multiLineText]: 'Longer text across multiple lines',
        [PropertyDataType.number]: 'A numeric value',
        [PropertyDataType.file]: 'An uploaded file',
        [PropertyDataType.address]: 'A structured address with street, zip code and city',
        [PropertyDataType.money]: 'An amount with a currency',
    },
    propertyRefDescriptions: {
        [Entity.Customer]: 'The property is filled in on the customer and shared across their cases',
        [Entity.Case]: 'The property is filled in on the individual case',
        [Entity.CaseVoucher]: 'The property is filled in on each voucher on a case',
        [Entity.Creditor]: 'The property is filled in on the individual creditor',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Name of the alternative contact person.',
        ['Address for the alternative contact person.']: 'Address for the alternative contact person.',
        ['Phone to the alternative contact person.']: 'Phone to the alternative contact person.',
        ['Email to the alternative contact person.']: 'Email to the alternative contact person.',
        ['Type of the alternative contact person.']: 'Type of the alternative contact person.',
        ['Company where the alternative contact person works.']: 'Company where the alternative contact person works.',
    },
    alternativeContactTypes: {
        [AlternativeContactType.Lawyer]: 'Lawyer',
        [AlternativeContactType.Proprietorship]: 'Residential administrator',
        [AlternativeContactType.Owner]: 'Owner',
        [AlternativeContactType.Guardian]: 'Guardian',
        [AlternativeContactType.Curator]: 'Curator',
        [AlternativeContactType.Landlord]: 'Landlord',
        [AlternativeContactType.FinancialAdvisor]: 'Financial advisor',
        [AlternativeContactType.TaxAuthority]: 'Tax authority',
        [AlternativeContactType.PowerOfAttorney]: 'Power of attorney',
        [AlternativeContactType.Administrator]: 'Administrator',
        [AlternativeContactType.Police]: 'Police',
        [AlternativeContactType.Guarantor]: 'Guarantor',
        [AlternativeContactType.Other]: 'Other',
    },
    creditScore: {
        estimated: 'Estimated',
        estimate: 'collection probability on remaining debt',
        estimateZero: 'collection probability',
        paid: 'Debt has been paid',
    },
    voucherApplications: {
        header: 'Voucher applications',
        createError: 'Could not create voucher application, check that you are not creating circular references',
        creditorCustomApplicationList: 'Creditors with their own applications',
        noCustomApplications: 'No creditors have custom applications',
        textSelector1: 'When a new ',
        textSelector2: ' is created, where the type of the case is ',
        textSelector3: ', the following voucher will be created',
        forCreditor: 'When creditor is',
        addCreditor: 'Choose creditor',
    },
    voucherApplicationTypeLabels: {
        [VoucherApplicationType.Case]: 'case',
        [VoucherApplicationType.VoucherCategory]: 'voucher with the category',
        [VoucherApplicationType.VoucherType]: 'voucher with the type',
    },
    voucherApplicationTargetLabels: {
        [VoucherApplicationTarget.Both]: 'private/company',
        [VoucherApplicationTarget.Person]: 'private',
        [VoucherApplicationTarget.Company]: 'company',
    },
    interestFromLabels: {
        [InterestFrom.Date]: 'from creation date',
        [InterestFrom.DueDate]: 'from due date',
    },
    todoQueue: {
        sorting: 'Sorting',
        oldest: 'Oldest',
        creditScore: 'Credit score',
        creditorTodosNotSupported: 'Todos are not handled for creditors yet',
    },
    views: {
        associated: 'Associated',
        notAssociated: 'Not associated',
        filter: 'Filter',
        view: 'view',
        name: 'View name',
        introHeader: 'No views here',
        introDescription: 'You can create a view by clicking the button in the top right corner.',
        clear: 'Clear',
        collapse: 'Collapse',
        expand: 'Expand',
        noData: 'Page is empty',
        is: 'is',
        oneOf: 'is one of',
        before: 'before',
        after: 'after',
        values: 'values',
        isNot: 'is not',
        noneOf: 'is not one of',
        invalidNumberError: ' is not a valid number',
        displayOptions: 'Values',
        localChanges: 'View edited locally',
        resetLocalChanges: 'reset changes',
        orderedBy: 'Sort based on',
        orderedByDirection: 'Sort direction',
        primaryLabel: 'Primary label',
        secondaryLabel: 'Secondary label',
        betaDisclaimer: 'Views is a beta feature. Changes or updates may occur that could potentially affect previously created views. We are continuously working to improve this feature and appreciate your patience',
        commaSeparated: 'Comma separated',
    },
    viewFilterTypeLabels: {
        isAssociatedCase: 'Case association',
        caseStatus: 'Case status',
        creditorId: 'Creditor',
        creditorState: 'Creditor state',
        interactionDirection: 'Interaction direction',
        interactionType: 'Interaction type',
        caseVoucherState: 'Voucher state',
        caseVoucherSource: 'Voucher source',
        caseVoucherCurrency: 'Voucher currency',
        caseVoucherType: 'Voucher type',
        pausedWithUpdates: 'Paused update',
        historicallyPausedUpdates: 'Historically paused update',
        creditorCreatedAt: 'Creditor created',
        updatePausedAt: 'Update paused at',
        updateContinuedAt: 'Update continued',
        updateRemindedAt: 'Update reminded',
        caseCreatedAt: 'Case created',
        caseVoucherDate: 'Voucher date',
        caseVoucherExpirationDate: 'Voucher expiration date',
        caseVoucherIrrecoverableDate: 'Voucher irrecoverable date',
        caseVoucherCreatedAt: 'Voucher created',
        satisfactionCreatedAt: 'Satisfaction created',
        interactionCreatedAt: 'Interaction created',
        endReasonId: 'End reason',
        caseGroupId: 'Case group',
        billingModelId: 'Billing model',
        documentType: 'Document type',
        caseWorkflow: 'Case workflow',
        currentCaseWorkflowTask: 'Current case workflow task',
        nextCaseWorkflowTask: 'Next case workflow task',
        caseStatusTime: 'Case status time',
        caseNumbers: 'Case id',
        properties: 'Property',
        caseTags: 'Case tags',
        isCompany: 'Debtor type',
        agentNotice: 'Agent notice type',
        agentProposalState: 'Agent proposal state',
        agentProposalProposedAt: 'Agent proposal date',
        agentProposalDecidedAt: 'Agent proposal decision date',
        agentProposalTool: 'Agent proposal action',
    },
    viewLabels: {
        'cases.id': 'Case id',
        'cases.status': 'Case status',
        'cases.createdAt': 'Case created date',
        'cases.createdBy': 'Case created by',
        'creditors.name': 'Creditor name',
        'creditors.id': 'Creditor id',
        'billingModels.name': 'Billing model',
        'caseGroups.label': 'Case group',
        'workflows.title': 'Workflow',
        'caseVouchers.amount': 'Case voucher amount',
        caseVoucherProperties: 'Case voucher properties',
        caseProperties: 'Case properties',
        contactName: 'Contact name',
        'voucherTypes.label': 'Vouchertype',
        caseResponsible: 'Case responsible',
        caseEndReason: 'Case end reason',
        caseUpdates: 'Paused case updates',
        agentProposals: 'Agent proposals',
    },
    interactionCategories: {
        title: 'Interaction Categories',
        createCategory: 'Create category',
        interactionCategory: 'interaction category',
        interactionCategories: 'interaction categories',
        sectionProposed: 'Proposed',
        sectionExisting: 'Existing',
    },
    categoryDiscovery: {
        title: 'Category discovery',
        description: 'Scan recent interactions and suggest new categories. Normally runs automatically at night — use this to trigger it manually.',
        runButton: 'Run discovery now',
        running: 'Starting…',
        started: 'Discovery started',
        skipped: 'A discovery run is already in progress',
        completed: 'Discovery completed',
        error: 'Could not start discovery',
        proposalsTitle: 'Suggested categories',
        proposalsEmpty: 'No suggested categories yet.',
        supportingCount: 'supporting interactions',
        acceptButton: 'Accept',
        rejectButton: 'Reject',
        acceptSuccess: 'Category created and applied to supporting interactions',
        rejectSuccess: 'Proposal rejected',
        settingsTitle: 'Settings',
        settingsEnabled: 'Enable category discovery',
        settingsAutomaticComingSoon: 'When enabled, category discovery runs automatically every night.',
        debugRerunTitle: 'Debug: re-aggregate run',
        debugRerunPlaceholder: 'Run ID',
        debugRerunButton: 'Re-aggregate',
        debugRerunSuccess: 'Re-aggregation finished',
    },
    ai: {
        suggestion: 'AI suggestion',
        qualityScore: 'Quality score',
        safetyScore: 'Safety score',
        manipulationDetected: 'Manipulation detected',
        sensitivityFlags: 'Sensitivity flags',
        reasoning: 'Reasoning',
    },
    autoReply: {
        customInstructions: 'Custom AI Instructions',
        customInstructionsDescription: 'These instructions will be included in all AI-generated responses. Use this to define tone, specific rules, or information that should always be included.',
        customInstructionsPlaceholder: "E.g.: Always refer to our website for payment information. Always use the customer's first name.",
        creditorAISettings: 'Creditor AI Settings',
        creditorAISettingsDescription: 'Custom instructions for AI-generated responses for cases on this creditor.',
        title: 'AI Auto-Reply',
        description: 'Automatically generate replies to incoming emails using AI',
        enabled: 'Enable auto-reply',
        enabledDescription: 'When enabled, AI will generate reply drafts for incoming emails mapped to cases',
        mode: 'Mode',
        modeOutbox: 'Outbox (Review)',
        modeOutboxDescription: 'Generated replies are saved as drafts for manual review before sending',
        modeAutoSend: 'Auto-send',
        modeAutoSendDescription: 'Replies that meet quality thresholds are sent automatically',
        qualityThreshold: 'Quality threshold',
        qualityThresholdDescription: 'Minimum quality score (0-1) required for auto-sending',
        safetyThreshold: 'Safety threshold',
        safetyThresholdDescription: 'Minimum safety score (0-1) required. Below this, replies are blocked',
        sensitivityFlags: 'Sensitivity blocklist',
        sensitivityFlagsDescription: 'Topics that require manual review when detected',
        customFlags: 'Custom sensitivity flags',
        customFlagsDescription: 'Define custom topics that should trigger manual review',
        addCustomFlag: 'Add custom flag',
        flagId: 'Flag ID',
        flagName: 'Name',
        flagDescription: 'Description (what should the AI look for)',
        noCustomFlags: 'No custom flags defined',
        generationModel: 'Generation model',
        judgeModel: 'Judge model',
        usageTitle: 'AI Usage',
        usageSuggestions: 'Suggestions',
        usageCategorizations: 'Categorizations',
        usageAutoReplies: 'Auto-replies',
        usageAgent: 'Agent runs',
        usageLimitReached: 'AI credit allowance exhausted for this month',
        creditsRemaining: 'credits remaining this month',
        creditsUsed: 'credits used this month',
        usageBreakdown: 'Spent on',
        generateSuggestion: 'Generate AI suggestion',
        flags: {
            COURT_LEGAL: 'Court / Legal',
            POLICE: 'Police',
            FINANCIAL_HARDSHIP: 'Financial hardship',
            DISPUTE: 'Dispute',
            THREAT_HOSTILE: 'Threats / Hostile',
            MEDICAL_HEALTH: 'Medical / Health',
        },
        blockedReasons: {
            auto_reply_disabled: 'Auto-reply is disabled',
            manipulation_detected: 'Manipulation detected in incoming message',
            safety_threshold: 'Safety score below threshold',
            blocklist_match: 'Matched sensitivity blocklist',
            custom_flag_match: 'Matched custom sensitivity flag',
            case_reassigned: 'Case was reassigned',
        },
    },
    // https://github.com/cospired/i18n-iso-languages/blob/main/langs/en.json
    languages: {
        aa: 'Afar',
        ab: 'Abkhazian',
        ae: 'Avestan',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amharic',
        an: 'Aragonese',
        ar: 'Arabic',
        as: 'Assamese',
        av: 'Avaric',
        ay: 'Aymara',
        az: 'Azerbaijani',
        ba: 'Bashkir',
        be: 'Belarusian',
        bg: 'Bulgarian',
        bh: 'Bihari languages',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetan',
        br: 'Breton',
        bs: 'Bosnian',
        ca: 'Catalan',
        ce: 'Chechen',
        ch: 'Chamorro',
        co: 'Corsican',
        cr: 'Cree',
        cs: 'Czech',
        cu: 'Church Slavic',
        cv: 'Chuvash',
        cy: 'Welsh',
        da: 'Danish',
        de: 'German',
        dv: 'Maldivian',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Greek (modern)',
        en: 'English',
        eo: 'Esperanto',
        es: 'Spanish',
        et: 'Estonian',
        eu: 'Basque',
        fa: 'Persian',
        ff: 'Fulah',
        fi: 'Finnish',
        fj: 'Fijian',
        fo: 'Faroese',
        fr: 'French',
        fy: 'Western Frisian',
        ga: 'Irish',
        gd: 'Gaelic',
        gl: 'Galician',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Manx',
        ha: 'Hausa',
        he: 'Hebrew (modern)',
        hi: 'Hindi',
        ho: 'Hiri Motu',
        hr: 'Croatian',
        ht: 'Haitian Creole',
        hu: 'Hungarian',
        hy: 'Armenian',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesian',
        ie: 'Interlingue',
        ig: 'Igbo',
        ii: 'Nuosu',
        ik: 'Inupiaq',
        io: 'Ido',
        is: 'Icelandic',
        it: 'Italian',
        iu: 'Inuktitut',
        ja: 'Japanese',
        jv: 'Javanese',
        ka: 'Georgian',
        kg: 'Kongo',
        ki: 'Kikuyu',
        kj: 'Kwanyama',
        kk: 'Kazakh',
        kl: 'Greenlandic',
        km: 'Central Khmer',
        kn: 'Kannada',
        ko: 'Korean',
        kr: 'Kanuri',
        ks: 'Kashmiri',
        ku: 'Kurdish',
        kv: 'Komi',
        kw: 'Cornish',
        ky: 'Kyrgyz',
        la: 'Latin',
        lb: 'Luxembourgish',
        lg: 'Ganda',
        li: 'Limburgish',
        ln: 'Lingala',
        lo: 'Lao',
        lt: 'Lithuanian',
        lu: 'Luba-Katanga',
        lv: 'Latvian',
        mg: 'Malagasy',
        mh: 'Marshallese',
        mi: 'Maori',
        mk: 'Macedonian',
        ml: 'Malayalam',
        mn: 'Mongolian',
        mr: 'Marathi',
        ms: 'Malay',
        mt: 'Maltese',
        my: 'Burmese',
        na: 'Nauru',
        nb: 'Bokmål',
        nd: 'North Ndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Dutch',
        nn: 'Norwegian Nynorsk',
        no: 'Norwegian',
        nr: 'South Ndebele',
        nv: 'Navajo',
        ny: 'Nyanja',
        oc: 'Occitan',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetian',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polish',
        ps: 'Pashto',
        pt: 'Portuguese',
        qu: 'Quechua',
        rm: 'Romansh',
        rn: 'Rundi',
        ro: 'Romanian',
        ru: 'Russian',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardinian',
        sd: 'Sindhi',
        se: 'Northern Sami',
        sg: 'Sango',
        si: 'Sinhalese',
        sk: 'Slovak',
        sl: 'Slovenian',
        sm: 'Samoan',
        sn: 'Shona',
        so: 'Somali',
        sq: 'Albanian',
        sr: 'Serbian',
        ss: 'Swati',
        st: 'Southern Sotho',
        su: 'Sundanese',
        sv: 'Swedish',
        sw: 'Swahili',
        ta: 'Tamil',
        te: 'Telugu',
        tg: 'Tajik',
        th: 'Thai',
        ti: 'Tigrinya',
        tk: 'Turkmen',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonga',
        tr: 'Turkish',
        ts: 'Tsonga',
        tt: 'Tatar',
        tw: 'Twi',
        ty: 'Tahitian',
        ug: 'Uyghur',
        uk: 'Ukrainian',
        ur: 'Urdu',
        uz: 'Uzbek',
        ve: 'Venda',
        vi: 'Vietnamese',
        vo: 'Volapük',
        wa: 'Walloon',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Yiddish',
        yo: 'Yoruba',
        za: 'Zhuang',
        zh: 'Chinese',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Monday',
        1: 'Tuesday',
        2: 'Wednesday',
        3: 'Thursday',
        4: 'Friday',
        5: 'Saturday',
        6: 'Sunday',
    },
    cosmo: {
        [ProviderName.DEBBIE]: {
            title: 'Debbie',
            description: 'Updates Cosmo with data from Debbie',
        },
        [ProviderName.LEGACY]: {
            title: 'Legacy [DO NOT ENABLE]',
            description: 'Migration from legacy cosmo to cosmoV2',
        },
        [ProviderName.MIGRATION]: {
            title: 'Migration [DO NOT ENABLE]',
            description: 'Historical contact data migrated from other systems during imports',
        },
        [ProviderName.AKS]: {
            title: 'Experian Aktiv KreditSikring (AKS)',
            description: "Aktiv KreditSikring (Active Credit Security) provides you with up-to-date and detailed credit information about your customers. The service includes the latest master data, financial key figures, notes, and other essential information that helps you assess a company's financial health.",
        },
        [ProviderName.CVR]: {
            title: 'CVR',
            description: "Get access to official company data directly from the CVR. Includes information on a company's name, address, CVR number, legal form, start date, owners, and other key data.",
        },
        [ProviderName.CPR]: {
            title: 'CPR',
            description: "Get access to the Danish state's official personal identification number registry. Here you can get personal information based on CPR number or name/address search.",
        },
        [ProviderName.TINGBOGEN]: {
            title: 'Tingbogen',
            description: 'Get access to registration information for real estate, vehicles, and other assets. Check ownership details, mortgage deeds, easements, and other encumbrances directly from the digital Land Register.',
        },
        [ProviderName.MAILVALIDATOR]: {
            title: 'Email validation',
            description: 'Debbie Email validation checks if an email address is correct and active. It verifies that the address is written correctly, that the domain exists, and also tries to confirm if the specific email address is active, so you can avoid sending messages to addresses that do not exist.',
        },
        [ProviderName.COURT]: {
            title: 'Court district',
            description: 'Automatically find and assign court district to cases',
        },
        [ProviderName.VONAGE]: {
            title: 'Vonage',
            description: 'Retrieve information about phone numbers, such as their validity, type (mobile or landline), and carrier details.',
        },
        [ProviderName.EJF]: {
            title: 'Ejerfortegnelsen',
            description: 'Access property ownership data from the Danish property ownership registry (Ejerfortegnelsen). Look up ownership details for real estate based on address or building code.',
        },
    },
    endReasonsSettings: {
        customEndReasons: 'Created end reasons',
        systemEndReasons: 'Standard end reasons',
        createEndReason: 'Create end reason',
        label: 'Label',
        category: 'Category',
        labelPlaceholder: 'End reason name',
        categoryPlaceholder: 'Choose category',
        uncategorized: 'Uncategorized',
        editEndReason: 'Edit end reason',
        deleteEndReason: 'Delete end reason',
        deleteEndReasonConfirm: 'Are you sure you want to delete this end reason? This cannot be undone.',
        deleteEndReasonInUse: 'The end reason is used by ended cases and cannot be deleted',
        standardReadOnly: 'Standard end reasons are shared by every tenant and cannot be edited or deleted.',
        endReasonNotFound: 'The end reason could not be found',
        handle: 'Handle',
    },
    voucherTypeSelect: {
        selectBillingVoucherType: 'Select billing voucher type',
        selectCaseVoucherType: 'Select case voucher type',
        selectPaymentVoucherType: 'Select payment voucher type',
        searchVoucherTypes: 'Search voucher types',
        allVoucherTypes: 'All voucher types',
    },
    paymentTypeSelect: {
        selectPaymentType: 'Select payment type',
        searchPaymentTypes: 'Search payment types',
        allPaymentTypes: 'All payment types',
    },
    contacts: {
        contact: 'contact',
        selectContact: 'Select contact',
        selectPayoutContact: 'Select the contact to pay out to',
        searchContacts: 'Search contacts',
        allContacts: 'All contacts',
        createContact: 'Create contact',
        editContact: 'Edit contact',
        deleteContact: 'Delete contact',
        deleteContactConfirm: 'Are you sure you want to delete the contact?',
        notSelectableHere: 'The contact lacks the details required here and was not selected',
        email: 'Email',
        phone: 'Phone',
        registryIdentifier: 'Registry identifier',
        bankAccount: 'Bank details',
    },
    errorEntities: {
        sftpServer: 'SFTP server',
        sftpUser: 'SFTP user',
        endReason: 'end reason',
        update: 'update',
        workflow: 'workflow',
        workflowStage: 'workflow stage',
        creditorLink: 'creditor link',
        ultimateCreditor: 'ultimate creditor',
        interaction: 'interaction',
        procedure: 'procedure',
        tribunalCase: 'tribunal case',
        tribunalJob: 'tribunal job',
        document: 'document',
        paymentPlan: 'payment plan',
        file: 'file',
        creditor: 'creditor',
        billing: 'billing',
        billingCollection: 'billing collection',
        caseVoucher: 'case voucher',
        caseVoucherTable: 'case voucher table',
        fixedDistribution: 'fixed distribution',
        billingModel: 'billing model',
        billingAppendixSetup: 'billing appendix setup',
        customer: 'customer',
        user: 'user',
        settings: 'settings',
        case: 'case',
        party: 'party',
        import: 'import',
        transactionAccount: 'transaction account',
        interactionCategory: 'interaction category',
        view: 'view',
        apiKey: 'API key',
        searchIndex: 'search index',
        merge: 'case merge',
        associateCase: 'case association',
        deposit: 'deposit',
        task: 'task',
        chain: 'workflow',
        contact: 'contact',
        remindDate: 'reminder date',
        changelog: 'changelog',
        referenceId: 'reference ID',
        aiSuggestion: 'AI suggestion',
        attachment: 'attachment',
        preview: 'preview',
        note: 'note',
        rollbackTask: 'task rollback',
        runTask: 'task execution',
        bankAccountDetails: 'bank account details',
        bulkActions: 'bulk action',
        pause: 'pause',
        meetingLocation: 'meeting location',
        meetingDate: 'meeting date',
        satisfaction: 'satisfaction',
        tags: 'tags',
        template: 'template',
        webhook: 'webhook',
        property: 'property',
        updateType: 'update type',
        phone: 'phone number',
        email: 'email address',
        report: 'report',
        caseGroup: 'case group',
        collector: 'collector',
        team: 'team',
        rkiRegistration: 'RKI registration',
        interestCalculation: 'interest calculation',
        integration: 'integration',
        asset: 'asset',
    },
    generalManagementInsights: {
        tabs: {
            portfolio: 'Case portfolio',
            resolutionRate: 'Resolution rate',
            caseHandling: 'Case handling',
            calls: 'Calls',
            communicationsAndWorkflows: 'Communications & workflows',
            expiration: 'Expiration',
            revenue: 'Revenue',
            tribunal: 'Court',
            incomingPayments: 'Incoming payments',
            paymentPlans: 'Payment plans',
        },
        filters: {
            caseGroupsPlaceholder: 'All case groups',
            creditorsPlaceholder: 'All creditors',
            searchPlaceholder: 'Type to search',
        },
        incomingPayments: {
            byMonthHeader: 'Payments per month',
            bySourceHeader: 'Distribution by recipient',
            byStateHeader: 'Distribution by type',
            byPaymentTypeHeader: 'Distribution by payment method',
            countLabel: 'Count',
            amountLabel: 'Amount',
            sourceCollector: 'Received at collector',
            sourceCreditor: 'Received at creditor',
            shareOfAmount: (share) => `${share}% of amount`,
            countWithShare: (count, share) => `${count} payments (${share}%)`,
            stateLabels: {
                [CaseVoucherState.FullPayment]: 'Full payment',
                [CaseVoucherState.PartialPayment]: 'Partial payment',
                [CaseVoucherState.Overpayment]: 'Overpayment',
                [CaseVoucherState.PaymentPlanEntryPayment]: 'Payment plan instalment',
                [CaseVoucherState.UnkownPaymentPlanPayment]: 'Unknown instalment',
                [CaseVoucherState.AccordPayment]: 'Accord',
                [CaseVoucherState.PrincipalPayment]: 'Principal payment',
            },
            paymentTypeUnknown: 'Unknown',
            columnPaymentType: 'Payment method',
            columnCount: 'Count',
            columnCountShare: 'Share of count',
            columnAmount: 'Amount',
            columnAmountShare: 'Share of amount',
            currencyLabel: 'Currency',
            noData: 'No data',
        },
        common: {
            incoming: 'Incoming',
            outgoing: 'Outgoing',
            others: 'Others',
            noCaseGroup: 'No case group',
            noData: 'No data',
            creditor: 'Creditor',
            caseGroup: 'Case group',
            updateType: 'Task type',
            user: 'User',
            tag: 'Tag',
            count: 'Count',
            total: 'Total',
            payment: 'Payment',
            paymentPlan: 'Payment plan',
            revenue: 'Revenue',
            open: 'Open',
            oldest: 'Oldest',
            over7Days: 'Over 7d',
            over30Days: 'Over 30d',
            medianAge: 'Median age',
            daysValue: (days) => `${days} days`,
            xOfY: (a, b) => `${a} of ${b}`,
        },
        portfolio: {
            createdAndEndedCasesPerMonth: 'Cases created and ended per month',
            createdCasesPerCreditor: 'Cases created per creditor',
            activeCasesPerMonth: 'Active cases per month',
            submittedAndImposedPerMonth: 'Submitted and imposed per month',
            ageDistributionOfActiveCases: 'Age distribution of active cases',
            top10CreditorsByOutstanding: 'Top 10 creditors by total outstanding',
            createdCases: 'Created cases',
            activeCases: 'Active cases',
            imposedByCreditor: 'Imposed by creditor',
            imposedByCollector: 'Imposed by collector',
            compositionFootnote: 'Vouchers are split by who registered them — the creditor (principal, invoices, reminder fees) or the collector (interest, costs, court costs, fees added during collection).',
            cases: 'Cases',
            balance: 'Balance',
            columnCaseCount: 'Cases',
            columnTotalOutstanding: 'Total outstanding',
        },
        caseHandling: {
            allCaseGroups: 'All case groups',
            allCreditors: 'All creditors',
            allUpdateTypes: 'All task types',
            allResponsibles: 'All responsibles',
            unassignedOption: 'Unassigned',
            teamsGroup: 'Teams',
            usersGroup: 'Users',
            behindPerUser: 'Behind per user',
            behindPerUserDescription: 'Open tasks per user - includes unassigned tasks so ownership gaps surface.',
            behindPerTeam: 'Behind per team',
            behindPerTeamDescription: 'Open tasks per team - to see which teams are falling behind.',
            noOpenTasksByUser: 'No open tasks per user',
            noOpenTasksByTeam: 'No open tasks per team',
            unknownUser: 'Unknown user',
            unknownTeam: 'Unknown team',
            user: 'User',
            currentTaskBacklog: 'Current task backlog',
            timeSpentPerUpdateType: 'Time spent per task type',
            avgTimeOnTaskList: (label) => (label ?? '')
                ? `Avg. time on task list - ${label}`
                : 'Avg. time on task list',
            lessThanOneDay: '< 1d',
            taskBacklogDescription: 'Shows the tasks currently on the task list. Use it to see what the team is behind on, and which task types need prioritization.',
            totalOpenTasks: 'Total open tasks',
            oldestLabel: (days) => `Oldest: ${days}`,
            overDeadline: 'Past deadline',
            percentOfTasksWithDeadline: (percent) => `${percent}% of tasks with deadline`,
            noDeadlinesConfigured: 'No deadlines configured',
            olderThan7Days: 'Older than 7 days',
            percentOfBacklog: (percent) => `${percent}% of backlog`,
            olderThan30Days: 'Older than 30 days',
            unassigned: 'Unassigned',
            ageDistribution: 'Age distribution',
            ageDistributionDescription: 'How long have the open tasks been on the task list? The bars on the right should be low — otherwise tasks are starting to pile up.',
            quantity: 'Count',
            prioritizationPerUpdateType: 'Prioritization per task type',
            prioritizationDescription: 'Sorted by number of tasks past deadline. Task types without a deadline configured fall to the bottom — set a deadline on the task type to include it in the prioritization.',
            noTasksOnList: 'There are no tasks on the task list.',
            behindPerCreditor: 'Behind per creditor',
            behindPerCreditorDescription: 'Sorted by number of tasks older than 7 days. Use it to see which creditors currently need extra attention.',
            noOpenTasksByCreditor: 'No open tasks by creditor.',
            behindPerCaseGroup: 'Behind per case group',
            behindPerCaseGroupDescription: 'Which case groups have the largest task buildup, and where are tasks waiting the longest?',
            noOpenTasksByCaseGroup: 'No open tasks by case group.',
            hoursPerUpdateType: 'Hours per task type',
            timeTrackingDescription: 'Time tracking is recorded automatically on a task when a task type is selected from the task list. The clock starts when entering a case and stops when leaving the case or marking the task as resolved.',
            average: 'Average',
            median: 'Median',
            taskCount: 'Task count',
            taskQueueDurationDescription: 'Shows on average how long tasks have been on the task list — measured from when they were created until they were continued.',
            columnAvgPerTask: 'Avg. per task',
            columnResolvedTasksCount: 'Resolved tasks',
            totalTimeSpent: 'Total time spent',
            weekdays: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat',
            },
            onParWithTeam: 'On par with the team',
            comparedToTeam: (signedPct) => `${signedPct} vs. team`,
            resolvedCount: 'Resolved count',
            percentile25: '25th percentile',
            percentile75: '75th percentile',
            fastest: 'Fastest',
            slowest: 'Slowest',
            timeSpentDistribution: 'Time spent distribution',
            timeSpentDistributionDescription: "How the user's tasks are distributed over time — compared to the team's distribution. If the user is to the right of the team, they generally take longer per task.",
            team: 'Team',
            efficiencyPerWeekday: 'Efficiency per weekday',
            efficiencyPerWeekdayDescription: "Average task time per weekday — the user's own time (dark) vs. the team's average (light). The bars also show how many tasks the user has resolved on each day.",
            userAvg: 'User avg.',
            teamAvg: 'Team avg.',
            tasks: 'Tasks',
            minutesSuffix: ' min',
        },
        calls: {
            overviewSectionHeader: 'Calls and revenue in the period',
            callsPerMonthHeader: 'Calls per month',
            creditorReachHeader: 'Creditors — how easily do we reach the debtors?',
            outgoingTagsHeader: 'Outgoing calls — tags and success rate',
            incomingTagsHeader: 'Incoming calls — tags and success rate',
            caseworkerPerformanceHeader: 'Caseworkers — success rate',
            shareOfCalls: (share) => `${share}% of calls`,
            stat: {
                totalCalls: 'Total calls',
                totalCallsInfo: 'The total number of call interactions registered on cases in the selected period.',
                incomingInfo: 'Number of calls where a debtor (or someone else) called in.',
                outgoingInfo: 'Number of calls made by caseworkers.',
                outgoingAnswered: 'Outgoing answered',
                outgoingAnsweredInfo: "Outgoing calls not tagged with 'No answer'. The share is shown relative to all outgoing.",
                outgoingNoAnswer: 'Outgoing no answer',
                outgoingNoAnswerInfo: "Outgoing calls where the caseworker tagged the call with 'No answer'. The share is shown relative to all outgoing.",
                withPayment: 'With payment',
                withPaymentInfo: 'Number of calls followed by a payment on the same case within 7 days.',
                withNewPaymentPlan: 'With new payment plan',
                withNewPaymentPlanInfo: 'Number of calls followed by a created payment plan on the same case within 7 days.',
                collectionCommission: 'Collection commission',
                collectionCommissionInfo: 'Sum of collection commission (billing vouchers) booked within 7 days after a call in the period.',
                otherFees: 'Other fees',
                otherFeesInfo: 'Sum of other fees (billing vouchers) booked within 7 days after a call in the period.',
                totalRevenue: 'Total revenue',
                totalRevenueInfo: "Total revenue (collection commission + other fees) booked within 7 days after a call in the period. 'Per call' is the average distributed across all calls.",
                perCall: (amount) => `${amount} per call`,
            },
            emptyTags: 'No tags registered in the period.',
            unknownUser: 'Unknown user',
            emptyCaseworkers: (minCalls) => `No caseworkers with at least ${minCalls} calls in the period.`,
            caseworkerHelp: (minCalls) => `Only caseworkers with at least ${minCalls} registered calls in the period are shown. The success rate measures the share of the caseworker's calls followed by a payment or a created payment plan on the same case within 7 days.`,
            emptyCreditors: (minCalls) => `No creditors with at least ${minCalls} calls in the period.`,
            creditorReachHelpPrefix: 'Sort by ',
            creditorReachHelpAnswered: 'Answered',
            creditorReachHelpMiddle: ' to see whose debtors are easiest to reach. Only outgoing calls count toward the answer rate — calls without the ',
            creditorReachHelpNoAnswer: "'No answer'",
            creditorReachHelpMin: (minCalls) => ` tag count as answered. Only creditors with at least ${minCalls} calls in the period are shown.`,
            answered: 'Answered',
            caseworker: 'Caseworker',
        },
        communications: {
            sectionHeader: 'Communications in the period',
            templatesHeader: 'Templates — success rate and derived revenue',
            byTypeHeader: 'Interactions per type and direction',
            letterReturnsHeader: 'Returned letters — count, response time and reason',
            dataQualityHeader: 'Contact data quality per creditor and case group',
            futureWorkflowsHeader: 'Workflows — upcoming tasks per task type',
            shareOfAll: (percent) => `${percent} of all`,
            shareOfSent: (percent) => `${percent} of sent`,
            stat: {
                totalInteractions: 'Total interactions',
                totalInteractionsInfo: 'The total number of communication interactions (all types, all directions) in the period.',
                outgoingInfo: 'Number of outgoing interactions in the period.',
                incomingInfo: 'Number of incoming interactions in the period.',
                withPaymentPlan: 'With new payment plan',
                withPaymentPlanInfo: 'Interactions followed by a new payment plan on the same case within 7 days.',
                withPayment: 'With payment',
                withPaymentInfo: 'Interactions followed by a payment on the same case within 7 days.',
                linkClicks: 'Link clicks',
                linkClicksInfo: 'Total number of link clicks registered on interactions in the period.',
                collectionCommission: 'Collection commission',
                collectionCommissionInfo: 'Sum of collection commission on cases that received an interaction in the period, posted within 7 days.',
                otherFees: 'Other fees',
                otherFeesInfo: 'Sum of other fees (FEE category) on cases that received an interaction in the period, posted within 7 days.',
                totalRevenue: 'Total revenue',
                totalRevenueInfo: 'Revenue attributed to the most recent outgoing template message before each fee, within 7 days. Each fee is counted once.',
                lettersSent: 'Letters sent',
                lettersSentInfo: 'Number of letters sent in the period.',
                lettersReturned: 'Letters returned',
                lettersReturnedInfo: "Number of letters where PostNord registered a 'Failed' event in the period.",
                averageReturnTime: 'Average response time',
                averageReturnTimeInfo: 'Average number of days from when the letter is sent until the return event is registered.',
            },
            emptyTemplates: 'No template-based interactions in the period.',
            emptyInteractions: 'No interactions in the period.',
            emptyReturns: 'No returned letters registered in the period.',
            emptyCases: 'No cases found.',
            emptyWorkflowTasks: 'No upcoming workflow tasks found.',
            templatesHelp: 'Each row is one template used on outgoing interactions in the period. Payment plan % and Payment % count how many of the sent interactions were followed within 7 days by — respectively — a new payment plan or a deposit payment on the same case. Link clicks are click events registered on the interactions. Revenue is the sum of collection commission and other fees posted on the same case within 7 days after sending.',
            dataQualityHelp: 'The table shows how good the contact data is per creditor and case group. Low return rates and low failure rates mean we reach the debtors via the selected channels. Numbers in parentheses are the absolute number of delivery failures.',
            workflowHelp: 'Volume of upcoming workflow tasks per task type. Based on the case next planned task (cases.workflow_next_task_id). Filters above are not applied — the table shows the current backlog.',
            daysValue: (days) => `${days} days`,
            col: {
                template: 'Template',
                type: 'Type',
                sent: 'Sent',
                linkClicks: 'Link clicks',
                returnReason: 'Return reason',
                shareOfSent: 'Share of sent',
                averageResponseTime: 'Response time (avg.)',
                lettersReturned: 'Letters returned',
                emailsFailed: 'Emails failed',
                eboksFailed: 'e-Boks failed',
                cases: 'Cases',
                overdue: 'Overdue',
                next7Days: 'Next 7 days',
                days8To30: '8-30 days',
                later: 'Later',
            },
        },
        expiration: {
            headerExpiration: 'Expiration',
            headerSuspension: 'Ability to suspend expiration',
            clear: 'Clear',
            loadingForMonth: (month) => `Loading distribution for ${month}…`,
            distributionPerCreditor: (month) => `Distribution per creditor – ${month}`,
            distributionPerCaseGroup: (month) => `Distribution per case group – ${month}`,
        },
        revenue: {
            settledRevenuePerMonth: 'Settled revenue per month',
            collectionCommissionByCasePostingType: 'Collection commission by case posting type',
            otherFeesByFeeType: 'Other fees by fee type',
            billingSpeedPerCreditor: 'Billing speed per creditor',
            workInProgressNotYetBilled: 'Work in progress (not yet billed)',
            revenuePerCreditor: 'Revenue per creditor',
            revenuePerCaseGroup: 'Revenue per case group',
            collectionCommission: 'Collection commission',
            fees: 'Fees',
            otherFees: 'Other fees',
            avgDaysToBilling: 'Avg. days to billing',
            billed: 'Billed',
            unbilled: 'Unbilled',
            totalOtherFees: 'Total other fees',
            totalCollectionCommission: 'Total collection commission',
            name: 'Name',
        },
        tribunal: {
            paymentOrderOutcomes: 'Payment order outcomes',
            casesFiledAndBailiffMeetingsPerMonth: 'Court cases filed and bailiff meetings per month',
            courtProcessingTime: 'Court processing time (payment orders)',
            percentOfCases: (share) => `${share}% of cases`,
            stat: {
                totalFiled: 'Total filed',
                totalFiledInfo: 'The number of unique cases where a payment order has been created or resubmitted in the selected period. The date is the time the payment order was filed.',
                paidAfterFiling: 'Paid after filing',
                paidAfterFilingInfo: "The number of cases ended as paid within 3 months after the most recent court module action. Cases are counted by the date of the original payment order — not the payment date. Requires the case to be ended with reason 'Paid' in Debbie.",
                paidBetweenFirstAndSecondEndorsement: 'Paid between 1st and 2nd endorsement',
                paidBetweenFirstAndSecondEndorsementInfo: 'The number of unique cases where a payment was registered between the 1st endorsement and up to 5 days after the 2nd endorsement (to catch payments registered later). The case does not need to be ended as paid. Cases are counted by the date of the original payment order.',
                paidBetweenSecondEndorsementAndBailiffMeeting: 'Paid between 2nd endorsement and bailiff meeting',
                paidBetweenSecondEndorsementAndBailiffMeetingInfo: 'The number of unique cases where a payment was registered between the 2nd endorsement and up to 5 days after the bailiff meeting (to catch payments registered later). The case does not need to be ended as paid. Cases are counted by the date of the original payment order. Requires the bailiff meeting to be registered in Debbie.',
                distraintsPerformed: 'Distraints performed',
                distraintsPerformedInfo: 'The number of unique cases where a distraint event has been registered. Cases are counted by the date of the original payment order — not the date of the distraint. Note: Distraints not registered in Debbie are not included.',
                paymentPlansCreatedAfterBailiffMeeting: 'Payment plans created after bailiff meeting',
                paymentPlansCreatedAfterBailiffMeetingInfo: 'The number of payment plans created within 1 month after a bailiff meeting. Cases are counted by the date of the original payment order — not the date of the payment plan. All created payment plans count, including those later cancelled or defaulted. Requires the bailiff meeting to be registered in Debbie.',
                activePaymentPlansNow: 'Active payment plans now',
                activePaymentPlansNowInfo: 'Of the payment plans created after a bailiff meeting, how many are currently active.',
                finishedPaymentPlans: 'Finished payment plans',
                finishedPaymentPlansInfo: 'Of the payment plans created after a bailiff meeting, how many have been completed (fully paid off).',
                objections: 'Objections',
                objectionsInfo: 'The number of bailiff cases closed with an objection after the 1st endorsement. Cases are counted by the date of the original payment order — not the date of the objection. Note: Objections not registered in Debbie are not included.',
                insolvencies: 'Insolvencies',
                insolvenciesInfo: 'The number of unique cases where insolvency has been registered. Cases are counted by the date of the original payment order — not the date of the insolvency registration. Note: Insolvencies not registered in Debbie are not included.',
            },
            bailiffMeetings: 'Bailiff meetings',
            courtSpeedBenchmarkDescription: 'Total time from case start to each step in the simplified process. The number below shows the time from the previous step.',
            court: 'Court',
            firstEndorsement: '1st endorsement',
            secondEndorsement: '2nd endorsement',
            invitation: 'Invitation',
            bailiffMeeting: 'Bailiff meeting',
            casesByCourt: 'Cases filed by court',
            casesByCourtDescription: 'The number of original payment orders this tenant has filed at each court in the selected period, and how many were returned by the court requiring a revised version to be resubmitted.',
            casesByCourtCount: 'Cases filed',
            casesByCourtShare: 'Share of total',
            casesByCourtRevised: 'Returned for revision',
            casesByCourtRevisedShare: 'Revision rate',
        },
    },
    agentToolLabels: {
        [ToolName.SearchTools]: 'Search tools',
        [ToolName.GetTool]: 'Inspect tool',
        [ToolName.ListPendingProposals]: 'List pending proposals',
        [ToolName.EscalateToHuman]: 'Escalate to human',
        [ToolName.ReportOutcome]: 'Report outcome',
        [ToolName.GetCustomer]: 'Get debtor info',
        [ToolName.GetCreditor]: 'Get creditor info',
        [ToolName.GetWorkflow]: 'Get workflow info',
        [ToolName.GetCurrentPaymentPlan]: 'Get current payment plan',
        [ToolName.SearchCaseHistory]: 'Search case history',
        [ToolName.SearchContactPersons]: 'Search contact persons',
        [ToolName.SearchProperties]: 'Search case properties',
        [ToolName.SearchInteractions]: 'Search interactions',
        [ToolName.GetInteraction]: 'Get interaction',
        [ToolName.SearchVouchers]: 'Search vouchers',
        [ToolName.GetVoucher]: 'Get voucher',
        [ToolName.SearchTemplates]: 'Search templates',
        [ToolName.GetTemplate]: 'Get template',
        [ToolName.SearchMentions]: 'Search mentions',
        [ToolName.SearchUpdateTypes]: 'Search update types',
        [ToolName.GetUpdateType]: 'Get update type',
        [ToolName.SearchUpdates]: 'Search applied updates',
        [ToolName.GetUpdate]: 'Get update',
        [ToolName.SearchDocuments]: 'Search documents',
        [ToolName.GetDocument]: 'Get document',
        [ToolName.GetFile]: 'Read file',
        [ToolName.SearchPaymentPlans]: 'Search payment plans',
        [ToolName.GetPaymentPlan]: 'Get payment plan',
        [ToolName.SearchTribunalCases]: 'Search tribunal cases',
        [ToolName.GetTribunalCase]: 'Get tribunal case',
        [ToolName.CreateInteraction]: 'Send a message',
        [ToolName.CreateCreditorMessage]: 'Send creditor message',
        [ToolName.CreatePaymentPlan]: 'Create payment plan',
        [ToolName.CreateUpdate]: 'Apply an update',
        [ToolName.EndCase]: 'End case',
    },
    agentToolDescriptions: {
        [ToolName.SearchTools]: 'Find which tools are available to the agent. Call with no filters to see categories.',
        [ToolName.GetTool]: 'Look up the exact input shape for a specific tool and expose it for invocation.',
        [ToolName.ListPendingProposals]: 'See proposals on this case that are still awaiting a decision.',
        [ToolName.EscalateToHuman]: 'End the run and create a notice for a concrete action or decision that needs human attention.',
        [ToolName.ReportOutcome]: 'End the run with a structured outcome when no action is taken.',
        [ToolName.GetCustomer]: 'Read basic information about the debtor on this case.',
        [ToolName.GetCreditor]: 'Read information about the creditor on this case.',
        [ToolName.GetWorkflow]: "Read the case's workflow stage and what the workflow plans to do next.",
        [ToolName.GetCurrentPaymentPlan]: 'Read the currently active payment plan, if any.',
        [ToolName.SearchCaseHistory]: 'Browse the chronological timeline of activity on this case.',
        [ToolName.SearchContactPersons]: 'List alternative contact persons (lawyers, guardians, employers, etc.) attached to this case.',
        [ToolName.SearchProperties]: 'List tenant-configured custom properties on this case.',
        [ToolName.SearchInteractions]: 'List interactions (emails, SMS, letters, notes) on this case.',
        [ToolName.GetInteraction]: 'Read the full body of a specific interaction.',
        [ToolName.SearchVouchers]: 'List vouchers (principal, interest, fees, payments) on this case.',
        [ToolName.GetVoucher]: 'Read full details of a specific voucher including remaining balance.',
        [ToolName.SearchTemplates]: 'Browse interaction templates configured for this tenant.',
        [ToolName.GetTemplate]: 'Read the full body of a specific template.',
        [ToolName.SearchMentions]: 'Search the catalog of {{mention}} placeholders used in interaction bodies.',
        [ToolName.SearchUpdateTypes]: 'Search the update types available on this case (pauses, handovers, status changes).',
        [ToolName.GetUpdateType]: 'Read full details of an update type including the procedure it triggers.',
        [ToolName.SearchUpdates]: 'List updates that have been applied to this case.',
        [ToolName.GetUpdate]: 'Read details of a specific update applied to the case.',
        [ToolName.SearchDocuments]: 'List documents attached to this case (foundations, judgements, settlements).',
        [ToolName.GetDocument]: "Read a document's domain metadata (type, signed/foundation status, etc.). Call get_file with the fileId for the document's text content.",
        [ToolName.GetFile]: 'Read the extracted text of a file by id, from anywhere it is attached.',
        [ToolName.SearchPaymentPlans]: 'List payment plans on this case, including cancelled and completed ones.',
        [ToolName.GetPaymentPlan]: 'Read full details of a specific payment plan.',
        [ToolName.SearchTribunalCases]: 'List tribunal (court / bailiff) cases linked to this debt case.',
        [ToolName.GetTribunalCase]: 'Read full details of a tribunal case including events and notes.',
        [ToolName.CreateInteraction]: 'Send a message to the debtor.',
        [ToolName.CreateCreditorMessage]: 'Send a message to the creditor through the creditor portal.',
        [ToolName.CreatePaymentPlan]: 'Create a payment plan with installments.',
        [ToolName.CreateUpdate]: 'Apply an update to the case (log an event, pause, hand over).',
        [ToolName.EndCase]: 'End the case with a specific reason.',
    },
    agentProposals: {
        title: 'Agent proposals',
        empty: 'No agent proposals on this case.',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        failed: 'Failed',
        stale: 'Stale',
        superseded: 'Superseded',
        dismissed: 'Dismissed',
        executing: 'Executing',
        approve: 'Approve',
        reject: 'Reject',
        retry: 'Retry',
        dismiss: 'Dismiss',
        invalidEdits: 'Invalid changes',
        reasoning: 'Reasoning',
        proposedInput: 'Proposal',
        appliedInput: 'Applied input',
        finalVersion: 'Final version',
        agentVersion: "Agent's proposal",
        decidedBy: 'Decided by',
        proposedAt: 'Proposed',
        snapshot: 'Snapshot at proposal',
        errorMessage: 'Error',
        output: 'Result',
    },
    categoryInsights: {
        tabTitle: 'Categories',
        category: 'Category',
        allCategories: 'All categories',
        interactions: 'Interactions',
        uncategorized: 'Not categorized',
        addedByCaseworkers: 'Added by caseworkers',
        removedByCaseworkers: 'Removed by caseworkers',
        noInteractions: 'No categorized interactions in this period.',
        removed: 'Removed by a caseworker',
        addedByAi: 'Added by the AI',
    },
    agentPerformance: {
        tabTitle: 'Agent proposals',
        action: 'Action',
        allActions: 'All actions',
        taskPrompt: 'Task prompt',
        task: 'Task',
        allTaskPrompts: 'All task prompts',
        startedManually: 'Started manually',
        unknownUpdateType: 'Unknown update type',
        accepted: 'Accepted',
        proposals: 'Proposals',
        decisionTime: 'Decision time',
        escalated: 'Escalated to caseworker',
        oldestPending: 'Oldest: {age}',
        comparedToPrevious: 'Compared with the previous period',
        percentagePoints: '{points} pp',
        duration: {
            minutes: '{minutes} min',
            hours: '{hours} h',
            days: '{days} days',
        },
        decisions: {
            [ProposalDecision.Pending]: 'Pending',
            [ProposalDecision.ApprovedAsIs]: 'Approved as is',
            [ProposalDecision.Edited]: 'Edited',
            [ProposalDecision.Rejected]: 'Rejected',
            [ProposalDecision.Failed]: 'Failed',
            [ProposalDecision.Closed]: 'Closed',
        },
        allDecisions: 'All',
        noProposals: 'No proposals in this period.',
    },
    agentNotices: {
        humanEscalation: 'Caseworker attention requested',
        systemFailure: 'Agent could not complete the review',
        attention: 'Attention',
        filterHumanEscalation: 'Caseworker escalation',
        filterSystemFailure: 'System failure',
    },
    agentSettings: {
        tabTitle: 'Agent',
        title: 'Agent tool policies',
        description: 'Control which heavy actions the agent may propose. Every proposed action requires caseworker approval before it executes.',
        heavyOnlyNote: 'Only heavy actions are configurable. Read-only tools (search and get) are always available to the agent.',
        policies: {
            [ToolPolicy.Disabled]: 'Disabled',
            [ToolPolicy.RequireApproval]: 'Require approval',
            [ToolPolicy.AutoRun]: 'Auto-run',
        },
        policyDescriptions: {
            [ToolPolicy.Disabled]: 'The agent cannot propose this action at all.',
            [ToolPolicy.RequireApproval]: 'The agent may propose; a caseworker reviews and decides.',
            [ToolPolicy.AutoRun]: 'The agent may propose; the action runs automatically without review.',
        },
        default: 'Default',
        saved: 'Policy updated',
        saveError: 'Could not update policy',
    },
    agentProposalBodies: {
        reply: 'Reply',
        replyingTo: 'Replying to',
        numberOfInstallments: 'Number of installments',
        upfrontDate: 'Upfront date',
        addScheduledChange: 'Add change',
        unknownUpdateType: 'Unknown update type',
        procedureTasks: 'Tasks executed when this update is applied',
        outstandingBalance: 'Outstanding balance',
        endCaseConsequences: 'When the case is ended',
        endCaseConsequencePlans: 'Active payment plans are cancelled',
        endCaseConsequenceRki: 'RKI registrations are removed',
        endCaseConsequenceProposals: 'Other pending agent proposals are superseded',
        endCaseConsequenceFinal: 'A closed case can no longer receive messages or payment plans',
        startDateInPast: 'Start date must not be in the past',
        message: 'Message',
        letterBody: 'Letter body',
        letterWrapperNote: 'The tenant template adds the header, address block and signature at send time.',
        oneAttachment: '1 attachment',
        attachments: 'attachments',
        startDate: 'Start date',
        installmentAmount: 'Installment amount',
        upfront: 'Upfront',
        scheduledChanges: 'Scheduled amount changes',
        fromDate: 'From',
        updateText: 'Update text',
        updateType: 'Update type',
        creditorMessage: 'Creditor message',
        continuation: 'Update state after application',
        continueNow: 'Completed immediately',
        leavePaused: 'Keep as active pause',
        keepScheduledDate: 'Keep scheduled continuation',
        noDetails: 'No further details.',
        to: 'to',
        recipientDebtor: 'Debtor',
        recipientCreditor: 'Creditor',
        startsOn: 'Starts',
        installments: 'installments',
        upfrontInline: 'upfront on',
        summaryEnds: 'Ends',
        summaryTotal: 'Total',
        summaryPerInstallment: 'per installment',
    },
    tribunalSettings: {
        box4CaseStatementTemplate: 'Box 4 - Template for case presentation',
        caseStatementTemplate: 'Template for case presentation',
        submission: 'Submission',
        ignorePaymentsWarning: 'Ignore warning that the case contains payments',
        box1Creditor: 'Box 1 - Creditor (and representative, if any)',
        creditor: 'Creditor',
        representative: 'Representative, if any',
        contactInformation: 'Contact information',
        noPhoneMeetingBelow: 'Do not request a phone meeting if the total claim is below (DKK):',
        representativePhone: "Representative's phone number",
        representativeEmail: "Representative's email",
        representativeRegistrationNumber: "Representative's registration no.",
        representativeAccountNumber: "Representative's account no.",
        box2Debtor: 'Box 2 - Debtor',
        includeCprInPaymentDemand: 'Include CPR number in the payment demand',
        box4ClaimSize: 'Box 4 - Size of the claim',
        excludeVoucherTypesDescription: 'Exclude selected case voucher types when submitting the payment demand. For example collection costs.',
        selectVoucherTypesToSubtract: 'Select case voucher types to subtract at submission',
        box5CaseStatement: 'Box 5 - Case presentation',
        box9SubmittedBy: "Box 9 - Submitted by (creditor or creditor's representative)",
        courtCosts: 'Court costs',
        selectCourtCostVoucherType: 'Select the case voucher type for court costs',
        vouchersToOverride: 'Vouchers to override (removed from the case)',
        selectVouchers: 'Select vouchers',
        vouchersToSubtractFromCourtCosts: 'Vouchers to offset against the court costs',
        keepHigherExtrajudicialCosts: 'Keep extrajudicial costs if they are higher than the judicial costs',
        interestActSection8a: 'Interest Act § 8 a',
        interestActSection8aDescription: 'Court costs awarded by judgment or other court ruling in a civil case accrue interest from the expiry of the enforcement deadline at the rate set out in § 5 (1) and (2).',
        selectInterestVoucherTypesAfterVerdict: 'Select voucher types that accrue interest 14 days after the verdict',
        insolvencyDeclaration: 'Insolvency declaration',
        useCustomInsolvencyUpdateType: 'Use custom insolvency task type',
        defaultEmailTemplate: 'Default email template',
        defaultEmailAttachmentTemplate: 'Default template for the email attachment',
        editTemplate: 'Edit template',
    },
    cosmoSettings: {
        header: 'Cosmo settings',
        warningPrefix: 'NOTE:',
        warning: 'Do not make changes on this page without consulting Debbie support.',
        identityProviderDescription: 'Select which identity providers to use for persons and companies respectively. An identity provider is the data provider used to uniquely identify a person or company',
        personIdentityProvider: 'Person identity provider',
        selectPersonIdentityProvider: 'Select person identity provider',
        companyIdentityProvider: 'Company identity provider',
        selectCompanyIdentityProvider: 'Select company identity provider',
        subscriptionStrategyDescription: 'Select when users should be subscribed to Cosmo',
        strategyOnOpenCases: 'Subscribe users on all active cases and unsubscribe when the cases end',
        strategyOnAllCustomers: '[not implemented] Subscribe users on customer creation and unsubscribe on deletion',
        strategyManual: 'Manual subscription and unsubscription of users. No automatic subscription/unsubscription.',
        providers: 'Providers',
        disabledProviders: 'Disabled providers',
        notActivated: 'Not activated',
        settings: 'Settings',
        deactivate: 'Deactivate',
        activate: 'Activate',
        identityProvider: 'Identity provider',
        persons: 'Persons',
        companies: 'Companies',
    },
    dnsSetup: {
        checkDns: 'Check DNS',
        title: 'DNS setup',
        allRecordsConfirmed: 'All records have been confirmed',
        domainVerification: 'Domain verification',
        email: 'Email',
        outboundEmails: 'Outbound emails (DKIM & SPF)',
        spfExistingPrefix: 'If an SPF record already exists, ensure that you add',
        spfExistingSuffix: 'to the existing record.',
        inboundEmails: 'Inbound emails',
        inboundForwarded: 'All inbound mails shall be automatically forwarded.',
        sites: 'Sites',
        debtorWebApp: 'Debtor web app',
        creditorWebApp: 'Creditor web app',
        verified: 'Verified',
        type: 'Type',
        hostname: 'Hostname',
        value: 'Value',
        currentValue: 'Current value',
    },
    createTenant: {
        tenantType: 'Tenant type',
        agency: 'Agency',
        agencyDescription: 'Debt collection agency that collects on behalf of external clients. Money collected is distributed to the creditors, and features such as tribunal/court proceedings are enabled.',
        accountsReceivable: 'Accounts receivable',
        accountsReceivableDescription: 'Company that collects its own receivables in-house. The tenant itself is the sole creditor and uses a simplified accounts-receivable bookkeeping model.',
        companyName: 'Name of company',
        vatNumber: 'VAT number (DK12345678)',
        billingAddress: 'Billing address',
        country: 'Country',
        language: 'Language',
        currency: 'Currency',
        timezone: 'Timezone',
        demoDescription: 'Demo tenant used for sales presentations. These tenants can have mock data and some stats will be fictitious. Sending emails, text messages etc. is mocked and no real data is sent. Data will be sent to the user using the system.',
        sandboxDescription: 'Used for customers that need a sandbox environment. Sending emails, text messages etc. is mocked and no real data is sent. Data will be sent to the user using the system.',
        gettingStartedDescription: 'Tenants post go-live. If configuration, API integration, onboarding etc. is ongoing. Tenant can later on be set as an active tenant. Sending emails, text messages etc. is mocked and no real data is sent. Data will be sent to the user using the system.',
        demoMockData: 'Demo mock data',
        noMockData: '-- No mock data --',
        addFrisbiiPaymentGateway: 'Add Frisbii payment gateway',
        principalType: 'Principal type',
        interestType: 'Interest type',
        noInterest: '-- No interest --',
        quantityCreditors: 'Quantity creditors',
        quantityCasesPerCreditor: 'Quantity cases per creditor',
        privateDebtors: 'Private debtors',
        companyDebtors: 'Company debtors',
        mixed: 'Mixed',
        createTenant: 'Create tenant',
    },
    experianClientNumber: {
        header: 'Submit Experian client number',
        withAksCustomerNumber: 'with AKS customer number:',
        partnershipText: 'has entered into a partnership with the company below. An RKI client number is therefore requested for',
        forFutureRegistrations: 'for future registrations.',
        companyName: 'Company name:',
        address: 'Address:',
        clientNumberRegistered: 'The client number has been registered',
        clientNumberPlaceholder: 'Client number',
        submit: 'Submit',
    },
    satisfaction: {
        backToMyCase: 'Back to my case',
        header: 'Your opinion matters a lot to us',
        intro: 'To provide the best possible service, we would very much like to hear about your experience.',
        whichSmiley: 'Which smiley best describes your experience with the handling of case #',
        optionalComment: 'Optional comment',
        submit: 'Submit',
        thanks: 'Thank you for submitting your feedback',
    },
    webappSettings: {
        title: 'Webapps',
        debtorWeb: 'Debtor portal',
        creditorWeb: 'Creditor portal',
        creditorIntroduction: 'Choose which information creditors can see in their portal.',
        documentsTitle: 'Documents',
        hideDocumentsDescription: 'Hide case documents in the creditor portal. Documents remain available to your caseworkers.',
    },
    lighthouse: {
        cosmo: 'Cosmo',
        modules: 'Modules',
        recalculateTenant: 'Recalculate tenant',
        recalculateTenantDescription: 'Recalculate interest, expiry and billing on all pending and verified cases on the tenant.',
        recalculateTenantConfirm: 'Recalculate all pending and verified cases on this tenant? This can create billing adjustments.',
        recalculate: 'Recalculate',
        recalculation: 'Recalculation',
        recalculationRunsInBackground: 'It runs in the background.',
    },
    debtorWebSettings: {
        introduction: 'Customize the text and self-service options in the portal your debtors use.',
        textsTitle: 'Text and contact',
        textsDescription: 'Use the default text or write your own. The text appears on the debtor’s case.',
        customWelcome: 'Use a custom welcome message',
        welcomeDescription: 'Replaces the introduction at the top of the case.',
        defaultText: 'Default text',
        defaultWelcomeDescription: 'The default introduction shows the debtor’s balance, creditor name and the options available in the portal.',
        showContactInformation: 'Show contact information',
        contactInformationDescription: 'Show the contact section with your email and phone number on the case.',
        customContact: 'Use a custom contact message',
        contactDescription: 'This text appears alongside your contact information.',
        paymentsTitle: 'Payments and instalments',
        allowPartialPayments: 'Allow partial payments',
        partialPaymentsDescription: 'Let debtors pay part of their balance through the payment portal.',
        encouragePaymentPlan: 'Show payment plan suggestions',
        paymentPlanDescription: 'Suggest requesting a payment plan when this is available for the case.',
        detailsTitle: 'Details and case number',
        allowSelfOverwrite: 'Allow changes without approval',
        selfOverwriteDescription: 'Let debtors overwrite their own details without a caseworker’s approval.',
        preferOriginalJournalNumber: 'Use the original case number',
        journalNumberDescription: 'Show the case number from your previous system. If unavailable, the Debbie case number is used.',
        unsavedChanges: 'Unsaved changes',
        saveDescription: 'Changes take effect when you save.',
        saveChanges: 'Save changes',
        emptyText: 'Enter your custom text or turn off customization to use the default.',
        leaveWithoutSaving: 'You have unsaved changes. Do you want to leave this page?',
        welcomeText: 'Welcome text',
        contactUsText: 'Contact us text',
        hideContactInformation: 'Hide contact information',
        noPartialPayments: 'No partial payments',
        doNotEncouragePaymentPlan: 'Do not encourage a payment plan',
        useMigratedJournalNumber: 'Use migrated journal number (fallback to Debbie journal number)',
    },
};
//# sourceMappingURL=en.js.map